import { Directive, Input, EventEmitter, HostBinding, Output, Component, forwardRef, ViewChild, ElementRef, NgModule, ViewContainerRef, HostListener, NO_ERRORS_SCHEMA, ContentChild, Renderer2, ViewEncapsulation, Injectable, ContentChildren, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormsModule, NgModel, NG_VALIDATORS, NG_ASYNC_VALIDATORS } from '@angular/forms';
import { DatePickerModule as DatePickerModule$1 } from '@progress/kendo-angular-dateinputs';
import { DateTime, LocaleService, Reflection, TooltipModule, LocalizationModule, PopupModule, Guid, Type, Bool } from '@wke/ucc-angular-alt-common';
import { IntlModule } from '@progress/kendo-angular-intl';
import { IconModule } from '@wke/ucc-icons';
import { CommonModule } from '@angular/common';
import { InputsModule as InputsModule$1 } from '@progress/kendo-angular-inputs';
import { DropDownListModule as DropDownListModule$1, ItemTemplateDirective, DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { filter, debounceTime, takeWhile, map, switchMap, first } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { NavigationService } from '@wke/ucc-angular-alt-navigation';

/**@ignore */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/forms';
import * as ɵngcc2 from '@wke/ucc-angular-alt-common';
import * as ɵngcc3 from '@progress/kendo-angular-dateinputs';
import * as ɵngcc4 from '@angular/common';
import * as ɵngcc5 from '@wke/ucc-icons';
import * as ɵngcc6 from '@progress/kendo-angular-inputs';
import * as ɵngcc7 from '@progress/kendo-angular-dropdowns';
import * as ɵngcc8 from '@wke/ucc-angular-alt-navigation';
import * as ɵngcc9 from '@angular/router';

const _c0 = ["input"];
const _c1 = ["datePicker"];
function TextBoxComponent_ucc_icon_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ucc-icon", 4);
    ɵngcc0.ɵɵlistener("click", function TextBoxComponent_ucc_icon_3_Template_ucc_icon_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.onDeleteContent(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", !ctx_r1.canDisplayIconClass);
} }
const _c2 = ["numericbox"];
const _c3 = ["placeholderLayout"];
const _c4 = ["labelLayout"];
function FloatingLabelComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelement(1, "ucc-icon", 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngwkTooltip", ctx_r1.mandatoryMessage);
} }
function FloatingLabelComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵelement(1, "ucc-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngwkTooltip", ctx_r2.infoMessage);
} }
function FloatingLabelComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelement(1, "ucc-icon", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngwkTooltip", ctx_r4.mandatoryMessage);
} }
function FloatingLabelComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵelement(1, "ucc-icon", 20);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngwkTooltip", ctx_r5.getValidationMessages());
} }
function FloatingLabelComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵelement(1, "ucc-icon", 21);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngwkTooltip", ctx_r6.infoMessage);
} }
const _c5 = ["*"];
const _c6 = ["dropdownlist"];
function DropDownListComponent_ng_template_2_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c7 = function (a0) { return { item: a0 }; };
function DropDownListComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DropDownListComponent_ng_template_2_ng_container_0_Template, 1, 0, "ng-container", 6);
} if (rf & 2) {
    const dataItem_r7 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.selectedItemTemplate || _r3)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c7, ctx_r1.getItem(dataItem_r7)));
} }
function DropDownListComponent_ng_template_3_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DropDownListComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DropDownListComponent_ng_template_3_ng_container_0_Template, 1, 0, "ng-container", 6);
} if (rf & 2) {
    const dataItem_r9 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    const _r5 = ɵngcc0.ɵɵreference(7);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r2.listTemplate || _r5)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c7, ctx_r2.getItem(dataItem_r9)));
} }
function DropDownListComponent_ng_template_4_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r11 = ɵngcc0.ɵɵnextContext().item;
    const ctx_r12 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r11[ctx_r12.displayField], " ");
} }
function DropDownListComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DropDownListComponent_ng_template_4_div_0_Template, 2, 1, "div", 7);
} if (rf & 2) {
    const item_r11 = ctx.item;
    ɵngcc0.ɵɵproperty("ngIf", item_r11);
} }
function DropDownListComponent_ng_template_6_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r14 = ɵngcc0.ɵɵnextContext().item;
    const ctx_r15 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r14[ctx_r15.displayField], " ");
} }
function DropDownListComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DropDownListComponent_ng_template_6_div_0_Template, 2, 1, "div", 7);
} if (rf & 2) {
    const item_r14 = ctx.item;
    ɵngcc0.ɵɵproperty("ngIf", item_r14);
} }
const _c8 = ["textarea"];
const _c9 = ["autocomplete"];
function AutocompleteComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "locale");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "no_data_found"));
} }
const _c10 = ["switch"];
const _c11 = ["upload"];
const _c12 = ["anchor"];
const _c13 = ["popup"];
function FormValidationListComponent_ngwk_popup_0_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 7);
    ɵngcc0.ɵɵlistener("click", function FormValidationListComponent_ngwk_popup_0_button_6_Template_button_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r5); const validation_r3 = restoredCtx.$implicit; const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.onClick(validation_r3); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const validation_r3 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(validation_r3.validationMessage);
} }
function FormValidationListComponent_ngwk_popup_0_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ngwk-popup", 2);
    ɵngcc0.ɵɵlistener("close", function FormValidationListComponent_ngwk_popup_0_Template_ngwk_popup_close_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onListClose(); });
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "locale");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 5);
    ɵngcc0.ɵɵtemplate(6, FormValidationListComponent_ngwk_popup_0_button_6_Template, 2, 1, "button", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("anchor", ctx_r0.anchor)("anchorAlign", ctx_r0.anchorAlign)("popupAlign", ctx_r0.popupAlign)("popupClass", "menuPopupContainer");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(4, 7, "validation_error_list"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.validations)("ngForTrackBy", ctx_r0.trackByValidationKey);
} }
function FormValidationListComponent_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵlistener("click", function FormValidationListComponent_div_1_div_2_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.onClick(ctx_r11.validations[0]); });
    ɵngcc0.ɵɵelement(1, "ucc-icon", 12);
    ɵngcc0.ɵɵelementStart(2, "span", 13);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r9.validations[0] == null ? null : ctx_r9.validations[0].validationMessage, " ");
} }
function FormValidationListComponent_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵelement(1, "ucc-icon", 12);
    ɵngcc0.ɵɵelementStart(2, "span", 13);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "locale");
    ɵngcc0.ɵɵpipe(5, "locale");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate3(" ", ɵngcc0.ɵɵpipeBind1(4, 3, "validation_error_length_first"), " ", ctx_r10.validations == null ? null : ctx_r10.validations.length, " ", ɵngcc0.ɵɵpipeBind1(5, 5, "validation_error_length_second"), " ");
} }
function FormValidationListComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", null, 8);
    ɵngcc0.ɵɵtemplate(2, FormValidationListComponent_div_1_div_2_Template, 4, 1, "div", 9);
    ɵngcc0.ɵɵtemplate(3, FormValidationListComponent_div_1_div_3_Template, 6, 7, "div", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r1.validations == null ? null : ctx_r1.validations.length) == 1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r1.validations == null ? null : ctx_r1.validations.length) > 1);
} }
const _c14 = ["checkbox"];
const _c15 = ["ngwkTags"];
const _c16 = ["ngwkTagsOpenButton"];
function TagsComponent_ng_template_3_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dataItem_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngwkTooltip", ctx_r5.getTagItemText(dataItem_r4));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.getTagItemText(dataItem_r4));
} }
function TagsComponent_ng_template_3_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function TagsComponent_ng_template_3_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, TagsComponent_ng_template_3_div_2_ng_container_1_Template, 1, 0, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dataItem_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r6.customTemplate)("ngTemplateOutletContext", ctx_r6.getTagContext(dataItem_r4));
} }
function TagsComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵtemplate(1, TagsComponent_ng_template_3_span_1_Template, 2, 2, "span", 7);
    ɵngcc0.ɵɵtemplate(2, TagsComponent_ng_template_3_div_2_Template, 2, 2, "div", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dataItem_r4 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", ctx_r1.getTagItemId(dataItem_r4));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.customTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.customTemplate);
} }
function TagsComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "locale");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "no_data_found"));
} }
function TagsComponent_button_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 11, 12);
    ɵngcc0.ɵɵelement(2, "ucc-icon", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r3.isButtonDisabled());
} }
const _c17 = function (a0) { return { "hideInput": a0 }; };
const _c18 = function (a0) { return { periodicitySelectorItemDisabled: a0 }; };
function PeriodicitySelectorComponent_ngwk_periodicity_selector_item_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ngwk-periodicity-selector-item", 2);
    ɵngcc0.ɵɵlistener("itemClick", function PeriodicitySelectorComponent_ngwk_periodicity_selector_item_1_Template_ngwk_periodicity_selector_item_itemClick_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r3); const item_r1 = restoredCtx.$implicit; const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.onItemClick(item_r1.id); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", item_r1.id)("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c18, ctx_r0.isDisabled(item_r1.id)))("label", item_r1.label)("checked", ctx_r0.isChecked(item_r1.id))("disabled", ctx_r0.isDisabled(item_r1.id))("readonly", ctx_r0.readonly);
    ɵngcc0.ɵɵattribute("checked", ctx_r0.isChecked(item_r1.id));
} }
const _c19 = function (a0, a1) { return { periodicitySelectorItemChecked: a0, periodicitySelectorItemReadonly: a1 }; };
const _c20 = ["dropDownList"];
function MultiDropDownListComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "locale");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "no_data_found"));
} }
function MultiDropDownListComponent_3_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵlistener("click", function MultiDropDownListComponent_3_ng_template_0_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.onCheckAllClick(); });
    ɵngcc0.ɵɵelement(1, "ngwk-checkbox", 8);
    ɵngcc0.ɵɵelementStart(2, "span", 9);
    ɵngcc0.ɵɵelementStart(3, "span");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "locale");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r5.isHeaderChecked())("indeterminate", ctx_r5.isHeaderIndeterminate());
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(5, 3, "select_all"));
} }
function MultiDropDownListComponent_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MultiDropDownListComponent_3_ng_template_0_Template, 6, 5, "ng-template", 6);
} }
function MultiDropDownListComponent_ng_template_4_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", 10);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r9.getTextFields());
} }
function MultiDropDownListComponent_ng_template_4_span_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c21 = function (a0) { return { dataItem: a0 }; };
function MultiDropDownListComponent_ng_template_4_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtemplate(1, MultiDropDownListComponent_ng_template_4_span_1_ng_container_1_Template, 1, 0, "ng-container", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dataItem_r8 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r10 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r10.valueTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c21, dataItem_r8));
} }
function MultiDropDownListComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MultiDropDownListComponent_ng_template_4_ng_container_0_Template, 3, 1, "ng-container", 3);
    ɵngcc0.ɵɵtemplate(1, MultiDropDownListComponent_ng_template_4_span_1_Template, 2, 4, "span", 3);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.valueTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.valueTemplate);
} }
function MultiDropDownListComponent_ng_template_5_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0, 15);
    ɵngcc0.ɵɵelementStart(1, "span", 10);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const dataItem_r13 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r14 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r14.getTextField(dataItem_r13));
} }
function MultiDropDownListComponent_ng_template_5_span_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function MultiDropDownListComponent_ng_template_5_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 15);
    ɵngcc0.ɵɵtemplate(1, MultiDropDownListComponent_ng_template_5_span_3_ng_container_1_Template, 1, 0, "ng-container", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dataItem_r13 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r15 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r15.itemTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c21, dataItem_r13));
} }
function MultiDropDownListComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵlistener("click", function MultiDropDownListComponent_ng_template_5_Template_div_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r20); const dataItem_r13 = restoredCtx.$implicit; const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.onCheckClick(dataItem_r13); });
    ɵngcc0.ɵɵelement(1, "ngwk-checkbox", 13);
    ɵngcc0.ɵɵtemplate(2, MultiDropDownListComponent_ng_template_5_ng_container_2_Template, 3, 1, "ng-container", 14);
    ɵngcc0.ɵɵtemplate(3, MultiDropDownListComponent_ng_template_5_span_3_Template, 2, 4, "span", 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dataItem_r13 = ctx.$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r4.isItemChecked(dataItem_r13))("disabled", ctx_r4.isItemDisabled(dataItem_r13));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r4.itemTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.itemTemplate);
} }
function StarRatingComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "ucc-icon", 3);
    ɵngcc0.ɵɵlistener("click", function StarRatingComponent_div_1_Template_ucc_icon_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r3); const star_r1 = restoredCtx.$implicit; const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.onItemClick(star_r1.id); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const star_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.getClasses(star_r1.active));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("id", ctx_r0.getId(star_r1.id))("key", ctx_r0.getKey(star_r1.active));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.getText(star_r1.id));
} }
class BaseInput {
    constructor() {
        this._internalValue = null;
        this._isDisabled = false;
        this.onChangedCallback = (value) => { };
        this.onTouchedCallback = () => { };
    }
    /** @ignore */
    writeValue(value) {
        if (value !== this._internalValue) {
            this._internalValue = value;
        }
    }
    /** @ignore */
    registerOnChange(fn) {
        this.onChangedCallback = fn;
    }
    /** @ignore */
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
    /** @ignore */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    /** @ignore */
    get internalValue() {
        return this._internalValue;
    }
    /** @ignore */
    set internalValue(value) {
        if (value !== this.internalValue) {
            this._internalValue = value;
            this.onChangedCallback(this._internalValue);
        }
    }
    /**
     * Permite consultar si el estado de deshabilitado está activado o desactivado
     */
    get disabled() {
        return this._isDisabled;
    }
    /**
     * Permite habilitar o deshabilitar el campo del input
     *
     * @param value Valor que habilita o deshabilita el campo
     */
    set disabled(value) {
        this._isDisabled = value;
    }
}
BaseInput.ɵfac = function BaseInput_Factory(t) { return new (t || BaseInput)(); };
BaseInput.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: BaseInput, inputs: { disabled: "disabled" } });
BaseInput.propDecorators = {
    disabled: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BaseInput, [{
        type: Directive
    }], function () { return []; }, { disabled: [{
            type: Input
        }] }); })();

/** Clase que sirve para implementar las funcionalidades de Focus y Blur en los Inputs de la aplicación */
class FocusableInput extends BaseInput {
    constructor() {
        super(...arguments);
        this._isFocused = false;
        this._isFocusedAttr = false;
        this._focused = new EventEmitter();
        this._blur = new EventEmitter();
    }
    ngDoCheck() {
        this._isFocusedAttr = this._isFocused ? true : null;
    }
    /** @ignore */
    get isFocusedAttr() {
        return this._isFocusedAttr;
    }
    /**
     * Permite forzar el foco en el Input
     */
    focus() {
        this.inputFocus.focus();
    }
    /** @ignore */
    onBlur() {
        this.onTouchedCallback();
        this.blur.emit();
        this._isFocused = false;
    }
    /** @ignore */
    onFocus() {
        this.focused.emit();
        this._isFocused = true;
    }
    /**
     * Permite consultar si el input tiene el estado de focus
     */
    get isFocused() {
        return this._isFocused;
    }
    /**
     * Emite cuando el input ha obtenido el estado de focus
     */
    get focused() {
        return this._focused;
    }
    /**
     * Emite cuando el input ha perdido el focus
     */
    get blur() {
        return this._blur;
    }
}
FocusableInput.ɵfac = /*@__PURE__*/ function () { let ɵFocusableInput_BaseFactory; return function FocusableInput_Factory(t) { return (ɵFocusableInput_BaseFactory || (ɵFocusableInput_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(FocusableInput)))(t || FocusableInput); }; }();
FocusableInput.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: FocusableInput, hostVars: 1, hostBindings: function FocusableInput_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("data-focused", ctx.isFocusedAttr);
    } }, outputs: { focused: "focus", blur: "blur" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
FocusableInput.propDecorators = {
    isFocusedAttr: [{ type: HostBinding, args: ['attr.data-focused',] }],
    focused: [{ type: Output, args: ['focus',] }],
    blur: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FocusableInput, [{
        type: Directive
    }], null, { isFocusedAttr: [{
            type: HostBinding,
            args: ['attr.data-focused']
        }], focused: [{
            type: Output,
            args: ['focus']
        }], blur: [{
            type: Output
        }] }); })();

/**
 * Clase abstracta que deben heredar aquellos que quieren impletar el estado solo lectura y focusable de un input
 */
class ReadonlyFocusableInput extends FocusableInput {
    constructor() {
        super(...arguments);
        this._readonly = false;
        this._onreadonly = new EventEmitter();
    }
    onNotifyReadonlyChange() {
        this.onreadonly.emit(this.readonly);
    }
    /**
     * Permite consultar el estado de solo lectura en el input
     */
    get readonly() {
        return this._readonly;
    }
    /**
     * Permite activar o desactivar el estado de solo lectura del input
     *
     * @param value Valor que activa o desactiva el estado de solo lectura
     */
    set readonly(value) {
        this._readonly = value;
        this.onNotifyReadonlyChange();
    }
    /**
     * Emite cuando cambia el estado de solo lectura
     */
    get onreadonly() {
        return this._onreadonly;
    }
}
ReadonlyFocusableInput.ɵfac = /*@__PURE__*/ function () { let ɵReadonlyFocusableInput_BaseFactory; return function ReadonlyFocusableInput_Factory(t) { return (ɵReadonlyFocusableInput_BaseFactory || (ɵReadonlyFocusableInput_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(ReadonlyFocusableInput)))(t || ReadonlyFocusableInput); }; }();
ReadonlyFocusableInput.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ReadonlyFocusableInput, inputs: { readonly: "readonly" }, outputs: { onreadonly: "readonly" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
ReadonlyFocusableInput.propDecorators = {
    readonly: [{ type: Input }],
    onreadonly: [{ type: Output, args: ['readonly',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ReadonlyFocusableInput, [{
        type: Directive
    }], null, { readonly: [{
            type: Input
        }], onreadonly: [{
            type: Output,
            args: ['readonly']
        }] }); })();

/**
 * Este componente se utiliza para la declaración de un input de tipo password
 *
 * @example
 * <ngwk-password-box
 *  [(ngModel)]="value"
 *  [autocomplete]="autocomplete">
 * </ngwk-password-box>
 *
 */
class PasswordBoxComponent extends ReadonlyFocusableInput {
    constructor() {
        super(...arguments);
        this._autocomplete = null;
    }
    /** @ignore */
    get inputFocus() {
        return this._input.nativeElement;
    }
    /**
     * Permite obtener el tipo de autocomplete de los inputs de tipo password
     */
    get autocomplete() {
        return this._autocomplete;
    }
    /**
     * Permite definir el tipo de autocomplete de los inputs de tipo password
     *
     * @param value El tipo de autocomplete
     */
    set autocomplete(value) {
        this._autocomplete = value;
    }
}
PasswordBoxComponent.ɵfac = /*@__PURE__*/ function () { let ɵPasswordBoxComponent_BaseFactory; return function PasswordBoxComponent_Factory(t) { return (ɵPasswordBoxComponent_BaseFactory || (ɵPasswordBoxComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(PasswordBoxComponent)))(t || PasswordBoxComponent); }; }();
PasswordBoxComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PasswordBoxComponent, selectors: [["ngwk-password-box"]], viewQuery: function PasswordBoxComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._input = _t.first);
    } }, inputs: { autocomplete: "autocomplete" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => PasswordBoxComponent),
                multi: true
            },
            {
                provide: ReadonlyFocusableInput,
                useExisting: forwardRef(() => PasswordBoxComponent),
                multi: true
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 4, consts: [["type", "password", 3, "ngModel", "autocomplete", "readonly", "disabled", "ngModelChange", "blur", "focus"], ["input", ""]], template: function PasswordBoxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "input", 0, 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function PasswordBoxComponent_Template_input_ngModelChange_0_listener($event) { return ctx.internalValue = $event; })("blur", function PasswordBoxComponent_Template_input_blur_0_listener() { return ctx.onBlur(); })("focus", function PasswordBoxComponent_Template_input_focus_0_listener() { return ctx.onFocus(); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngModel", ctx.internalValue)("autocomplete", ctx.autocomplete)("readonly", ctx.readonly)("disabled", ctx.disabled);
    } }, directives: [ɵngcc1.DefaultValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.NgModel], encapsulation: 2 });
PasswordBoxComponent.propDecorators = {
    _input: [{ type: ViewChild, args: ['input', { read: ElementRef, static: true },] }],
    autocomplete: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PasswordBoxComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-password-box',
                template: "<input #input type=\"password\" [(ngModel)]=\"internalValue\" [autocomplete]=\"autocomplete\" (blur)=\"onBlur()\" (focus)=\"onFocus()\"\r\n  [readonly]=\"readonly\" [disabled]=\"disabled\" />\r\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => PasswordBoxComponent),
                        multi: true
                    },
                    {
                        provide: ReadonlyFocusableInput,
                        useExisting: forwardRef(() => PasswordBoxComponent),
                        multi: true
                    }
                ]
            }]
    }], null, { autocomplete: [{
            type: Input
        }], _input: [{
            type: ViewChild,
            args: ['input', { read: ElementRef, static: true }]
        }] }); })();

class PasswordBoxModule {
}
PasswordBoxModule.ɵfac = function PasswordBoxModule_Factory(t) { return new (t || PasswordBoxModule)(); };
PasswordBoxModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PasswordBoxModule });
PasswordBoxModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            FormsModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PasswordBoxModule, [{
        type: NgModule,
        args: [{
                imports: [
                    FormsModule
                ],
                declarations: [
                    PasswordBoxComponent
                ],
                exports: [
                    PasswordBoxComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PasswordBoxModule, { declarations: function () { return [PasswordBoxComponent]; }, imports: function () { return [FormsModule]; }, exports: function () { return [PasswordBoxComponent]; } }); })();

/**
 * Este componente se utiliza para la declaración de inputs de tipo DatePicker
 *
 * @example
 * <ngwk-date-picker [(ngModel)]="date"></ngwk-date-picker>
 */
class DatePickerComponent extends ReadonlyFocusableInput {
    /**@ignore */
    constructor(_localeService) {
        super();
        this._localeService = _localeService;
        /** Permite definir el formato de la fecha */
        this.format = this.getDefaultFormat();
        /** Permite definir la fecha máxima introducible */
        this.max = null;
        /** Permite definir la fecha mínima introducible */
        this.min = null;
        /**
         * Permite definir el límite de un año de dos dígitos que se traduzca correctamente a un año de cuatro dígitos.
         * De manera predeterminada es 40, que quiere decir que cualquier número menor o igual a 40 se traducirá en el margen de años 2000-2040.
         * Si es mayor a 40 y menor a 100, se traducirá en el margen de años de 1941-1999.
         */
        this.twoDigitYearMax = 40;
    }
    //#region Hooks
    ngAfterViewInit() {
        this.selectAllWhenClick();
    }
    //#endregion
    //#region Public methods
    /**@ignore */
    tabNext() {
        this.selectNextTabbableOrFocusable();
    }
    /**@ignore */
    tabPrevious() {
        this.selectPreviousTabbableOrFocusable();
    }
    //#endregion
    //#region Private methods
    selectAllWhenClick() {
        const kendoDatePickerInput = this._datePicker.input;
        kendoDatePickerInput.selectNearestSegment = () => kendoDatePickerInput.caret(0, 10);
    }
    /**@ignore */
    onKeyDown(event) {
        if (event.shiftKey && event.key === 'Tab') {
            this.tabPrevious();
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }
        else if (event.key === 'Tab') {
            this.tabNext();
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }
    }
    /**@ignore */
    onBlur() {
        this.normalizeDate(this.internalValue);
        this.validateMinMaxDate();
        super.onBlur();
    }
    /**@ignore */
    onFocus() {
        this.selectAllText();
        super.onFocus();
    }
    normalizeDate(date) {
        const normalizedDate = DateTime.convertToDate(date, this.twoDigitYearMax);
        if (normalizedDate) {
            this.internalValue = normalizedDate;
        }
    }
    selectNextTabbableOrFocusable() {
        let selectableElements = this.getSelectableElements();
        let selectableElementsArray = Array.prototype.slice.call(selectableElements);
        selectableElementsArray = selectableElementsArray.filter((element) => element.disabled !== true);
        let currentElement = document.activeElement;
        let nextIndex = 0;
        let currentElementIndex = selectableElementsArray.findIndex((element) => element === currentElement);
        if (currentElementIndex + 1 < selectableElements.length) {
            nextIndex = currentElementIndex + 1;
        }
        this.cleanTextSelection();
        selectableElementsArray[nextIndex].focus();
    }
    selectPreviousTabbableOrFocusable() {
        let selectableElements = this.getSelectableElements();
        let selectableElementsArray = Array.prototype.slice.call(selectableElements);
        selectableElementsArray = selectableElementsArray.filter((element) => element.disabled !== true);
        let currentElement = document.activeElement;
        let prevIndex = selectableElementsArray.length - 1;
        let currentElementIndex = selectableElementsArray.findIndex((element) => element === currentElement);
        if (currentElementIndex > 0) {
            prevIndex = currentElementIndex - 1;
        }
        this.cleanTextSelection();
        selectableElementsArray[prevIndex].focus();
    }
    getSelectableElements() {
        return document.querySelectorAll('[href], button:enabled, input:enabled, select:enabled, textarea:enabled, [tabindex]:not([tabindex="-1"])');
    }
    cleanTextSelection() {
        const selection = window.getSelection ? window.getSelection() : null;
        if (selection && selection.removeAllRanges) {
            selection.removeAllRanges();
        }
    }
    selectAllText() {
        const inputElement = this._datePicker.input.inputElement;
        // See https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8229660/
        if (navigator.userAgent.match(/Edge\/(13|14|15|16|17)/)) {
            setTimeout(inputElement.select.bind(inputElement), 10);
        }
        else {
            setTimeout(() => inputElement.select());
        }
    }
    getDefaultFormat() {
        switch (this._localeService.currentCulture) {
            case 'en-EN': return 'MM/dd/yyyy';
            case 'es-ES': return 'dd/MM/yyyy';
            default: return 'dd/MM/yyyy';
        }
    }
    validateMinMaxDate() {
        if (this.max && this.internalValue > this.max) {
            this.internalValue = this.max;
        }
        else if (this.min && this.internalValue < this.min) {
            this.internalValue = this.min;
        }
    }
    //#endregion
    //#region Properties
    /**@ignore */
    get inputFocus() {
        return this._datePicker;
    }
}
DatePickerComponent.ɵfac = function DatePickerComponent_Factory(t) { return new (t || DatePickerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.LocaleService)); };
DatePickerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DatePickerComponent, selectors: [["ngwk-date-picker"]], viewQuery: function DatePickerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c1, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._datePicker = _t.first);
    } }, inputs: { format: "format", max: "max", min: "min", twoDigitYearMax: "twoDigitYearMax" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DatePickerComponent),
                multi: true
            },
            {
                provide: ReadonlyFocusableInput,
                useExisting: forwardRef(() => DatePickerComponent),
                multi: true
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 6, consts: [[3, "value", "format", "min", "max", "readonly", "disabled", "valueChange", "blur", "focus", "keydown"], ["datePicker", ""]], template: function DatePickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "kendo-datepicker", 0, 1);
        ɵngcc0.ɵɵlistener("valueChange", function DatePickerComponent_Template_kendo_datepicker_valueChange_0_listener($event) { return ctx.internalValue = $event; })("blur", function DatePickerComponent_Template_kendo_datepicker_blur_0_listener() { return ctx.onBlur(); })("focus", function DatePickerComponent_Template_kendo_datepicker_focus_0_listener() { return ctx.onFocus(); })("keydown", function DatePickerComponent_Template_kendo_datepicker_keydown_0_listener($event) { return ctx.onKeyDown($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("value", ctx.internalValue)("format", ctx.format)("min", ctx.min)("max", ctx.max)("readonly", ctx.readonly)("disabled", ctx.disabled);
    } }, directives: [ɵngcc3.DatePickerComponent], styles: [".inputLabelContent[_nghost-%COMP%]     kendo-datepicker, .inputLabelContent   [_nghost-%COMP%]     kendo-datepicker{width:100%;cursor:pointer}.inputLabelContent[_nghost-%COMP%]     kendo-datepicker ::selection, .inputLabelContent   [_nghost-%COMP%]     kendo-datepicker ::selection{background-color:#3390ff}.inputLabelContent[_nghost-%COMP%]     kendo-datepicker:hover, .inputLabelContent   [_nghost-%COMP%]     kendo-datepicker:hover{background-color:transparent}.inputLabelContent[_nghost-%COMP%]     kendo-datepicker span, .inputLabelContent   [_nghost-%COMP%]     kendo-datepicker span{border:none!important;background-color:transparent!important;border-bottom:1px solid #ccc;box-shadow:0 0!important}.inputLabelContent[_nghost-%COMP%]     kendo-datepicker span span.k-select, .inputLabelContent   [_nghost-%COMP%]     kendo-datepicker span span.k-select{width:auto;padding:7px}.inputLabelContent[_nghost-%COMP%]     kendo-datepicker span:focus, .inputLabelContent   [_nghost-%COMP%]     kendo-datepicker span:focus{border-bottom-color:#0081c6}.inputLabelContent[_nghost-%COMP%]     kendo-datepicker span kendo-dateinput, .inputLabelContent   [_nghost-%COMP%]     kendo-datepicker span kendo-dateinput{box-shadow:0 0!important}.inputLabelContent[_nghost-%COMP%]     kendo-datepicker span kendo-dateinput .k-input, .inputLabelContent   [_nghost-%COMP%]     kendo-datepicker span kendo-dateinput .k-input{padding:4px!important}.inputLabelContent[_nghost-%COMP%]     kendo-datepicker span kendo-dateinput:focus, .inputLabelContent   [_nghost-%COMP%]     kendo-datepicker span kendo-dateinput:focus{border:none!important;background-color:transparent!important;box-shadow:0 0!important}.inputLabelContent[_nghost-%COMP%]     kendo-datepicker span span, .inputLabelContent   [_nghost-%COMP%]     kendo-datepicker span span{background-color:transparent!important;color:#666;background-image:none!important;font-size:13px}.inputLabelContent[_nghost-%COMP%]     kendo-datepicker span span:hover, .inputLabelContent   [_nghost-%COMP%]     kendo-datepicker span span:hover{color:#333;background-color:transparent!important;background-image:none!important}"] });
/** @nocollapse */
DatePickerComponent.ctorParameters = () => [
    { type: LocaleService }
];
DatePickerComponent.propDecorators = {
    format: [{ type: Input }],
    max: [{ type: Input }],
    min: [{ type: Input }],
    twoDigitYearMax: [{ type: Input }],
    _datePicker: [{ type: ViewChild, args: ['datePicker', { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DatePickerComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-date-picker',
                template: "<kendo-datepicker #datePicker\r\n    [(value)]=\"internalValue\"\r\n    [format]=\"format\"\r\n    [min]=\"min\"\r\n    [max]=\"max\"\r\n    [readonly]=\"readonly\"\r\n    [disabled]=\"disabled\"\r\n    (blur)=\"onBlur()\"\r\n    (focus)=\"onFocus()\"\r\n    (keydown)=\"onKeyDown($event)\">\r\n</kendo-datepicker>\r\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DatePickerComponent),
                        multi: true
                    },
                    {
                        provide: ReadonlyFocusableInput,
                        useExisting: forwardRef(() => DatePickerComponent),
                        multi: true
                    }
                ],
                styles: [":host-context(.inputLabelContent) ::ng-deep kendo-datepicker{width:100%;cursor:pointer}:host-context(.inputLabelContent) ::ng-deep kendo-datepicker ::selection{background-color:#3390ff}:host-context(.inputLabelContent) ::ng-deep kendo-datepicker:hover{background-color:transparent}:host-context(.inputLabelContent) ::ng-deep kendo-datepicker span{border:none!important;background-color:transparent!important;border-bottom:1px solid #ccc;box-shadow:0 0!important}:host-context(.inputLabelContent) ::ng-deep kendo-datepicker span span.k-select{width:auto;padding:7px}:host-context(.inputLabelContent) ::ng-deep kendo-datepicker span:focus{border-bottom-color:#0081c6}:host-context(.inputLabelContent) ::ng-deep kendo-datepicker span kendo-dateinput{box-shadow:0 0!important}:host-context(.inputLabelContent) ::ng-deep kendo-datepicker span kendo-dateinput .k-input{padding:4px!important}:host-context(.inputLabelContent) ::ng-deep kendo-datepicker span kendo-dateinput:focus{border:none!important;background-color:transparent!important;box-shadow:0 0!important}:host-context(.inputLabelContent) ::ng-deep kendo-datepicker span span{background-color:transparent!important;color:#666;background-image:none!important;font-size:13px}:host-context(.inputLabelContent) ::ng-deep kendo-datepicker span span:hover{color:#333;background-color:transparent!important;background-image:none!important}\n"]
            }]
    }], function () { return [{ type: ɵngcc2.LocaleService }]; }, { format: [{
            type: Input
        }], max: [{
            type: Input
        }], min: [{
            type: Input
        }], twoDigitYearMax: [{
            type: Input
        }], _datePicker: [{
            type: ViewChild,
            args: ['datePicker', { static: true }]
        }] }); })();

class DatePickerModule {
}
DatePickerModule.ɵfac = function DatePickerModule_Factory(t) { return new (t || DatePickerModule)(); };
DatePickerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DatePickerModule });
DatePickerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            FormsModule,
            IntlModule,
            DatePickerModule$1
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DatePickerModule, [{
        type: NgModule,
        args: [{
                imports: [
                    FormsModule,
                    IntlModule,
                    DatePickerModule$1
                ],
                exports: [
                    DatePickerComponent
                ],
                declarations: [
                    DatePickerComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DatePickerModule, { declarations: function () { return [DatePickerComponent]; }, imports: function () { return [FormsModule,
        IntlModule,
        DatePickerModule$1]; }, exports: function () { return [DatePickerComponent]; } }); })();

/**
 * Este componente se utiliza para la declaración de un input de tipo Text
 *
 * @example
 * <ngwk-text-box
 *  [(ngModel)]="textValue">
 * </ngwk-text-box>
 *
 */
class TextBoxComponent extends ReadonlyFocusableInput {
    /** @ignore */
    constructor(_el) {
        super();
        this._el = _el;
        this._maxlength = null;
        this._placeholder = '';
        this._clearButton = false;
        this._autocomplete = '';
        this._clear = new EventEmitter();
    }
    /** @ignore */
    onMouseOver() {
        this._mouseOver = true;
    }
    /** @ignore */
    onMouseOut() {
        this._mouseOver = false;
    }
    /** @ignore */
    get canShowIcon() {
        return (this.internalValue && this.clearButton && !this.readonly);
    }
    /** @ignore */
    get canDisplayIconClass() {
        return (this._mouseOver || this._el.nativeElement.contains(document.activeElement));
    }
    /** @ignore */
    onDeleteContent() {
        this.internalValue = null;
        this.clear.emit();
    }
    /** @ignore */
    get inputFocus() {
        return this._input.element.nativeElement.querySelector('input');
    }
    /**
     * Permite obtener la longitud máxima en carácteres del input Text
     */
    get maxlength() {
        return this._maxlength;
    }
    /**
     * Permite definir la longitud máxima en carácteres del input Text
     *
     * @param value La longitud máxima en carácteres
     */
    set maxlength(value) {
        this._maxlength = value;
    }
    /**
     * Permite obtener el placeholder
     */
    get placeholder() {
        return this._placeholder;
    }
    /**
     * Permite definir el placeholder
     *
     * @param value El placeholder
     */
    set placeholder(value) {
        this._placeholder = value;
    }
    /**
     * Permite consultar si el botón de borrar el campo de texto está activado o no
     */
    get clearButton() {
        return this._clearButton;
    }
    /**
     * Permite activar o desactivar el botón de borrar el campo de texto
     *
     * @param value Valor que activa o desactiva el botón de borrar el campo de texto
     */
    set clearButton(value) {
        this._clearButton = value;
    }
    /**
     * Permite consultar si la opción de autocomplete está activada o no
     */
    get autocomplete() {
        return this._autocomplete;
    }
    /**
     * Permite activar o desactivar la opción de autocomplete a través de un string. 'on' lo activa y 'off' lo desactiva
     *
     * @param value Valor que activa o desactiva la opción de autocomplete
     */
    set autocomplete(value) {
        this._autocomplete = value;
    }
    /**
     * Emite un evento cuando se hace click en el botón de borrar el campo de texto
     */
    get clear() {
        return this._clear;
    }
}
TextBoxComponent.ɵfac = function TextBoxComponent_Factory(t) { return new (t || TextBoxComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
TextBoxComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TextBoxComponent, selectors: [["ngwk-text-box"]], viewQuery: function TextBoxComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._input = _t.first);
    } }, hostBindings: function TextBoxComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("mouseover", function TextBoxComponent_mouseover_HostBindingHandler() { return ctx.onMouseOver(); })("mouseleave", function TextBoxComponent_mouseleave_HostBindingHandler() { return ctx.onMouseOut(); });
    } }, inputs: { maxlength: "maxlength", placeholder: "placeholder", clearButton: "clearButton", autocomplete: "autocomplete" }, outputs: { clear: "clear" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => TextBoxComponent),
                multi: true
            },
            {
                provide: ReadonlyFocusableInput,
                useExisting: forwardRef(() => TextBoxComponent),
                multi: true
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 7, consts: [[1, "horizontalLayout", "alignMiddle"], ["input", ""], ["type", "text", 3, "ngModel", "maxlength", "placeholder", "disabled", "autocomplete", "readonly", "ngModelChange", "blur", "focus"], ["class", "inputTextboxIcon", "key", "clearFieldIcon", 3, "hidden", "click", 4, "ngIf"], ["key", "clearFieldIcon", 1, "inputTextboxIcon", 3, "hidden", "click"]], template: function TextBoxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵelementStart(2, "input", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function TextBoxComponent_Template_input_ngModelChange_2_listener($event) { return ctx.internalValue = $event; })("blur", function TextBoxComponent_Template_input_blur_2_listener() { return ctx.onBlur(); })("focus", function TextBoxComponent_Template_input_focus_2_listener() { return ctx.onFocus(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, TextBoxComponent_ucc_icon_3_Template, 1, 1, "ucc-icon", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.internalValue)("maxlength", ctx.maxlength)("placeholder", ctx.placeholder)("disabled", ctx.disabled)("autocomplete", ctx.autocomplete)("readonly", ctx.readonly);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.canShowIcon && !ctx.disabled);
    } }, directives: [ɵngcc1.DefaultValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.NgModel, ɵngcc1.MaxLengthValidator, ɵngcc4.NgIf, ɵngcc5.IconComponent], styles: ["[_nghost-%COMP%]     .inputTextboxIcon{cursor:pointer;color:#ccc}[_nghost-%COMP%]     .inputTextboxIcon .baseIcon{font-size:13px;color:#ccc}[_nghost-%COMP%]     .inputTextboxIcon .baseIcon:hover{color:#373737;background-color:transparent}"] });
/** @nocollapse */
TextBoxComponent.ctorParameters = () => [
    { type: ElementRef }
];
TextBoxComponent.propDecorators = {
    _input: [{ type: ViewChild, args: ['input', { read: ViewContainerRef, static: true },] }],
    onMouseOver: [{ type: HostListener, args: ['mouseover',] }],
    onMouseOut: [{ type: HostListener, args: ['mouseleave',] }],
    maxlength: [{ type: Input }],
    placeholder: [{ type: Input }],
    clearButton: [{ type: Input }],
    autocomplete: [{ type: Input }],
    clear: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TextBoxComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-text-box',
                template: "<div #input class=\"horizontalLayout alignMiddle\">\r\n    <input\r\n    type=\"text\"\r\n    [(ngModel)]=\"internalValue\"\r\n    [maxlength]=\"maxlength\"\r\n    [placeholder]=\"placeholder\"\r\n    [disabled]=\"disabled\"\r\n    [autocomplete]=\"autocomplete\"\r\n    (blur)=\"onBlur()\"\r\n    (focus)=\"onFocus()\"\r\n    [readonly]=\"readonly\" />\r\n    <ucc-icon\r\n        *ngIf=\"canShowIcon && !disabled\"\r\n        [hidden]=\"!canDisplayIconClass\"\r\n        class=\"inputTextboxIcon\"\r\n        key='clearFieldIcon'\r\n        (click)=\"onDeleteContent()\">\r\n    </ucc-icon>\r\n</div>\r\n\r\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => TextBoxComponent),
                        multi: true
                    },
                    {
                        provide: ReadonlyFocusableInput,
                        useExisting: forwardRef(() => TextBoxComponent),
                        multi: true
                    }
                ],
                styles: [":host ::ng-deep .inputTextboxIcon{cursor:pointer;color:#ccc}:host ::ng-deep .inputTextboxIcon .baseIcon{font-size:13px;color:#ccc}:host ::ng-deep .inputTextboxIcon .baseIcon:hover{color:#373737;background-color:transparent}\n"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { 
    /** @ignore */
    onMouseOver: [{
            type: HostListener,
            args: ['mouseover']
        }], 
    /** @ignore */
    onMouseOut: [{
            type: HostListener,
            args: ['mouseleave']
        }], maxlength: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], clearButton: [{
            type: Input
        }], autocomplete: [{
            type: Input
        }], clear: [{
            type: Output
        }], _input: [{
            type: ViewChild,
            args: ['input', { read: ViewContainerRef, static: true }]
        }] }); })();

class TextBoxModule {
}
TextBoxModule.ɵfac = function TextBoxModule_Factory(t) { return new (t || TextBoxModule)(); };
TextBoxModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TextBoxModule });
TextBoxModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            FormsModule,
            CommonModule,
            IconModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TextBoxModule, [{
        type: NgModule,
        args: [{
                imports: [
                    FormsModule,
                    CommonModule,
                    IconModule
                ],
                declarations: [
                    TextBoxComponent
                ],
                exports: [
                    TextBoxComponent
                ],
                schemas: [NO_ERRORS_SCHEMA]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TextBoxModule, { declarations: function () { return [TextBoxComponent]; }, imports: function () { return [FormsModule,
        CommonModule,
        IconModule]; }, exports: function () { return [TextBoxComponent]; } }); })();

/**
 * Este componente se utiliza para la declaración de un input de tipo numeric box
 *
 * @example
 * <ngwk-numeric-box
 *  [(ngModel)]="value"
 *  [min]="min"
 *  [max]="max"
 *  [decimals]="decimals"
 *  [format]="format">
 * </ngwk-numeric-box>
 *
 */
class NumericBoxComponent extends ReadonlyFocusableInput {
    /** @ignore */
    constructor() {
        super();
        this._disabled = false;
        this._spinners = false;
        this._autoCorrect = true;
    }
    ngOnInit() {
        this.configureFormat();
    }
    configureFormat() {
        if (!this.format) {
            if (this.decimals) {
                this.format = 'n' + this.decimals;
            }
            else {
                this.format = 'n';
            }
        }
    }
    /** @ignore */
    get inputFocus() {
        return this._numericbox;
    }
    //#region Getters & Setters
    /**
     * Permite obtener el valor mínimo introducible en el NumericBox
     */
    get min() {
        return this._min;
    }
    /**
     * Permite definir el valor mínimo introducible en el NumericBox
     *
     * @param value El valor mínimo introducible en el NumericBox
     */
    set min(value) {
        this._min = value;
    }
    /**
     * Permite obtener el valor máximo introducible en el NumericBox
     */
    get max() {
        return this._max;
    }
    /**
     * Permite definir el valor máximo introducible en el NumericBox
     *
     * @param value El valor máximo introducible en el NumericBox
     */
    set max(value) {
        this._max = value;
    }
    /**
     * Permite obtener el número de decimales del valor del NumericBox
     */
    get decimals() {
        return this._decimals;
    }
    /**
     * Permite definir el número de decimales del valor del NumericBox
     *
     * @param value El número de decimales del valor del NumericBox
     */
    set decimals(value) {
        this._decimals = value;
    }
    /**
     * Permite consultar si el estado de deshabilitado está activado o desactivado. De manera predeterminada está habilitado
     */
    get disabled() {
        return this._disabled;
    }
    /**
     * Permite habilitar o deshabilitar el campo del NumericBox. De manera predeterminada está habilitado
     *
     * @param value Valor que habilita o deshabilita el campo
     */
    set disabled(value) {
        this._disabled = value;
    }
    /**
     * Permite consultar si los spinners del NumericBox están activados o desactivados. De manera predeterminada están desactivados
     */
    get spinners() {
        return this._spinners;
    }
    /**
     * Permite activar o desactivar los spinners del NumericBox. De manera predeterminada están desactivados
     *
     * @param value Valor que activa o desactiva los spinners
     */
    set spinners(value) {
        this._spinners = value;
    }
    /**
     * Permite obtener el formato de los números del NumericBox
     */
    get format() {
        return this._format;
    }
    /**
     * Permite definir el formato de los números del NumericBox
     *
     * @param value El formato de los números del NumericBox
     */
    set format(value) {
        this._format = value;
    }
    /**
     * Permite consultar si la opción de corregir automáticamente del NumericBox están activada o desactivada. De manera predeterminada está activada
     */
    get autoCorrect() {
        return this._autoCorrect;
    }
    /**
     * Permite activar o desactivar la opción de corregir automáticamente del NumericBox. De manera predeterminada está activada
     *
     * @param value Valor que activa o desactiva la opción de corregir automáticamente
     */
    set autoCorrect(value) {
        this._autoCorrect = value;
    }
}
NumericBoxComponent.ɵfac = function NumericBoxComponent_Factory(t) { return new (t || NumericBoxComponent)(); };
NumericBoxComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NumericBoxComponent, selectors: [["ngwk-numeric-box"]], viewQuery: function NumericBoxComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c2, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._numericbox = _t.first);
    } }, inputs: { format: "format", min: "min", max: "max", decimals: "decimals", disabled: "disabled", spinners: "spinners", autoCorrect: "autoCorrect" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => NumericBoxComponent),
                multi: true
            },
            {
                provide: ReadonlyFocusableInput,
                useExisting: forwardRef(() => NumericBoxComponent),
                multi: true
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 9, consts: [[3, "ngModel", "autoCorrect", "min", "max", "decimals", "format", "spinners", "readonly", "disabled", "ngModelChange", "blur", "focus"], ["numericbox", ""]], template: function NumericBoxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "kendo-numerictextbox", 0, 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function NumericBoxComponent_Template_kendo_numerictextbox_ngModelChange_0_listener($event) { return ctx.internalValue = $event; })("blur", function NumericBoxComponent_Template_kendo_numerictextbox_blur_0_listener() { return ctx.onBlur(); })("focus", function NumericBoxComponent_Template_kendo_numerictextbox_focus_0_listener() { return ctx.onFocus(); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngModel", ctx.internalValue)("autoCorrect", ctx.autoCorrect)("min", ctx.min)("max", ctx.max)("decimals", ctx.decimals)("format", ctx.format)("spinners", ctx.spinners)("readonly", ctx.readonly)("disabled", ctx.disabled);
    } }, directives: [ɵngcc6.NumericTextBoxComponent, ɵngcc1.NgControlStatus, ɵngcc1.NgModel], styles: [".inputLabelContent[_nghost-%COMP%]     kendo-numerictextbox, .inputLabelContent   [_nghost-%COMP%]     kendo-numerictextbox{width:100%;border-color:transparent}.inputLabelContent[_nghost-%COMP%]     kendo-numerictextbox.k-widget, .inputLabelContent   [_nghost-%COMP%]     kendo-numerictextbox.k-widget{font-size:13px;border-color:transparent;border:none}.inputLabelContent[_nghost-%COMP%]     kendo-numerictextbox .k-widget::selection, .inputLabelContent   [_nghost-%COMP%]     kendo-numerictextbox .k-widget::selection{background-color:#3390ff!important}.inputLabelContent[_nghost-%COMP%]     kendo-numerictextbox .k-state-focused, .inputLabelContent   [_nghost-%COMP%]     kendo-numerictextbox .k-state-focused{border:none;box-shadow:0 0}.inputLabelContent[_nghost-%COMP%]     kendo-numerictextbox .k-state-focused .k-input::selection, .inputLabelContent   [_nghost-%COMP%]     kendo-numerictextbox .k-state-focused .k-input::selection{background-color:#3390ff!important}.inputLabelContent[_nghost-%COMP%]     kendo-numerictextbox .k-numeric-wrap, .inputLabelContent   [_nghost-%COMP%]     kendo-numerictextbox .k-numeric-wrap{border:none;background-color:transparent!important}.inputLabelContent[_nghost-%COMP%]     kendo-numerictextbox .k-numeric-wrap .k-input, .inputLabelContent   [_nghost-%COMP%]     kendo-numerictextbox .k-numeric-wrap .k-input{text-align:right;font-size:13px!important}.inputLabelContent[_nghost-%COMP%]     kendo-numerictextbox .k-select, .inputLabelContent   [_nghost-%COMP%]     kendo-numerictextbox .k-select{color:#656565;background-color:transparent;border-color:none;background-image:none}.inputLabelContent[_nghost-%COMP%]     kendo-numerictextbox .k-select:hover, .inputLabelContent   [_nghost-%COMP%]     kendo-numerictextbox .k-select:hover{color:#656565;background-color:transparent;border-color:none;background-image:none}.inputLabelContent[_nghost-%COMP%]     kendo-numerictextbox .k-select .k-state-active, .inputLabelContent   [_nghost-%COMP%]     kendo-numerictextbox .k-select .k-state-active{color:#656565;background-color:transparent;border-color:none;background-image:none}"] });
/** @nocollapse */
NumericBoxComponent.ctorParameters = () => [];
NumericBoxComponent.propDecorators = {
    _numericbox: [{ type: ViewChild, args: ['numericbox', { static: true },] }],
    min: [{ type: Input }],
    max: [{ type: Input }],
    decimals: [{ type: Input }],
    disabled: [{ type: Input }],
    spinners: [{ type: Input }],
    format: [{ type: Input }],
    autoCorrect: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NumericBoxComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-numeric-box',
                template: "<kendo-numerictextbox #numericbox\r\n    [(ngModel)]='internalValue'\r\n    [autoCorrect]=\"autoCorrect\"\r\n    [min]=\"min\"\r\n    [max]=\"max\"\r\n    [decimals]=\"decimals\"\r\n    [format]=\"format\"\r\n    [spinners]=\"spinners\"\r\n    [readonly]=\"readonly\"\r\n    [disabled]=\"disabled\"\r\n    (blur)=\"onBlur()\"\r\n    (focus)=\"onFocus()\">\r\n</kendo-numerictextbox>\r\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => NumericBoxComponent),
                        multi: true
                    },
                    {
                        provide: ReadonlyFocusableInput,
                        useExisting: forwardRef(() => NumericBoxComponent),
                        multi: true
                    }
                ],
                styles: [":host-context(.inputLabelContent) ::ng-deep kendo-numerictextbox{width:100%;border-color:transparent}:host-context(.inputLabelContent) ::ng-deep kendo-numerictextbox.k-widget{font-size:13px;border-color:transparent;border:none}:host-context(.inputLabelContent) ::ng-deep kendo-numerictextbox .k-widget::selection{background-color:#3390ff!important}:host-context(.inputLabelContent) ::ng-deep kendo-numerictextbox .k-state-focused{border:none;box-shadow:0 0}:host-context(.inputLabelContent) ::ng-deep kendo-numerictextbox .k-state-focused .k-input::selection{background-color:#3390ff!important}:host-context(.inputLabelContent) ::ng-deep kendo-numerictextbox .k-numeric-wrap{border:none;background-color:transparent!important}:host-context(.inputLabelContent) ::ng-deep kendo-numerictextbox .k-numeric-wrap .k-input{text-align:right;font-size:13px!important}:host-context(.inputLabelContent) ::ng-deep kendo-numerictextbox .k-select{color:#656565;background-color:transparent;border-color:none;background-image:none}:host-context(.inputLabelContent) ::ng-deep kendo-numerictextbox .k-select:hover{color:#656565;background-color:transparent;border-color:none;background-image:none}:host-context(.inputLabelContent) ::ng-deep kendo-numerictextbox .k-select .k-state-active{color:#656565;background-color:transparent;border-color:none;background-image:none}\n"]
            }]
    }], function () { return []; }, { format: [{
            type: Input
        }], min: [{
            type: Input
        }], max: [{
            type: Input
        }], decimals: [{
            type: Input
        }], disabled: [{
            type: Input
        }], spinners: [{
            type: Input
        }], autoCorrect: [{
            type: Input
        }], _numericbox: [{
            type: ViewChild,
            args: ['numericbox', { static: true }]
        }] }); })();

class NumericBoxModule {
}
NumericBoxModule.ɵfac = function NumericBoxModule_Factory(t) { return new (t || NumericBoxModule)(); };
NumericBoxModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NumericBoxModule });
NumericBoxModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            FormsModule,
            InputsModule$1
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NumericBoxModule, [{
        type: NgModule,
        args: [{
                imports: [
                    FormsModule,
                    InputsModule$1
                ],
                declarations: [
                    NumericBoxComponent
                ],
                exports: [
                    NumericBoxComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NumericBoxModule, { declarations: function () { return [NumericBoxComponent]; }, imports: function () { return [FormsModule,
        InputsModule$1]; }, exports: function () { return [NumericBoxComponent]; } }); })();

/**
 * Este componente se utiliza para la declaración de floating labels. Los floating labels sirven como información extra para los
 * inputs. Si no se ha escrito nada en el campo del input, el texto del label estará en la zona del input hasta que el input
 * obtenga información, en cuyo caso se posicionará arriba con el mismo texto. Además, se le puede aportar funcionalidades
 * extra como mensajes de información o de error, deshabilitar el input, etc.
 *
 * @example
 * <ngwk-floating-label mandatory="true" label="Fixed Label" fixedLabel='true' infoMessage="El tipico mensjae de Info, aqui va tu dni...">
 */
class FloatingLabelComponent {
    /**@ignore */
    constructor(elementRef) {
        this.elementRef = elementRef;
        this._label = null;
        this._placeHolder = null;
        this._infoMessage = null;
        this._errorMessages = null;
        this._mandatoryMessage = null;
        this._fixedLabel = false;
        this._readonly = false;
        this._hasValue = null;
        this._hasLabel = false;
        this._placeholderLayout = null;
        this._labelLayout = null;
        this._model = null;
        this._input = null;
    }
    /**@ignore */
    ngOnInit() {
        if (this._model) {
            this._model.valueChanges.subscribe((value) => {
                this.onValueChange(this._model.value);
            });
            this.onValueChange(this._model.value);
        }
    }
    /**@ignore */
    ngOnChanges(changes) {
        if (changes.fixedLabel && changes.fixedLabel.isFirstChange() && changes.fixedLabel.currentValue) {
            this._hasLabel = true;
        }
        this.setStylesOnLabelAndPlaceHolder();
    }
    /**
     * Esta función detecta si ha habido algún cambio y, a partir de los cambios, cambia los estilos actuales del floating label
     *
     * @param value Nuevo valor para la propiedad 'data'
     * @return
     */
    onValueChange(value) {
        if (this.hasRequiredError && !this.mandatoryMessage) {
            this._hasLabel = this.fixedLabel;
            this.mandatoryMessage = this.errorMessages ? this.errorMessages.get('required') : 'required';
        }
        else {
            this._hasLabel = this.fixedLabel ? true : !this.valueIsEmpty(value);
        }
        this.setStylesOnLabelAndPlaceHolder();
    }
    valueIsEmpty(value) {
        return (value === null || value === '' || (Array.isArray(value) && value.length === 0)) ? true : false;
    }
    /**@ignore */
    get hasRequiredError() {
        return this._model && this._model.hasError('required');
    }
    setStylesOnLabelAndPlaceHolder() {
        let _placeHolderClasses = null;
        let _labelClasses = null;
        if (this.hasLabel) {
            _placeHolderClasses = 'floatingPlaceHolder floatingPlaceHolderHidden';
            _labelClasses = 'floatingLabel floatingLabelShown alignVerticalMiddle';
        }
        else {
            _placeHolderClasses = 'floatingPlaceHolder';
            _labelClasses = 'floatingLabel';
        }
        this._placeholderLayout.nativeElement.className = `horizontalLayout ${_placeHolderClasses}`;
        this._labelLayout.nativeElement.className = `horizontalLayout ${_labelClasses}`;
    }
    /**@ignore */
    getValidationMessages() {
        let errorsKey = Reflection.getProperties(this._model.errors).filter((e) => e !== 'required');
        let validationErrors = [];
        if (errorsKey) {
            errorsKey.forEach((k) => {
                if (this._errorMessages && this._errorMessages.has(k)) {
                    validationErrors.push(this._errorMessages.get(k));
                }
                else {
                    validationErrors.push(k);
                }
            });
        }
        return validationErrors.join('\n');
    }
    //#region Properties
    /**@ignore */
    get isFocused() {
        return this._input && this._input.isFocused ? true : null;
    }
    /**@ignore */
    get isReadOnly() {
        return this._input && this._input.readonly ? true : null;
    }
    /**@ignore */
    get isDisabled() {
        return this._input && this._input.disabled ? true : null;
    }
    /**@ignore */
    get hasModelErrors() {
        return this.hasErrorsExcludingRequiredError ? true : null;
    }
    // private get hasErrors(): boolean {
    //   return this._model && this._model.errors && Object.keys(this._model.errors).length > 0;
    // }
    /**
     * Permite obtener el label del FloatingLabel
     */
    get label() {
        return this._label;
    }
    /**
     * Permite definir el label del FloatingLabel
     *
     * @param value El label del FloatingLabel
     */
    set label(value) {
        this._label = value;
    }
    /**
     * Permite obtener el placeholder que se situará encima del Input que engloba el FloatingLabel
     */
    get placeHolder() {
        return this._placeHolder || this._label;
    }
    /**
     * Permite definir el placeholder que se situará encima del Input que engloba el FloatingLabel
     *
     * @param value El placeholder que se situará encima del Input
     */
    set placeHolder(value) {
        this._placeHolder = value;
    }
    /**
     * Permite obtener el mensaje de información que se situa al lado del FloatingLabel
     */
    get infoMessage() {
        return this._infoMessage;
    }
    /**
     * Permite definir el mensaje de información que se situa al lado del FloatingLabel
     *
     * @param value El mensaje de información
     */
    set infoMessage(value) {
        this._infoMessage = value;
    }
    /**
     * Permite obtener los mensajes de error que se situan al lado del FloatingLabel
     */
    get errorMessages() {
        return this._errorMessages;
    }
    /**
     * Permite definir los mensajes de error que se situan al lado del FloatingLabel
     *
     * @param value Los mensajes de error que se situan al lado del FloatingLabel
     */
    set errorMessages(value) {
        this._errorMessages = value;
    }
    /**
     * Permite obtener el mensaje que indica que el campo que engloba el FloatingLabel es obligatorio
     */
    get mandatoryMessage() {
        return this._mandatoryMessage;
    }
    /**
     * Permite definir el mensaje que indica que el campo que engloba el FloatingLabel es obligatorio
     *
     * @param value El mensaje que indica que el campo que engloba el FloatingLabel es obligatorio
     */
    set mandatoryMessage(value) {
        this._mandatoryMessage = value;
    }
    /**
     * Permite consultar si el label está de manera fija arriba del Input o no
     */
    get fixedLabel() {
        return this._fixedLabel;
    }
    /**
     * Permite activar o desactivar el estado de fijado del label
     *
     * @param value Valor que activa o desactiva el estado de fijado del label
     */
    set fixedLabel(value) {
        this._fixedLabel = value;
    }
    /**
     * Permite consultar si el FloatingLabel está en readonly o no
     */
    get readonly() {
        return this._readonly;
    }
    /**
     * Permite activar o desactivar el estado de readonly del label
     *
     * @param value Valor que activa o desactiva el estado de readonly del label
     */
    set readonly(value) {
        this._readonly = value;
    }
    /** @ignore */
    get hasLabel() {
        return this._hasLabel;
    }
    /** @ignore */
    get hasErrorsExcludingRequiredError() {
        let hasErrors = false;
        if (this._model && this._model.errors) {
            let errorsCount = Object.keys(this._model.errors).length;
            hasErrors =
                errorsCount > 1 || (errorsCount === 1 && !this.hasRequiredError);
        }
        return hasErrors;
    }
}
FloatingLabelComponent.ɵfac = function FloatingLabelComponent_Factory(t) { return new (t || FloatingLabelComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
FloatingLabelComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FloatingLabelComponent, selectors: [["ngwk-floating-label"]], contentQueries: function FloatingLabelComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, NgModel, 7);
        ɵngcc0.ɵɵcontentQuery(dirIndex, ReadonlyFocusableInput, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._model = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._input = _t.first);
    } }, viewQuery: function FloatingLabelComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c3, 7);
        ɵngcc0.ɵɵviewQuery(_c4, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._placeholderLayout = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._labelLayout = _t.first);
    } }, hostVars: 4, hostBindings: function FloatingLabelComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("data-focused", ctx.isFocused)("data-readonly", ctx.isReadOnly)("data-disabled", ctx.isDisabled)("data-error", ctx.hasModelErrors);
    } }, inputs: { mandatoryMessage: "mandatoryMessage", label: "label", placeHolder: "placeHolder", infoMessage: "infoMessage", errorMessages: "errorMessages", fixedLabel: "fixedLabel", readonly: "readonly" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => FloatingLabelComponent),
                multi: true
            }
        ]), ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c5, decls: 18, vars: 7, consts: [[1, "floatingLabelControl"], [1, "floatingPlaceHolderContainer"], ["id", "placeholderLayout", 1, "horizontalLayout"], ["placeholderLayout", ""], [1, "colAuto"], ["class", "mandatoryInputIcon inputTips colAuto", 3, "ngwkTooltip", 4, "ngIf"], ["class", "inputTips colAuto", 3, "ngwkTooltip", 4, "ngIf"], [1, "floatingLabelContainer"], ["id", "labelLayout", 1, "horizontalLayout"], ["labelLayout", ""], ["class", "mandatoryInputIcon colAuto", 3, "ngwkTooltip", 4, "ngIf"], ["class", "colAuto", 3, "ngwkTooltip", 4, "ngIf"], ["id", "contentLayout", 1, "inputLabelContent"], [1, "mandatoryInputIcon", "inputTips", "colAuto", 3, "ngwkTooltip"], ["key", "exclamation", "decorator", "circle", "iconClass", "floatingErrorIcon"], [1, "inputTips", "colAuto", 3, "ngwkTooltip"], ["key", "info", "decorator", "circle", "iconClass", "floatingInfoIcon"], [1, "mandatoryInputIcon", "colAuto", 3, "ngwkTooltip"], ["key", "exclamation", "decorator", "circle", "iconClass", "floatingWarningIcon"], [1, "colAuto", 3, "ngwkTooltip"], ["key", "errorIcon", "decorator", "circle", "iconClass", "floatingErrorIcon"], ["key", "info", "decorator", "circle", "iconClass", "floatingInfoIcon alignMiddle"]], template: function FloatingLabelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2, 3);
        ɵngcc0.ɵɵelementStart(4, "label", 4);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, FloatingLabelComponent_div_6_Template, 2, 1, "div", 5);
        ɵngcc0.ɵɵtemplate(7, FloatingLabelComponent_div_7_Template, 2, 1, "div", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 7);
        ɵngcc0.ɵɵelementStart(9, "div", 8, 9);
        ɵngcc0.ɵɵelementStart(11, "label", 4);
        ɵngcc0.ɵɵtext(12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(13, FloatingLabelComponent_div_13_Template, 2, 1, "div", 10);
        ɵngcc0.ɵɵtemplate(14, FloatingLabelComponent_div_14_Template, 2, 1, "div", 11);
        ɵngcc0.ɵɵtemplate(15, FloatingLabelComponent_div_15_Template, 2, 1, "div", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 12);
        ɵngcc0.ɵɵprojection(17);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ctx.placeHolder);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasRequiredError && !ctx.hasLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.infoMessage && !ctx.hasLabel);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasRequiredError && ctx.fixedLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasErrorsExcludingRequiredError);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.infoMessage);
    } }, directives: [ɵngcc4.NgIf, ɵngcc2.NgwkTooltipDirective, ɵngcc5.IconComponent], styles: ["[_nghost-%COMP%]     .floatingLabel{position:absolute;top:5;transition:top .7s ease,opacity .7s ease;opacity:0;width:100%;font-weight:normal}[_nghost-%COMP%]     .floatingLabelContainer{position:relative;height:16px;width:100%;margin-bottom:1.6px;overflow:hidden}[_nghost-%COMP%]     .floatingLabelIcon{font-size:12px;margin:2px 1px 3px 6px;color:#fff;background-color:#ccc;padding:1px}[_nghost-%COMP%]     .floatingErrorIcon{font-size:12px;margin:2px 1px 3px 6px;color:#fff;background-color:#ccc;padding:1px;background-color:#fb7e5d}[_nghost-%COMP%]     .floatingInfoIcon{font-size:12px;margin:2px 1px 3px 6px;background-color:#ccc;padding:1px;color:#fff;background-color:#429ed6}[_nghost-%COMP%]     .floatingWarningIcon{font-size:12px;margin:2px 1px 3px 6px;background-color:#ccc;padding:1px;background-color:#429ed6;color:#fff;background-color:#e67e22}[_nghost-%COMP%]     .floatingLabelShown{opacity:1;top:0}[_nghost-%COMP%]     .floatingPlaceHolderContainer{position:relative;height:0;z-index:1;width:100%}[_nghost-%COMP%]     .inputTips{pointer-events:all}[_nghost-%COMP%]     .inputLabelContent{bottom:0;display:block;width:100%;min-height:29px;z-index:1}[_nghost-%COMP%]     .floatingLabelControl{width:100%;height:auto;margin-bottom:15px;border-bottom:1px solid #dddddd;padding-top:0;padding-bottom:0;font-size:13px}[_nghost-%COMP%]     .floatingLabelControl p{margin:6px}[_nghost-%COMP%]     .floatingLabelControl .inputField{top:0;display:block;width:100%;border:transparent;background:transparent;outline:0;resize:none}[_nghost-%COMP%]     .floatingLabelControl input, [_nghost-%COMP%]     .floatingLabelControl select, [_nghost-%COMP%]     .floatingLabelControl textarea{top:0;display:block;width:100%;border:transparent;background:transparent;outline:0;resize:none;padding:6px 4px 4px;font-size:13px;color:#373737!important}[_nghost-%COMP%]     .floatingLabelControl textarea{top:0;display:block;width:100%;border:transparent;background:transparent;outline:0;overflow:hidden;resize:none;padding-bottom:0;position:relative}[_nghost-%COMP%]     .floatingLabelControl label{color:#429ed6;font-size:13px;white-space:nowrap;overflow:hidden;-ms-text-overflow:ellipsis;text-overflow:ellipsis;font-weight:normal;font-size:11px;margin-left:4px;max-width:85%}[_nghost-%COMP%]     .floatingPlaceHolder{position:absolute;top:23.8px;opacity:1;color:#aaa;font-family:FiraSans Regular,Calibri,Verdana;font-weight:normal;pointer-events:none}[_nghost-%COMP%]     .floatingPlaceHolder label{color:#aaa;font-weight:normal;font-size:13px}[_nghost-%COMP%]     .floatingPlaceHolderHidden{opacity:0}[_nghost-%COMP%]     .floatingLabelControl .floatingLabelSearch input{background:white!important;border:1px solid #ccc!important;margin-right:35px}[data-focused][_nghost-%COMP%]     .floatingLabelControl{border-bottom:1px solid #0081c6}[data-readonly][_nghost-%COMP%]     .floatingLabelControl{border-bottom:1px dashed #dddddd}[data-readonly][_nghost-%COMP%]     .floatingLabelControl span{cursor:default}[data-readonly][_nghost-%COMP%]     .floatingLabelControl span .k-icon{color:#ccc!important}[data-disabled][_nghost-%COMP%]     .floatingLabelControl{border-bottom:1px solid #dddddd}[data-disabled][_nghost-%COMP%]     .floatingLabelControl label, [data-disabled][_nghost-%COMP%]     .floatingLabelControl input{color:#949494!important}[data-disabled][_nghost-%COMP%]     .floatingLabelControl span{cursor:initial}[data-disabled][_nghost-%COMP%]     .floatingLabelControl span .k-icon{color:#ccc!important}[data-error][_nghost-%COMP%]     .floatingLabelControl{border-bottom:1px solid #FB7E5D}[data-error][_nghost-%COMP%]     .floatingLabelControl label{color:#fb7e5d}[data-error][data-focused][_nghost-%COMP%]     .floatingLabelControl{border-bottom:1px solid #ea1b2d}[data-error][data-focused][_nghost-%COMP%]     .floatingLabelControl label{color:#ea1b2d}"] });
/** @nocollapse */
FloatingLabelComponent.ctorParameters = () => [
    { type: ElementRef }
];
FloatingLabelComponent.propDecorators = {
    _placeholderLayout: [{ type: ViewChild, args: ['placeholderLayout', { static: true },] }],
    _labelLayout: [{ type: ViewChild, args: ['labelLayout', { static: true },] }],
    _model: [{ type: ContentChild, args: [NgModel, { static: true },] }],
    _input: [{ type: ContentChild, args: [ReadonlyFocusableInput, { static: true },] }],
    isFocused: [{ type: HostBinding, args: ['attr.data-focused',] }],
    isReadOnly: [{ type: HostBinding, args: ['attr.data-readonly',] }],
    isDisabled: [{ type: HostBinding, args: ['attr.data-disabled',] }],
    hasModelErrors: [{ type: HostBinding, args: ['attr.data-error',] }],
    label: [{ type: Input }],
    placeHolder: [{ type: Input }],
    infoMessage: [{ type: Input }],
    errorMessages: [{ type: Input }],
    mandatoryMessage: [{ type: Input }],
    fixedLabel: [{ type: Input }],
    readonly: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FloatingLabelComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-floating-label',
                template: "<div class=\"floatingLabelControl\">\r\n    <div class=\"floatingPlaceHolderContainer\">\r\n        <div #placeholderLayout id='placeholderLayout'  class='horizontalLayout'>\r\n            <label class=\"colAuto\">{{placeHolder}}</label>\r\n            <div *ngIf=\"hasRequiredError && !hasLabel\" class=\"mandatoryInputIcon inputTips colAuto\" [ngwkTooltip]='mandatoryMessage'>\r\n                <ucc-icon key=\"exclamation\" decorator='circle' iconClass=\"floatingErrorIcon\"></ucc-icon>\r\n            </div>\r\n            <div *ngIf='infoMessage && !hasLabel' class='inputTips colAuto' [ngwkTooltip]='infoMessage'>\r\n                <ucc-icon key='info' decorator='circle' iconClass=\"floatingInfoIcon\"></ucc-icon>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"floatingLabelContainer\">\r\n        <div #labelLayout id='labelLayout' class='horizontalLayout'>\r\n            <label class=\"colAuto\">{{label}}</label>\r\n            <div *ngIf=\"hasRequiredError && fixedLabel\" class=\"mandatoryInputIcon colAuto\" [ngwkTooltip]='mandatoryMessage'>\r\n                <ucc-icon key=\"exclamation\" decorator='circle' iconClass=\"floatingWarningIcon\"></ucc-icon>\r\n            </div>\r\n            <div *ngIf='hasErrorsExcludingRequiredError' class='colAuto' [ngwkTooltip]='getValidationMessages()'>\r\n                <ucc-icon key='errorIcon'  decorator='circle' iconClass='floatingErrorIcon'></ucc-icon>\r\n            </div>\r\n            <div *ngIf='infoMessage' class='colAuto' [ngwkTooltip]='infoMessage'>\r\n                <ucc-icon key='info' decorator='circle' iconClass='floatingInfoIcon alignMiddle'></ucc-icon>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div id='contentLayout' class='inputLabelContent'>\r\n        <ng-content></ng-content>\r\n    </div>\r\n</div>\r\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => FloatingLabelComponent),
                        multi: true
                    }
                ],
                styles: [":host ::ng-deep .floatingLabel{position:absolute;top:5;transition:top .7s ease,opacity .7s ease;opacity:0;width:100%;font-weight:normal}:host ::ng-deep .floatingLabelContainer{position:relative;height:16px;width:100%;margin-bottom:1.6px;overflow:hidden}:host ::ng-deep .floatingLabelIcon{font-size:12px;margin:2px 1px 3px 6px;color:#fff;background-color:#ccc;padding:1px}:host ::ng-deep .floatingErrorIcon{font-size:12px;margin:2px 1px 3px 6px;color:#fff;background-color:#ccc;padding:1px;background-color:#fb7e5d}:host ::ng-deep .floatingInfoIcon{font-size:12px;margin:2px 1px 3px 6px;background-color:#ccc;padding:1px;color:#fff;background-color:#429ed6}:host ::ng-deep .floatingWarningIcon{font-size:12px;margin:2px 1px 3px 6px;background-color:#ccc;padding:1px;background-color:#429ed6;color:#fff;background-color:#e67e22}:host ::ng-deep .floatingLabelShown{opacity:1;top:0}:host ::ng-deep .floatingPlaceHolderContainer{position:relative;height:0;z-index:1;width:100%}:host ::ng-deep .inputTips{pointer-events:all}:host ::ng-deep .inputLabelContent{bottom:0;display:block;width:100%;min-height:29px;z-index:1}:host ::ng-deep .floatingLabelControl{width:100%;height:auto;margin-bottom:15px;border-bottom:1px solid #dddddd;padding-top:0;padding-bottom:0;font-size:13px}:host ::ng-deep .floatingLabelControl p{margin:6px}:host ::ng-deep .floatingLabelControl .inputField{top:0;display:block;width:100%;border:transparent;background:transparent;outline:0;resize:none}:host ::ng-deep .floatingLabelControl input,:host ::ng-deep .floatingLabelControl select,:host ::ng-deep .floatingLabelControl textarea{top:0;display:block;width:100%;border:transparent;background:transparent;outline:0;resize:none;padding:6px 4px 4px;font-size:13px;color:#373737!important}:host ::ng-deep .floatingLabelControl textarea{top:0;display:block;width:100%;border:transparent;background:transparent;outline:0;overflow:hidden;resize:none;padding-bottom:0;position:relative}:host ::ng-deep .floatingLabelControl label{color:#429ed6;font-size:13px;white-space:nowrap;overflow:hidden;-ms-text-overflow:ellipsis;text-overflow:ellipsis;font-weight:normal;font-size:11px;margin-left:4px;max-width:85%}:host ::ng-deep .floatingPlaceHolder{position:absolute;top:23.8px;opacity:1;color:#aaa;font-family:FiraSans Regular,Calibri,Verdana;font-weight:normal;pointer-events:none}:host ::ng-deep .floatingPlaceHolder label{color:#aaa;font-weight:normal;font-size:13px}:host ::ng-deep .floatingPlaceHolderHidden{opacity:0}:host ::ng-deep .floatingLabelControl .floatingLabelSearch input{background:white!important;border:1px solid #ccc!important;margin-right:35px}:host[data-focused] ::ng-deep .floatingLabelControl{border-bottom:1px solid #0081c6}:host[data-readonly] ::ng-deep .floatingLabelControl{border-bottom:1px dashed #dddddd}:host[data-readonly] ::ng-deep .floatingLabelControl span{cursor:default}:host[data-readonly] ::ng-deep .floatingLabelControl span .k-icon{color:#ccc!important}:host[data-disabled] ::ng-deep .floatingLabelControl{border-bottom:1px solid #dddddd}:host[data-disabled] ::ng-deep .floatingLabelControl label,:host[data-disabled] ::ng-deep .floatingLabelControl input{color:#949494!important}:host[data-disabled] ::ng-deep .floatingLabelControl span{cursor:initial}:host[data-disabled] ::ng-deep .floatingLabelControl span .k-icon{color:#ccc!important}:host[data-error] ::ng-deep .floatingLabelControl{border-bottom:1px solid #FB7E5D}:host[data-error] ::ng-deep .floatingLabelControl label{color:#fb7e5d}:host[data-error][data-focused] ::ng-deep .floatingLabelControl{border-bottom:1px solid #ea1b2d}:host[data-error][data-focused] ::ng-deep .floatingLabelControl label{color:#ea1b2d}\n"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { _placeholderLayout: [{
            type: ViewChild,
            args: ['placeholderLayout', { static: true }]
        }], _labelLayout: [{
            type: ViewChild,
            args: ['labelLayout', { static: true }]
        }], _model: [{
            type: ContentChild,
            args: [NgModel, { static: true }]
        }], _input: [{
            type: ContentChild,
            args: [ReadonlyFocusableInput, { static: true }]
        }], mandatoryMessage: [{
            type: Input
        }], isFocused: [{
            type: HostBinding,
            args: ['attr.data-focused']
        }], isReadOnly: [{
            type: HostBinding,
            args: ['attr.data-readonly']
        }], isDisabled: [{
            type: HostBinding,
            args: ['attr.data-disabled']
        }], hasModelErrors: [{
            type: HostBinding,
            args: ['attr.data-error']
        }], label: [{
            type: Input
        }], placeHolder: [{
            type: Input
        }], infoMessage: [{
            type: Input
        }], errorMessages: [{
            type: Input
        }], fixedLabel: [{
            type: Input
        }], readonly: [{
            type: Input
        }] }); })();

class FloatingLabelModule {
}
FloatingLabelModule.ɵfac = function FloatingLabelModule_Factory(t) { return new (t || FloatingLabelModule)(); };
FloatingLabelModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: FloatingLabelModule });
FloatingLabelModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            IconModule,
            TooltipModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FloatingLabelModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    IconModule,
                    TooltipModule
                ],
                declarations: [
                    FloatingLabelComponent
                ],
                exports: [
                    FloatingLabelComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FloatingLabelModule, { declarations: function () { return [FloatingLabelComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        IconModule,
        TooltipModule]; }, exports: function () { return [FloatingLabelComponent]; } }); })();

/**
 * Este componente se utiliza para la declaración de inputs de tipo Dropdown
 *
 * - ngModel es el campo donde se indicará el valor seleccionado. Si valueField es null, guarda el objeto completo. Si valueField
 *   indica una propiedad del objeto, se guardará únicamente la propiedad de dicho objeto
 * - data contiene el listado de objetos que se mostrarán al desplegar el Dropdown
 * - displayField es el nombre que se mostrarán en cada una de las opciones del Dropdown. Suele ser una propiedad del objeto
 * - valueField es el valor que se guardará en la variable que se indique en ngModel. Si es null, se guardará el objeto completo
 *
 * @example
 * <ngwk-dropdown-list [(ngModel)]="dropDownSelectedValue" [data]="data" [displayField]="'displayField'" [valueField]="'valueField'"></ngwk-dropdown-list>
 */
class DropDownListComponent extends ReadonlyFocusableInput {
    /**@ignore */
    constructor() {
        super();
        /** Permite definir el valor de la propiedad 'data' */
        this.data = null;
        /** Permite definir el valor de la propiedad 'displayField' */
        this.displayField = null;
        /** Permite definir el valor de la propiedad 'valueField' */
        this.valueField = '';
        /** Permite definir el template del del item seleccionado */
        this.selectedItemTemplate = null;
        /** Permite definir el template de los items a seleccionar */
        this.listTemplate = null;
        /** Permite definir la altura del desplegable del DropDown */
        this.popupHeight = 200;
        /** Deprecated */
        this.listHeight = 200;
        /** Permite definir el método que deshabilita o habilita los items del desplegable del DropDown */
        this.itemDisabled = () => false;
        /** @ignore */
        this.popupSettings = { width: 'auto' };
    }
    /**@ignore */
    get inputFocus() {
        return this._dropdownlist;
    }
    /** @ignore */
    getPopupHeight() {
        return this.popupHeight !== 200 ? this.popupHeight : this.listHeight;
    }
    /** @ignore */
    getItem(item) {
        if (item) {
            return item;
        }
    }
    /** Permite obtener el actual valor de la propiedad 'appendTo' del componente DropDownListComponent */
    get popupAppendTo() {
        return this.popupSettings.appendTo;
    }
    /**
     * Permite definir donde se situa el popup del DropDownListComponent dentro de la DOM.
     * @param value Nuevo valor para la propiedad 'popupAppendTo'
     */
    set popupAppendTo(value) {
        this.popupSettings.appendTo = value;
    }
    /** Permite obtener el actual valor de la propiedad 'popupClass' del componente DropDownListComponent */
    get popupClass() {
        return this.popupSettings.popupClass;
    }
    /**
     * Permite definir classes que se aplicaran al desplegable del DropDownListComponent.
     * @param value Nuevo valor para la propiedad 'popupClass'
     */
    set popupClass(value) {
        this.popupSettings.popupClass = value;
    }
    /**
     * Permite obtener el ancho del desplegable del DropDown
     *
     * @return
     */
    get popupWidth() {
        return this.popupSettings.width;
    }
    /**
     * Permite definir el ancho del desplegable del DropDown
     *
     * @param value Nuevo valor para el ancho del desplegable del DropDown
     * @return
     */
    set popupWidth(value) {
        this.popupSettings.width = value;
    }
    /**
     * Devuelve true si el componente DropDownListComponent tiene definido el campo valueField, para guardar únicamente
     * la propiedad del objeto indicado en valueField o bien el objeto entero
     */
    get hasValueFieldDefined() {
        const result = this.valueField ? true : false;
        return result;
    }
}
DropDownListComponent.ɵfac = function DropDownListComponent_Factory(t) { return new (t || DropDownListComponent)(); };
DropDownListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DropDownListComponent, selectors: [["ngwk-dropdown-list"]], viewQuery: function DropDownListComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c6, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._dropdownlist = _t.first);
    } }, inputs: { data: "data", displayField: "displayField", valueField: "valueField", selectedItemTemplate: "selectedItemTemplate", listTemplate: "listTemplate", popupHeight: "popupHeight", listHeight: "listHeight", itemDisabled: "itemDisabled", popupAppendTo: "popupAppendTo", popupClass: "popupClass", popupWidth: "popupWidth" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DropDownListComponent),
                multi: true
            },
            {
                provide: ReadonlyFocusableInput,
                useExisting: forwardRef(() => DropDownListComponent),
                multi: true
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 8, vars: 10, consts: [[3, "ngModel", "data", "textField", "valueField", "valuePrimitive", "popupSettings", "disabled", "itemDisabled", "listHeight", "readonly", "ngModelChange", "blur", "focus"], ["dropdownlist", ""], ["kendoDropDownListValueTemplate", ""], ["kendoDropDownListItemTemplate", ""], ["defaultSelectedItemTemplate", ""], ["defaultListTemplate", ""], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [4, "ngIf"]], template: function DropDownListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "kendo-dropdownlist", 0, 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function DropDownListComponent_Template_kendo_dropdownlist_ngModelChange_0_listener($event) { return ctx.internalValue = $event; })("blur", function DropDownListComponent_Template_kendo_dropdownlist_blur_0_listener() { return ctx.onBlur(); })("focus", function DropDownListComponent_Template_kendo_dropdownlist_focus_0_listener() { return ctx.onFocus(); });
        ɵngcc0.ɵɵtemplate(2, DropDownListComponent_ng_template_2_Template, 1, 4, "ng-template", 2);
        ɵngcc0.ɵɵtemplate(3, DropDownListComponent_ng_template_3_Template, 1, 4, "ng-template", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, DropDownListComponent_ng_template_4_Template, 1, 1, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(6, DropDownListComponent_ng_template_6_Template, 1, 1, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngModel", ctx.internalValue)("data", ctx.data)("textField", ctx.displayField)("valueField", ctx.valueField)("valuePrimitive", ctx.hasValueFieldDefined)("popupSettings", ctx.popupSettings)("disabled", ctx.disabled)("itemDisabled", ctx.itemDisabled)("listHeight", ctx.getPopupHeight())("readonly", ctx.readonly);
    } }, directives: [ɵngcc7.DropDownListComponent, ɵngcc1.NgControlStatus, ɵngcc1.NgModel, ɵngcc7.ValueTemplateDirective, ɵngcc7.ItemTemplateDirective, ɵngcc4.NgTemplateOutlet, ɵngcc4.NgIf], styles: [".inputLabelContent[_nghost-%COMP%]     kendo-dropdownlist, .inputLabelContent   [_nghost-%COMP%]     kendo-dropdownlist{width:100%;user-select:none;font-size:13px}.inputLabelContent[_nghost-%COMP%]     kendo-dropdownlist span, .inputLabelContent   [_nghost-%COMP%]     kendo-dropdownlist span{color:#373737!important;background-color:transparent;border:none;background-color:transparent!important;background-image:none!important}.inputLabelContent[_nghost-%COMP%]     kendo-dropdownlist span span.k-select, .inputLabelContent   [_nghost-%COMP%]     kendo-dropdownlist span span.k-select{width:auto;padding:4px}.inputLabelContent[_nghost-%COMP%]     kendo-dropdownlist span:hover, .inputLabelContent   [_nghost-%COMP%]     kendo-dropdownlist span:hover{color:#333!important}.inputLabelContent[_nghost-%COMP%]     kendo-dropdownlist span:focus, .inputLabelContent   [_nghost-%COMP%]     kendo-dropdownlist span:focus{border:none!important;background-color:transparent!important;box-shadow:0 0!important;color:#3390ff!important}.inputLabelContent[_nghost-%COMP%]     kendo-dropdownlist span.k-state-focused .k-input::selection, .inputLabelContent   [_nghost-%COMP%]     kendo-dropdownlist span.k-state-focused .k-input::selection{background-color:#3390ff!important}.inputLabelContent[_nghost-%COMP%]     kendo-dropdownlist span .k-input, .inputLabelContent   [_nghost-%COMP%]     kendo-dropdownlist span .k-input{cursor:default;user-select:text;padding:4px!important}.inputLabelContent[_nghost-%COMP%]     kendo-dropdownlist span .k-input::selection, .inputLabelContent   [_nghost-%COMP%]     kendo-dropdownlist span .k-input::selection{background:#3390FF}.inputLabelContent[_nghost-%COMP%]     kendo-dropdownlist .k-state-focused span div, .inputLabelContent   [_nghost-%COMP%]     kendo-dropdownlist .k-state-focused span div{color:#fff!important;background-color:#3390ff!important}"] });
/** @nocollapse */
DropDownListComponent.ctorParameters = () => [];
DropDownListComponent.propDecorators = {
    data: [{ type: Input }],
    displayField: [{ type: Input }],
    valueField: [{ type: Input }],
    selectedItemTemplate: [{ type: Input }],
    listTemplate: [{ type: Input }],
    popupHeight: [{ type: Input }],
    listHeight: [{ type: Input }],
    itemDisabled: [{ type: Input }],
    _dropdownlist: [{ type: ViewChild, args: ['dropdownlist', { static: true },] }],
    popupAppendTo: [{ type: Input }],
    popupClass: [{ type: Input }],
    popupWidth: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DropDownListComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-dropdown-list',
                template: "<kendo-dropdownlist #dropdownlist\r\n    [(ngModel)]=\"internalValue\"\r\n    [data]=\"data\"\r\n    [textField]=\"displayField\"\r\n    [valueField]=\"valueField\"\r\n    [valuePrimitive]=\"hasValueFieldDefined\"\r\n    [popupSettings]=\"popupSettings\"\r\n    [disabled]=\"disabled\"\r\n    [itemDisabled]=\"itemDisabled\"\r\n    [listHeight]=\"getPopupHeight()\"\r\n    (blur)=\"onBlur()\"\r\n    (focus)=\"onFocus()\"\r\n    [readonly]=\"readonly\">\r\n    <ng-template kendoDropDownListValueTemplate let-dataItem>\r\n        <ng-container\r\n            *ngTemplateOutlet=\"selectedItemTemplate || defaultSelectedItemTemplate; context: { item: getItem(dataItem) }\">\r\n        </ng-container>\r\n    </ng-template>\r\n    <ng-template kendoDropDownListItemTemplate let-dataItem>\r\n        <ng-container\r\n            *ngTemplateOutlet=\"listTemplate || defaultListTemplate; context: { item: getItem(dataItem) }\">\r\n        </ng-container>\r\n    </ng-template>\r\n</kendo-dropdownlist>\r\n\r\n<ng-template #defaultSelectedItemTemplate let-item=\"item\">\r\n    <div *ngIf=\"item\">\r\n        {{item[displayField]}}\r\n    </div>\r\n</ng-template>\r\n\r\n<ng-template #defaultListTemplate let-item=\"item\">\r\n    <div *ngIf=\"item\">\r\n        {{item[displayField]}}\r\n    </div>\r\n</ng-template>",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DropDownListComponent),
                        multi: true
                    },
                    {
                        provide: ReadonlyFocusableInput,
                        useExisting: forwardRef(() => DropDownListComponent),
                        multi: true
                    }
                ],
                styles: [":host-context(.inputLabelContent) ::ng-deep kendo-dropdownlist{width:100%;user-select:none;font-size:13px}:host-context(.inputLabelContent) ::ng-deep kendo-dropdownlist span{color:#373737!important;background-color:transparent;border:none;background-color:transparent!important;background-image:none!important}:host-context(.inputLabelContent) ::ng-deep kendo-dropdownlist span span.k-select{width:auto;padding:4px}:host-context(.inputLabelContent) ::ng-deep kendo-dropdownlist span:hover{color:#333!important}:host-context(.inputLabelContent) ::ng-deep kendo-dropdownlist span:focus{border:none!important;background-color:transparent!important;box-shadow:0 0!important;color:#3390ff!important}:host-context(.inputLabelContent) ::ng-deep kendo-dropdownlist span.k-state-focused .k-input::selection{background-color:#3390ff!important}:host-context(.inputLabelContent) ::ng-deep kendo-dropdownlist span .k-input{cursor:default;user-select:text;padding:4px!important}:host-context(.inputLabelContent) ::ng-deep kendo-dropdownlist span .k-input::selection{background:#3390FF}:host-context(.inputLabelContent) ::ng-deep kendo-dropdownlist .k-state-focused span div{color:#fff!important;background-color:#3390ff!important}\n"]
            }]
    }], function () { return []; }, { data: [{
            type: Input
        }], displayField: [{
            type: Input
        }], valueField: [{
            type: Input
        }], selectedItemTemplate: [{
            type: Input
        }], listTemplate: [{
            type: Input
        }], popupHeight: [{
            type: Input
        }], listHeight: [{
            type: Input
        }], itemDisabled: [{
            type: Input
        }], popupAppendTo: [{
            type: Input
        }], popupClass: [{
            type: Input
        }], popupWidth: [{
            type: Input
        }], _dropdownlist: [{
            type: ViewChild,
            args: ['dropdownlist', { static: true }]
        }] }); })();

class DropDownListModule {
}
DropDownListModule.ɵfac = function DropDownListModule_Factory(t) { return new (t || DropDownListModule)(); };
DropDownListModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DropDownListModule });
DropDownListModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            DropDownListModule$1,
            CommonModule,
            FormsModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DropDownListModule, [{
        type: NgModule,
        args: [{
                imports: [
                    DropDownListModule$1,
                    CommonModule,
                    FormsModule
                ],
                exports: [
                    DropDownListComponent
                ],
                declarations: [
                    DropDownListComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DropDownListModule, { declarations: function () { return [DropDownListComponent]; }, imports: function () { return [DropDownListModule$1,
        CommonModule,
        FormsModule]; }, exports: function () { return [DropDownListComponent]; } }); })();

/**
 * Este componente se utiliza para la declaración de un input de tipo TextArea
 *
 * @example
 * <ngwk-textarea-box
 *  [(ngModel)]="textAreaValue">
 * </ngwk-textarea-box>
 *
 */
class TextareaBoxComponent extends ReadonlyFocusableInput {
    /** @ignore */
    constructor(_el, _renderer) {
        super();
        this._el = _el;
        this._renderer = _renderer;
        this._maxlength = null;
        this._maxHeight = 100;
        this._minHeight = 0;
    }
    /** @ignore */
    get inputFocus() {
        return this._textarea.nativeElement;
    }
    /**
     * Permite obtener la longitud máxima en carácteres del TextArea
     */
    get maxlength() {
        return this._maxlength;
    }
    /**
     * Permite definir la longitud máxima en carácteres del TextArea
     *
     * @param value La longitud máxima en carácteres
     */
    set maxlength(value) {
        this._maxlength = value;
    }
    /**
     * Permite obtener la altura mínima del TextArea
     */
    get minHeight() {
        return this._minHeight;
    }
    /**
     * Permite definir la altura mínima del TextArea
     *
     * @param value La altura mínima
     */
    set minHeight(value) {
        this._minHeight = value;
    }
    /**
     * Permite obtener la altura máxima del TextArea
     */
    get maxHeight() {
        return this._maxHeight;
    }
    /**
     * Permite definir la altura máxima del TextArea
     *
     * @param value La altura máxima
     */
    set maxHeight(value) {
        this._maxHeight = value;
    }
}
TextareaBoxComponent.ɵfac = function TextareaBoxComponent_Factory(t) { return new (t || TextareaBoxComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
TextareaBoxComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TextareaBoxComponent, selectors: [["ngwk-textarea-box"]], viewQuery: function TextareaBoxComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c8, 7, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._textarea = _t.first);
    } }, inputs: { maxlength: "maxlength", minHeight: "minHeight", maxHeight: "maxHeight" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => TextareaBoxComponent),
                multi: true
            },
            {
                provide: ReadonlyFocusableInput,
                useExisting: forwardRef(() => TextareaBoxComponent),
                multi: true
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 6, consts: [["autosize", "", 3, "ngModel", "maxHeight", "minHeight", "maxlength", "readonly", "disabled", "ngModelChange", "blur", "focus"], ["textarea", ""]], template: function TextareaBoxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "textarea", 0, 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function TextareaBoxComponent_Template_textarea_ngModelChange_0_listener($event) { return ctx.internalValue = $event; })("blur", function TextareaBoxComponent_Template_textarea_blur_0_listener() { return ctx.onBlur(); })("focus", function TextareaBoxComponent_Template_textarea_focus_0_listener() { return ctx.onFocus(); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngModel", ctx.internalValue)("maxHeight", ctx.maxHeight)("minHeight", ctx.minHeight)("maxlength", ctx.maxlength)("readonly", ctx.readonly)("disabled", ctx.disabled);
    } }, directives: function () { return [TextareaAutosizeDirective, ɵngcc1.DefaultValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.NgModel, ɵngcc1.MaxLengthValidator]; }, styles: [".floatingLabelControl[_nghost-%COMP%]     textarea, .floatingLabelControl   [_nghost-%COMP%]     textarea{margin-bottom:2px}"] });
/** @nocollapse */
TextareaBoxComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
TextareaBoxComponent.propDecorators = {
    _textarea: [{ type: ViewChild, args: ['textarea', { read: ElementRef, static: true },] }],
    maxlength: [{ type: Input }],
    minHeight: [{ type: Input }],
    maxHeight: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TextareaBoxComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-textarea-box',
                template: "<textarea\r\n    #textarea\r\n    autosize\r\n    [(ngModel)]=\"internalValue\"\r\n    [maxHeight]=\"maxHeight\"\r\n    [minHeight]=\"minHeight\"\r\n    [maxlength]=\"maxlength\"\r\n    [readonly]=\"readonly\"\r\n    [disabled]=\"disabled\"\r\n    (blur)=\"onBlur()\"\r\n    (focus)=\"onFocus()\" >\r\n</textarea>\r\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => TextareaBoxComponent),
                        multi: true
                    },
                    {
                        provide: ReadonlyFocusableInput,
                        useExisting: forwardRef(() => TextareaBoxComponent),
                        multi: true
                    }
                ],
                styles: [":host-context(.floatingLabelControl) ::ng-deep textarea{margin-bottom:2px}\n"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { maxlength: [{
            type: Input
        }], minHeight: [{
            type: Input
        }], maxHeight: [{
            type: Input
        }], _textarea: [{
            type: ViewChild,
            args: ['textarea', { read: ElementRef, static: true }]
        }] }); })();

/** @ignore */
class TextareaAutosizeDirective {
    /** @ignore */
    constructor(_elementRef) {
        this._elementRef = _elementRef;
        this._htmlTextAreaElement = _elementRef.nativeElement;
        this._clientWidth = this._htmlTextAreaElement.clientWidth;
    }
    ngAfterViewInit() {
        // set element resize allowed manually by user
        let style = window.getComputedStyle(this._htmlTextAreaElement, null);
        if (style.resize === 'both') {
            this._htmlTextAreaElement.style.resize = 'horizontal';
        }
        else if (style.resize === 'vertical') {
            this._htmlTextAreaElement.style.resize = 'none';
        }
        // run first adjust
        setTimeout(() => this.adjust());
    }
    /** @ignore */
    onResize() {
        // Only apply adjustment if element width had changed.
        if (this._htmlTextAreaElement.clientWidth === this._clientWidth) {
            return;
        }
        ;
        this._clientWidth = this._elementRef.nativeElement.clientWidth;
        this.adjust();
    }
    /** @ignore */
    onInput() {
        this.adjust();
    }
    /** @ignore */
    adjust() {
        // perform height adjustments after input changes, if height is different
        if (this._htmlTextAreaElement.style.height == this._elementRef.nativeElement.scrollHeight + 'px') {
            return;
        }
        this._htmlTextAreaElement.style.height = 'auto';
        this._htmlTextAreaElement.style.height = this._htmlTextAreaElement.scrollHeight + 'px';
        if (parseFloat(this._htmlTextAreaElement.style.height) > parseFloat(this._htmlTextAreaElement.style.maxHeight)) {
            this._htmlTextAreaElement.style.overflow = 'auto';
        }
        else {
            this._htmlTextAreaElement.style.overflow = 'hidden';
        }
    }
    /** @ignore */
    updateMinHeight() {
        // Set textarea min height if input defined
        this._htmlTextAreaElement.style.minHeight = this._minHeight + 'px';
    }
    /** @ignore */
    updateMaxHeight() {
        // Set textarea max height if input defined
        this._htmlTextAreaElement.style.maxHeight = this._maxHeight + 'px';
    }
    /** @ignore */
    get minHeight() {
        return this._minHeight;
    }
    /** @ignore */
    set minHeight(val) {
        this._minHeight = val;
        this.updateMinHeight();
    }
    /** @ignore */
    get maxHeight() {
        return this._maxHeight;
    }
    /** @ignore */
    set maxHeight(val) {
        this._maxHeight = val;
        this.updateMaxHeight();
    }
}
TextareaAutosizeDirective.ɵfac = function TextareaAutosizeDirective_Factory(t) { return new (t || TextareaAutosizeDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
TextareaAutosizeDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TextareaAutosizeDirective, selectors: [["textarea", "autosize", ""]], hostBindings: function TextareaAutosizeDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function TextareaAutosizeDirective_resize_HostBindingHandler() { return ctx.onResize(); }, false, ɵngcc0.ɵɵresolveWindow)("input", function TextareaAutosizeDirective_input_HostBindingHandler() { return ctx.onInput(); });
    } }, inputs: { minHeight: "minHeight", maxHeight: "maxHeight" } });
/** @nocollapse */
TextareaAutosizeDirective.ctorParameters = () => [
    { type: ElementRef }
];
TextareaAutosizeDirective.propDecorators = {
    onResize: [{ type: HostListener, args: ['window:resize',] }],
    onInput: [{ type: HostListener, args: ['input',] }],
    minHeight: [{ type: Input }],
    maxHeight: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TextareaAutosizeDirective, [{
        type: Directive,
        args: [{
                selector: 'textarea[autosize]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { 
    /** @ignore */
    onResize: [{
            type: HostListener,
            args: ['window:resize']
        }], 
    /** @ignore */
    onInput: [{
            type: HostListener,
            args: ['input']
        }], minHeight: [{
            type: Input
        }], maxHeight: [{
            type: Input
        }] }); })();

class TextareaBoxModule {
}
TextareaBoxModule.ɵfac = function TextareaBoxModule_Factory(t) { return new (t || TextareaBoxModule)(); };
TextareaBoxModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TextareaBoxModule });
TextareaBoxModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            FormsModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TextareaBoxModule, [{
        type: NgModule,
        args: [{
                imports: [
                    FormsModule
                ],
                exports: [
                    TextareaBoxComponent
                ],
                declarations: [
                    TextareaBoxComponent,
                    TextareaAutosizeDirective
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TextareaBoxModule, { declarations: function () { return [TextareaBoxComponent, TextareaAutosizeDirective]; }, imports: function () { return [FormsModule]; }, exports: function () { return [TextareaBoxComponent]; } }); })();

/**
 * Este componente se utiliza para la declaración de inputs de tipo Autocomplete
 *
 * @example
 * <ngwk-autocomplete
 *   [(ngModel)]="value"
 *   [itemTemplate]="itemTemplate"
 *   [placeholder]="placeholder"
 *   [data]="data"
 *   [displayField]="displayField"
 *   [valueField]="valueField"
 *   (filter)="search($event)">
 * </ngwk-autocomplete>
 *
 */
class AutocompleteComponent extends ReadonlyFocusableInput {
    /**@ignore */
    constructor(_elRef) {
        super();
        this._elRef = _elRef;
        /** Permite definir el campo de tipo string que se mostrará de cada uno de los objetos que se hayan filtrado en el desplegable del autocomplete */
        this.displayField = null;
        /** Permite definir el campo por el cual se buscará a la hora de escribir en el autocomplete */
        this.valueField = null;
        /** Permite definir el mínimo de carácteres que se deben escribir en el autocomplete para realizar un filtro de la búsqueda */
        this.searchMinLength = 3;
        /** Permite activar o desactivar la opción de permitir valores nuevos en los autocomplete a parte de los definidos extrictamente en 'data'. De manera predeterminada está a 'false'. */
        this.allowNewValues = false;
        /** Permite activar o desactivar la opción de seleccionar el primer valor sugerido en el PopUp. De manera predeterminada está activado. */
        this.selectFirstItem = true;
        /** Permite definir una template custom para el Popup del autocomplete */
        this.itemTemplate = null;
        /** Permite informar un texto cuando no hay nada informado en el autocomplete */
        this.placeholder = null;
        /** Permite definir la altura del desplegable del Autocomplete */
        this.popupHeight = 200;
        /** Deprecated */
        this.listHeight = 200;
        /** Evento que permite informar de cuando se ha realizado una búsqueda en el autocomplete y se ha filtrado por un valor en concreto */
        this.filterEvent = new EventEmitter();
        /** Evento que informa cuando el campo de autocomplete ha quedado vacío */
        this.clear = new EventEmitter();
        /** @ignore */
        this.valueNormalizer = (text) => this.onValueNormalizer(text);
        /** @ignore */
        this.popupSettings = { width: 'auto' };
        this._allData = [];
        this._filteredData = [];
        this._isOpen = false;
        this._navigationSelectedValue = null;
        this._isAlive = true;
    }
    ngAfterViewInit() {
        this._comboboxInput.filterChange.pipe(filter((searchValue) => this.hasTextMinSearchLength(searchValue)), debounceTime(300), takeWhile(() => this._isAlive))
            .subscribe((searchValue) => {
            this.search(searchValue);
        });
        this._comboboxInput.filterChange.pipe(filter((searchValue) => !this.hasTextMinSearchLength(searchValue)), takeWhile(() => this._isAlive))
            .subscribe(() => {
            this.filteredData = [];
            this.isOpen = false;
        });
        this._comboboxInput.filterChange.pipe(filter((searchValue) => !this.hasSearchText(searchValue)), takeWhile(() => this._isAlive))
            .subscribe(() => {
            this.internalValue = null;
            this.clear.emit();
        });
        this._comboboxInput.selectionChange.pipe(takeWhile(() => this._isAlive))
            .subscribe((selectedValue) => {
            this._navigationSelectedValue = selectedValue;
        });
        this._comboboxInput.open.pipe(takeWhile(() => this._isAlive))
            .subscribe((event) => {
            event.preventDefault();
        });
        if (this.itemTemplate) {
            this._comboboxInput.template = new ItemTemplateDirective(this.itemTemplate);
        }
    }
    ngOnDestroy() {
        this._isAlive = false;
    }
    /** @ignore */
    getPopupHeight() {
        return this.popupHeight !== 200 ? this.popupHeight : this.listHeight;
    }
    /** @ignore */
    isPopupOpen() {
        return this._comboboxInput.isOpen;
    }
    /** @ignore */
    getTooltip() {
        return this.internalValue ? this.internalValue[this.displayField] : null;
    }
    /** @ignore */
    isTooltipDisabled() {
        if (this.internalValue) {
            // Width of the display text
            const textWidth = this.getTextWidth(this.internalValue[this.displayField]);
            // Width of the Input
            const comboboxInputElement = this._elRef.nativeElement.getElementsByClassName('k-input').item(0);
            const comboboxInputComputedStyle = getComputedStyle(comboboxInputElement);
            const inputWidth = comboboxInputElement.clientWidth - (parseFloat(comboboxInputComputedStyle.paddingLeft) + parseFloat(comboboxInputComputedStyle.paddingRight));
            return textWidth < inputWidth;
        }
        return true;
    }
    setFocusOnFirstItemOfSuggestions() {
        setTimeout(() => {
            if (this._comboboxInput.optionsList)
                this._comboboxInput.optionsList.selectionService.focus(0);
        });
    }
    onValueNormalizer(text) {
        return text.pipe(map((text) => this.normalizeObject(text)));
    }
    normalizeObject(text) {
        if (!this.internalValue || this.internalValue[this.displayField] !== text) {
            if (this.filteredData && this.filteredData.length > 0 && !this._navigationSelectedValue && this.hasSearchText(text) && this.selectFirstItem) {
                this._comboboxInput.text = this.filteredData[0][this.displayField];
                return this.filteredData[0];
            }
            else if (this.allowNewValues && text) {
                let result = {};
                Reflection.setPropertyValue(result, this.valueField, null);
                Reflection.setPropertyValue(result, this.displayField, text);
                return result;
            }
            else {
                this._comboboxInput.text = '';
                return null;
            }
        }
        return this.internalValue;
    }
    getTextWidth(text) {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        const element = this._elRef.nativeElement.getElementsByClassName('k-input').item(0);
        context.font = getComputedStyle(element).font;
        return context.measureText(text).width;
    }
    /**@ignore */
    writeValue(value) {
        super.writeValue(value);
    }
    /**@ignore */
    _focus() {
        this._comboboxInput.focus();
    }
    search(searchValue) {
        if (this.isBuiltInSearch) {
            const resultSearch = this.searchOnData(searchValue);
            if (!this.isEqualByValueField(resultSearch)) {
                this.filteredData = resultSearch;
            }
        }
        else {
            this.filterEvent.emit(searchValue);
        }
    }
    searchOnData(filterValue) {
        let result = null;
        const contains = (value) => (s) => (this.getDisplayValue(s))
            .toLowerCase()
            .indexOf(value.toLowerCase()) !== -1;
        if (this.data) {
            result = this.data.filter(contains(filterValue));
        }
        return result;
    }
    isEqualByValueField(items) {
        if (!items || items.length !== this.filteredData.length) {
            return false;
        }
        for (let i = 0; i < this.filteredData.length; ++i) {
            if (items[i][this.valueField] !== this.filteredData[i][this.valueField]) {
                return false;
            }
        }
        return true;
    }
    manageSuggestionsList() {
        if (this.isFocused &&
            !this._comboboxInput.isOpen &&
            this.hasTextMinSearchLength(this._comboboxInput.text)) {
            this.isOpen = true;
        }
    }
    getDisplayValue(item) {
        return this.displayField ? Reflection.getPropertyValue(item, this.displayField) : item;
    }
    hasTextMinSearchLength(text) {
        return text && text.length >= this.searchMinLength;
    }
    hasSearchText(text) {
        return text && text.length > 0;
    }
    /**@ignore */
    onBlur() {
        this.isOpen = false;
        super.onBlur();
    }
    //#region Properties
    /**@ignore */
    get inputFocus() {
        return this._comboboxInput;
    }
    /**
     * Permite obtener toda los datos definidos en el autocomplete
     *
     * @return
     */
    get data() {
        return this._allData;
    }
    /**
      * Permite definir los datos del autocomplete
      *
      * @param value Los datos a añadir en el autocomplete
      * @return
      */
    set data(value) {
        this._allData = value;
        if (!this.isBuiltInSearch && this.isFocused) {
            this.filteredData = this.isEqualByValueField(value) ? this.filteredData : value;
        }
    }
    /**
     * Permite obtener el actual valor de la propiedad 'appendTo' del componente AutoComplete
     *
     * @return
     */
    get popupAppendTo() {
        return this.popupSettings.appendTo;
    }
    /**
     * Permite definir donde se situa el popup del AutoComplete dentro de la DOM.
     *
     * @param value Nuevo valor para la propiedad 'popupAppendTo'
     * @return
     */
    set popupAppendTo(value) {
        this.popupSettings.appendTo = value;
    }
    /**
     * Permite obtener el actual valor de la propiedad 'popupClass' del componente AutoComplete
     *
     * @return
     */
    get popupClass() {
        return this.popupSettings.popupClass;
    }
    /**
     * Permite definir classes que se aplicaran al desplegable del AutoComplete.
     *
     * @param value Nuevo valor para la propiedad 'popupClass'
     * @return
     */
    set popupClass(value) {
        this.popupSettings.popupClass = value;
    }
    /**
     * Permite obtener el ancho del desplegable del Autocomplete
     *
     * @return
     */
    get popupWidth() {
        return this.popupSettings.width;
    }
    /**
     * Permite definir el ancho del desplegable del Autocomplete
     *
     * @param value Nuevo valor para el ancho del desplegable del Autocomplete
     * @return
     */
    set popupWidth(value) {
        this.popupSettings.width = value;
    }
    /** @ignore */
    get filteredData() {
        return this._filteredData;
    }
    /**@ignore */
    set filteredData(value) {
        this._filteredData = value;
        this.manageSuggestionsList();
        if (this.selectFirstItem) {
            this.setFocusOnFirstItemOfSuggestions();
        }
    }
    /**@ignore */
    get isBuiltInSearch() {
        return this.filterEvent.observers.length === 0;
    }
    /**@ignore */
    get isOpen() {
        return this._isOpen || this._comboboxInput.isOpen;
    }
    /**@ignore */
    set isOpen(value) {
        this._comboboxInput.toggle(value);
        this._isOpen = value;
        if (this._isOpen) {
            this._navigationSelectedValue = null;
            const interval = setInterval(() => {
                if (this._comboboxInput.optionsList) {
                    clearInterval(interval);
                    if (this.selectFirstItem) {
                        this.setFocusOnFirstItemOfSuggestions();
                    }
                }
            }, 40);
        }
    }
}
AutocompleteComponent.ɵfac = function AutocompleteComponent_Factory(t) { return new (t || AutocompleteComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
AutocompleteComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AutocompleteComponent, selectors: [["ngwk-autocomplete"]], viewQuery: function AutocompleteComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c9, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._comboboxInput = _t.first);
    } }, inputs: { displayField: "displayField", valueField: "valueField", searchMinLength: "searchMinLength", allowNewValues: "allowNewValues", selectFirstItem: "selectFirstItem", itemTemplate: "itemTemplate", placeholder: "placeholder", popupHeight: "popupHeight", listHeight: "listHeight", data: "data", popupAppendTo: "popupAppendTo", popupClass: "popupClass", popupWidth: "popupWidth" }, outputs: { filterEvent: "filter", clear: "clear" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => AutocompleteComponent),
                multi: true
            },
            {
                provide: ReadonlyFocusableInput,
                useExisting: forwardRef(() => AutocompleteComponent),
                multi: true
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 13, consts: [["clearbutton", "false", "filterable", "true", "allowCustom", "true", "ngwkTooltipPosition", "top-left", 3, "placeholder", "suggest", "ngModel", "valueNormalizer", "data", "textField", "valueField", "readonly", "popupSettings", "listHeight", "ngwkTooltip", "ngwkTooltipDisable", "disabled", "ngModelChange", "blur", "focus"], ["autocomplete", ""], ["clearTitle", ""], ["kendoComboBoxNoDataTemplate", ""]], template: function AutocompleteComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "kendo-combobox", 0, 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function AutocompleteComponent_Template_kendo_combobox_ngModelChange_0_listener($event) { return ctx.internalValue = $event; })("blur", function AutocompleteComponent_Template_kendo_combobox_blur_0_listener() { return ctx.onBlur(); })("focus", function AutocompleteComponent_Template_kendo_combobox_focus_0_listener() { return ctx.onFocus(); });
        ɵngcc0.ɵɵelement(2, "kendo-combobox-messages", 2);
        ɵngcc0.ɵɵtemplate(3, AutocompleteComponent_ng_template_3_Template, 3, 3, "ng-template", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("placeholder", ctx.placeholder)("suggest", ctx.selectFirstItem)("ngModel", ctx.internalValue)("valueNormalizer", ctx.valueNormalizer)("data", ctx.filteredData)("textField", ctx.displayField)("valueField", ctx.valueField)("readonly", ctx.readonly)("popupSettings", ctx.popupSettings)("listHeight", ctx.getPopupHeight())("ngwkTooltip", ctx.getTooltip())("ngwkTooltipDisable", ctx.isTooltipDisabled())("disabled", ctx.disabled);
    } }, directives: [ɵngcc7.ComboBoxComponent, ɵngcc1.NgControlStatus, ɵngcc1.NgModel, ɵngcc2.NgwkTooltipDirective, ɵngcc7.CustomMessagesComponent, ɵngcc7.NoDataTemplateDirective], pipes: [ɵngcc2.LocalePipe], styles: ["[_nghost-%COMP%]    {border:none!important;width:100%!important;font-size:13px!important;background-color:transparent!important}[_nghost-%COMP%]     ngwk-autocomplete input{padding-right:17px!important}[_nghost-%COMP%]     nwgk-f2-box .k-i-close{right:0px}[_nghost-%COMP%]     .k-combobox-clearable .k-input{padding-right:24px!important}[_nghost-%COMP%]     .k-state-focused{border-color:#3390ff!important;box-shadow:none!important;background-color:transparent!important}[_nghost-%COMP%]     input::selection{background-color:#3390ff!important}[_nghost-%COMP%]     span.k-select{display:none!important}[_nghost-%COMP%]     .k-combobox{width:100%}[_nghost-%COMP%]     .k-combobox .k-dropdown-wrap{border-color:transparent!important;background-color:transparent;height:29px}[_nghost-%COMP%]     .k-combobox .k-dropdown-wrap .k-i-close{right:5px}[_nghost-%COMP%]     .k-combobox .k-dropdown-wrap .k-clear-value{bottom:4px}[_nghost-%COMP%]     .k-combobox .k-state-focused{box-shadow:none!important}.floatingLabelControl[_nghost-%COMP%]     .k-combobox span, .floatingLabelControl   [_nghost-%COMP%]     .k-combobox span{box-shadow:0 0!important;border:transparent!important}.floatingLabelControl[_nghost-%COMP%]     .k-combobox span .k-state-focused, .floatingLabelControl   [_nghost-%COMP%]     .k-combobox span .k-state-focused{border:transparent;box-shadow:0 0!important}"] });
/** @nocollapse */
AutocompleteComponent.ctorParameters = () => [
    { type: ElementRef }
];
AutocompleteComponent.propDecorators = {
    displayField: [{ type: Input }],
    valueField: [{ type: Input }],
    searchMinLength: [{ type: Input }],
    allowNewValues: [{ type: Input }],
    selectFirstItem: [{ type: Input }],
    itemTemplate: [{ type: Input }],
    placeholder: [{ type: Input }],
    popupHeight: [{ type: Input }],
    listHeight: [{ type: Input }],
    filterEvent: [{ type: Output, args: ['filter',] }],
    clear: [{ type: Output }],
    _comboboxInput: [{ type: ViewChild, args: ['autocomplete', { static: true },] }],
    data: [{ type: Input }],
    popupAppendTo: [{ type: Input }],
    popupClass: [{ type: Input }],
    popupWidth: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AutocompleteComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-autocomplete',
                template: "<!-- valuePrimitive=\"false\" -->\r\n<kendo-combobox\r\n  #autocomplete\r\n  clearbutton=\"false\"\r\n  filterable=\"true\"\r\n  allowCustom=\"true\"\r\n  [placeholder]=\"placeholder\"\r\n  [suggest]=\"selectFirstItem\"\r\n  [(ngModel)]=\"internalValue\"\r\n  [valueNormalizer]=\"valueNormalizer\"\r\n  [data]=\"filteredData\"\r\n  [textField]=\"displayField\"\r\n  [valueField]=\"valueField\"\r\n  [readonly]=\"readonly\"\r\n  [popupSettings]=\"popupSettings\"\r\n  [listHeight]=\"getPopupHeight()\"\r\n  [ngwkTooltip]=\"getTooltip()\"\r\n  [ngwkTooltipDisable]=\"isTooltipDisabled()\"\r\n  ngwkTooltipPosition=\"top-left\"\r\n  [disabled]=\"disabled\"  \r\n  (blur)=\"onBlur()\"\r\n  (focus)=\"onFocus()\">\r\n    <kendo-combobox-messages clearTitle=\"\"></kendo-combobox-messages>\r\n    <ng-template kendoComboBoxNoDataTemplate>\r\n      <span>{{'no_data_found' | locale }}</span>\r\n    </ng-template>\r\n</kendo-combobox>",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => AutocompleteComponent),
                        multi: true
                    },
                    {
                        provide: ReadonlyFocusableInput,
                        useExisting: forwardRef(() => AutocompleteComponent),
                        multi: true
                    }
                ],
                styles: [":host ::ng-deep{border:none!important;width:100%!important;font-size:13px!important;background-color:transparent!important}:host ::ng-deep ngwk-autocomplete input{padding-right:17px!important}:host ::ng-deep nwgk-f2-box .k-i-close{right:0px}:host ::ng-deep .k-combobox-clearable .k-input{padding-right:24px!important}:host ::ng-deep .k-state-focused{border-color:#3390ff!important;box-shadow:none!important;background-color:transparent!important}:host ::ng-deep input::selection{background-color:#3390ff!important}:host ::ng-deep span.k-select{display:none!important}:host ::ng-deep .k-combobox{width:100%}:host ::ng-deep .k-combobox .k-dropdown-wrap{border-color:transparent!important;background-color:transparent;height:29px}:host ::ng-deep .k-combobox .k-dropdown-wrap .k-i-close{right:5px}:host ::ng-deep .k-combobox .k-dropdown-wrap .k-clear-value{bottom:4px}:host ::ng-deep .k-combobox .k-state-focused{box-shadow:none!important}:host-context(.floatingLabelControl) ::ng-deep .k-combobox span{box-shadow:0 0!important;border:transparent!important}:host-context(.floatingLabelControl) ::ng-deep .k-combobox span .k-state-focused{border:transparent;box-shadow:0 0!important}\n"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { displayField: [{
            type: Input
        }], valueField: [{
            type: Input
        }], searchMinLength: [{
            type: Input
        }], allowNewValues: [{
            type: Input
        }], selectFirstItem: [{
            type: Input
        }], itemTemplate: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], popupHeight: [{
            type: Input
        }], listHeight: [{
            type: Input
        }], filterEvent: [{
            type: Output,
            args: ['filter']
        }], clear: [{
            type: Output
        }], data: [{
            type: Input
        }], popupAppendTo: [{
            type: Input
        }], popupClass: [{
            type: Input
        }], popupWidth: [{
            type: Input
        }], _comboboxInput: [{
            type: ViewChild,
            args: ['autocomplete', { static: true }]
        }] }); })();

class AutocompleteModule {
}
AutocompleteModule.ɵfac = function AutocompleteModule_Factory(t) { return new (t || AutocompleteModule)(); };
AutocompleteModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AutocompleteModule });
AutocompleteModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            FormsModule,
            IntlModule,
            LocalizationModule,
            DropDownsModule,
            TooltipModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AutocompleteModule, [{
        type: NgModule,
        args: [{
                imports: [
                    FormsModule,
                    IntlModule,
                    LocalizationModule,
                    DropDownsModule,
                    TooltipModule
                ],
                exports: [
                    AutocompleteComponent
                ],
                declarations: [
                    AutocompleteComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AutocompleteModule, { declarations: function () { return [AutocompleteComponent]; }, imports: function () { return [FormsModule,
        IntlModule,
        LocalizationModule,
        DropDownsModule,
        TooltipModule]; }, exports: function () { return [AutocompleteComponent]; } }); })();

/**
 * Este componente se utiliza para la declaración de inputs de tipo Switch
 *
 * @example
 * <ngwk-switch
 *  [(ngModel)]="switchValue"
 *  [onLabel]="'On"
 *  [offLabel]="'Off'">
 * </ngwk-switch>
 */
class SwitchComponent extends ReadonlyFocusableInput {
    /** @ignore */
    constructor() {
        super();
        this._onLabel = null;
        this._offLabel = null;
        this._valueChange = new EventEmitter();
    }
    /** @ignore */
    get inputFocus() {
        return this._switch;
    }
    /** @ignore */
    onValueChange() {
        this.valueChange.emit();
    }
    /**
     * Permite obtener el valor del label cuando el switch está activado
     */
    get onLabel() {
        return this._onLabel;
    }
    /**
     * Permite definir el valor del label cuando el switch está activado
     *
     * @param value El valor del label cuando el switch está activado
     */
    set onLabel(value) {
        this._onLabel = value;
    }
    /**
     * Permite obtener el valor del label cuando el switch está desactivado
     */
    get offLabel() {
        return this._offLabel;
    }
    /**
     * Permite definir el valor del label cuando el switch está desactivado
     *
     * @param value El valor del label cuando el switch está desactivado
     */
    set offLabel(value) {
        this._offLabel = value;
    }
    /**
     * Emite un evento cuando el switch cambia de estado
     */
    get valueChange() {
        return this._valueChange;
    }
}
SwitchComponent.ɵfac = function SwitchComponent_Factory(t) { return new (t || SwitchComponent)(); };
SwitchComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SwitchComponent, selectors: [["ngwk-switch"]], viewQuery: function SwitchComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c10, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._switch = _t.first);
    } }, inputs: { onLabel: "onLabel", offLabel: "offLabel" }, outputs: { valueChange: "valueChange" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => SwitchComponent),
                multi: true
            },
            {
                provide: ReadonlyFocusableInput,
                useExisting: forwardRef(() => SwitchComponent),
                multi: true
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 7, vars: 4, consts: [[1, "horizontalLayout"], [1, "colAvailable", "alignVerticalMiddle", "paddingLeftText"], [1, "colAuto", "alignVerticalMiddle"], ["onLabel", " ", "offLabel", " ", 3, "ngModel", "readonly", "disabled", "ngModelChange", "blur", "focus", "valueChange"], ["switch", ""]], template: function SwitchComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "span");
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "kendo-switch", 3, 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function SwitchComponent_Template_kendo_switch_ngModelChange_5_listener($event) { return ctx.internalValue = $event; })("blur", function SwitchComponent_Template_kendo_switch_blur_5_listener() { return ctx.onBlur(); })("focus", function SwitchComponent_Template_kendo_switch_focus_5_listener() { return ctx.onFocus(); })("valueChange", function SwitchComponent_Template_kendo_switch_valueChange_5_listener() { return ctx.onValueChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.internalValue ? ctx.onLabel : ctx.offLabel);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.internalValue)("readonly", ctx.readonly)("disabled", ctx.disabled);
    } }, directives: [ɵngcc6.SwitchComponent, ɵngcc1.NgControlStatus, ɵngcc1.NgModel], styles: ["[_nghost-%COMP%]    {color:#373737}[_nghost-%COMP%]     kendo-switch{margin-bottom:3px}[_nghost-%COMP%]     kendo-switch.k-switch{width:45px}[_nghost-%COMP%]     kendo-switch.k-switch .k-switch-container{border:1px solid #e5e5e5;padding:0;font-size:9px!important;width:auto}[_nghost-%COMP%]     kendo-switch.k-switch .k-switch-container .k-switch-handle{width:23px;height:23px;margin:0;font-size:9px!important}[_nghost-%COMP%]     kendo-switch.k-switch .k-switch-container:hover{background-color:#f1f1f1}[_nghost-%COMP%]     kendo-switch.k-switch .k-switch-container:hover .k-switch-handle{background-color:#f6f6f6!important}[_nghost-%COMP%]     kendo-switch.k-switch.k-switch-on .k-switch-container{background-color:#7ac143!important;width:auto}[_nghost-%COMP%]     kendo-switch.k-switch.k-switch-on .k-switch-container .k-switch-handle{background-color:#fff!important;border:1px solid #ccc!important;margin:0 0 0 4px;background-image:none!important;left:calc(100% - 27px)}[_nghost-%COMP%]     kendo-switch.k-switch.k-switch-on .k-switch-container:hover{background-color:#67a536!important}[_nghost-%COMP%]     kendo-switch.k-switch.k-switch-on .k-switch-container:hover .k-switch-handle{background-color:#f1f1f1!important}[_nghost-%COMP%]     kendo-switch.k-switch .k-switch-label-on{background-color:#ccc!important}"] });
/** @nocollapse */
SwitchComponent.ctorParameters = () => [];
SwitchComponent.propDecorators = {
    _switch: [{ type: ViewChild, args: ['switch', { static: true },] }],
    onLabel: [{ type: Input }],
    offLabel: [{ type: Input }],
    valueChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SwitchComponent, [{
        type: Component,
        args: [{
                selector: "ngwk-switch",
                template: "<div class='horizontalLayout'>\r\n    <div class='colAvailable alignVerticalMiddle paddingLeftText'>\r\n        <span>{{internalValue ? onLabel : offLabel}}</span>\r\n    </div>\r\n    <div class='colAuto alignVerticalMiddle'>\r\n        <kendo-switch #switch\r\n            [(ngModel)]=\"internalValue\"\r\n            [readonly]=\"readonly\"\r\n            [disabled]=\"disabled\"\r\n            onLabel=\" \"\r\n            offLabel=\" \"\r\n            (blur)=\"onBlur()\"\r\n            (focus)=\"onFocus()\"\r\n            (valueChange)=\"onValueChange()\">\r\n        </kendo-switch>\r\n    </div>\r\n</div>\r\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => SwitchComponent),
                        multi: true
                    },
                    {
                        provide: ReadonlyFocusableInput,
                        useExisting: forwardRef(() => SwitchComponent),
                        multi: true
                    }
                ],
                encapsulation: ViewEncapsulation.Emulated,
                styles: [":host ::ng-deep{color:#373737}:host ::ng-deep kendo-switch{margin-bottom:3px}:host ::ng-deep kendo-switch.k-switch{width:45px}:host ::ng-deep kendo-switch.k-switch .k-switch-container{border:1px solid #e5e5e5;padding:0;font-size:9px!important;width:auto}:host ::ng-deep kendo-switch.k-switch .k-switch-container .k-switch-handle{width:23px;height:23px;margin:0;font-size:9px!important}:host ::ng-deep kendo-switch.k-switch .k-switch-container:hover{background-color:#f1f1f1}:host ::ng-deep kendo-switch.k-switch .k-switch-container:hover .k-switch-handle{background-color:#f6f6f6!important}:host ::ng-deep kendo-switch.k-switch.k-switch-on .k-switch-container{background-color:#7ac143!important;width:auto}:host ::ng-deep kendo-switch.k-switch.k-switch-on .k-switch-container .k-switch-handle{background-color:#fff!important;border:1px solid #ccc!important;margin:0 0 0 4px;background-image:none!important;left:calc(100% - 27px)}:host ::ng-deep kendo-switch.k-switch.k-switch-on .k-switch-container:hover{background-color:#67a536!important}:host ::ng-deep kendo-switch.k-switch.k-switch-on .k-switch-container:hover .k-switch-handle{background-color:#f1f1f1!important}:host ::ng-deep kendo-switch.k-switch .k-switch-label-on{background-color:#ccc!important}\n"]
            }]
    }], function () { return []; }, { onLabel: [{
            type: Input
        }], offLabel: [{
            type: Input
        }], valueChange: [{
            type: Output
        }], _switch: [{
            type: ViewChild,
            args: ['switch', { static: true }]
        }] }); })();

class SwitchModule {
}
SwitchModule.ɵfac = function SwitchModule_Factory(t) { return new (t || SwitchModule)(); };
SwitchModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SwitchModule });
SwitchModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            FormsModule,
            CommonModule,
            InputsModule$1
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SwitchModule, [{
        type: NgModule,
        args: [{
                imports: [
                    FormsModule,
                    CommonModule,
                    InputsModule$1
                ],
                exports: [
                    SwitchComponent
                ],
                declarations: [
                    SwitchComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SwitchModule, { declarations: function () { return [SwitchComponent]; }, imports: function () { return [FormsModule,
        CommonModule,
        InputsModule$1]; }, exports: function () { return [SwitchComponent]; } }); })();

/**
 * Directiva que funciona como validador sincrono
 */
class RegexpValidator {
    constructor() {
        this._regExpValidatorEnabled = true;
        this._control = null;
    }
    /** @ignore */
    validate(c) {
        this._control = c;
        if (this.regExpValidatorEnabled) {
            return !this._control.value || this.regExpValidator.test(this._control.value) ? null : Reflection.setPropertyValue({}, this.regExpValidatorName, false);
        }
        return null;
    }
    /**
     * Permite obtener el validador principal
     */
    get regExpValidator() {
        return this._regExpValidator;
    }
    /**
     * Permite definir el validador principal
     *
     * @param value El validador principal
     */
    set regExpValidator(value) {
        this._regExpValidator = value;
    }
    /**
     * Permite definir el nombre del validador, el cual funcionará como clave identificatoria
     */
    get regExpValidatorName() {
        return this._regExpValidatorName;
    }
    /**
     * Permite obtener el nombre del validador, el cual funcionará como clave identificatoria
     *
     * @param value El nombre del validador
     */
    set regExpValidatorName(value) {
        this._regExpValidatorName = value;
    }
    /**
     * Permite consultar si el validador está habilitado o deshabilitado
     */
    get regExpValidatorEnabled() {
        return this._regExpValidatorEnabled;
    }
    /**
     * Permite habilitar o deshabilitar el validador
     *
     * @param value Valor que habilita o deshabilita el validador
     */
    set regExpValidatorEnabled(value) {
        const hasChanged = this._regExpValidatorEnabled !== value;
        this._regExpValidatorEnabled = value;
        if (this._control && hasChanged) {
            this._control.updateValueAndValidity();
        }
    }
}
RegexpValidator.ɵfac = function RegexpValidator_Factory(t) { return new (t || RegexpValidator)(); };
RegexpValidator.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: RegexpValidator, selectors: [["", "regExpValidator", ""]], inputs: { regExpValidator: "regExpValidator", regExpValidatorName: "regExpValidatorName", regExpValidatorEnabled: "regExpValidatorEnabled" }, features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: NG_VALIDATORS, useExisting: RegexpValidator, multi: true }
        ])] });
RegexpValidator.propDecorators = {
    regExpValidator: [{ type: Input }],
    regExpValidatorName: [{ type: Input }],
    regExpValidatorEnabled: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RegexpValidator, [{
        type: Directive,
        args: [{
                selector: '[regExpValidator]',
                providers: [
                    { provide: NG_VALIDATORS, useExisting: RegexpValidator, multi: true }
                ]
            }]
    }], function () { return []; }, { regExpValidator: [{
            type: Input
        }], regExpValidatorName: [{
            type: Input
        }], regExpValidatorEnabled: [{
            type: Input
        }] }); })();

/**
 * Directiva que funciona como validador asincrono
 */
class AsyncValidator {
    constructor() {
        this._asyncValidatorEnabled = true;
        this._validate$ = new BehaviorSubject(null);
        this._control = null;
    }
    /** @ignore */
    validate(c) {
        this._control = c;
        this._validate$.next(this._control.value);
        if (this.asyncValidatorEnabled) {
            return this._validate$.asObservable().pipe(debounceTime(300), switchMap((value) => this.validateObservable(value)), first());
        }
        return new Observable((observer) => observer.next(null));
    }
    validateObservable(value) {
        return new Observable((observer) => {
            if (value !== null && value !== undefined) {
                this.asyncValidator(value).then((validationResponse) => observer.next(this.transformToValidatorResponse(validationResponse)));
            }
            else {
                observer.next(null);
            }
        });
    }
    transformToValidatorResponse(validatorResponse) {
        return (validatorResponse === false) ? Reflection.setPropertyValue({}, this.asyncValidatorName, false) : null;
    }
    /**
     * Permite definir el validador principal asincrono, pasandole una función que retorna una promesa
     */
    get asyncValidator() {
        return this._asyncValidator;
    }
    /**
     * Permite obtener el validador principal asincrono, pasandole una función que retorna una promesa
     *
     * @param value El validador principal asíncrono
     */
    set asyncValidator(value) {
        this._asyncValidator = value;
    }
    /**
     * Permite definir el nombre del validador asincrono, el cual funcionará como clave identificatoria
     */
    get asyncValidatorName() {
        return this._asyncValidatorName;
    }
    /**
     * Permite obtener el nombre del validador asincrono, el cual funcionará como clave identificatoria
     *
     * @param value El nombre del validador asincrono
     */
    set asyncValidatorName(value) {
        this._asyncValidatorName = value;
    }
    /**
     * Permite consultar si el validador está habilitado o deshabilitado
     */
    get asyncValidatorEnabled() {
        return this._asyncValidatorEnabled;
    }
    /**
     * Permite habilitar o deshabilitar el validador
     *
     * @param value Valor que habilita o deshabilita el validador
     */
    set asyncValidatorEnabled(value) {
        const hasChanged = this._asyncValidatorEnabled !== value;
        this._asyncValidatorEnabled = value;
        if (this._control && hasChanged) {
            this._control.updateValueAndValidity();
        }
    }
}
AsyncValidator.ɵfac = function AsyncValidator_Factory(t) { return new (t || AsyncValidator)(); };
AsyncValidator.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: AsyncValidator, selectors: [["", "asyncValidator", ""]], inputs: { asyncValidator: "asyncValidator", asyncValidatorName: "asyncValidatorName", asyncValidatorEnabled: "asyncValidatorEnabled" }, features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: NG_ASYNC_VALIDATORS, useExisting: forwardRef(() => AsyncValidator), multi: true }
        ])] });
AsyncValidator.propDecorators = {
    asyncValidator: [{ type: Input }],
    asyncValidatorName: [{ type: Input }],
    asyncValidatorEnabled: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AsyncValidator, [{
        type: Directive,
        args: [{
                selector: '[asyncValidator]',
                providers: [
                    { provide: NG_ASYNC_VALIDATORS, useExisting: forwardRef(() => AsyncValidator), multi: true }
                ]
            }]
    }], function () { return []; }, { asyncValidator: [{
            type: Input
        }], asyncValidatorName: [{
            type: Input
        }], asyncValidatorEnabled: [{
            type: Input
        }] }); })();

/**
 * Directiva que funciona como validador entre dos fechas diferentes, indicando cual es la fecha de inicio y cual es la final, con
 * el propósito de asegurarse que la fecha de inicio nunca sea superior a la fecha final
 */
class RangeDateValidator {
    constructor() {
        this._startDateValue = null;
        this._endDateValue = null;
        this._rangeDateValidatorEnabled = true;
        this._control = null;
    }
    /** @ignore */
    validate(control) {
        this._control = control;
        if (this.rangeDateValidatorEnabled) {
            if (this.startDateValue && this._control.value) {
                return this.validateRange(this.startDateValue, this._control.value);
            }
            else if (this.endDateValue && this._control.value) {
                return this.validateRange(this._control.value, this.endDateValue);
            }
        }
        return null;
    }
    validateRange(startDate, endDate) {
        return startDate > endDate ? Reflection.setPropertyValue({}, this.rangeDateValidatorName, false) : null;
    }
    /**
     * Permite obtener la fecha de inicio del validador
     */
    get startDateValue() {
        return this._startDateValue;
    }
    /**
     * Permite definir la fecha de inicio del validador
     *
     * @param value La fecha de inicio
     */
    set startDateValue(value) {
        const hasChanged = this._startDateValue !== value;
        this._startDateValue = value;
        if (this._control && hasChanged) {
            this._control.updateValueAndValidity();
        }
    }
    /**
     * Permite obtener la fecha final del validador
     */
    get endDateValue() {
        return this._endDateValue;
    }
    /**
     * Permite definir la fecha final del validador
     *
     * @param value La fecha final
     */
    set endDateValue(value) {
        const hasChanged = this._endDateValue !== value;
        this._endDateValue = value;
        if (this._control && hasChanged) {
            this._control.updateValueAndValidity();
        }
    }
    /**
     * Permite consultar si el validador está habilitado o deshabilitado
     */
    get rangeDateValidatorEnabled() {
        return this._rangeDateValidatorEnabled;
    }
    /**
     * Permite habilitar o deshabilitar el validador
     *
     * @param value Valor que habilita o deshabilita el validador
     */
    set rangeDateValidatorEnabled(value) {
        const hasChanged = this._rangeDateValidatorEnabled !== value;
        this._rangeDateValidatorEnabled = value;
        if (this._control && hasChanged) {
            this._control.updateValueAndValidity();
        }
    }
    /**
     * Permite definir el nombre del validador, el cual funcionará como clave identificatoria
     */
    get rangeDateValidatorName() {
        return this._rangeDateValidatorName;
    }
    /**
     * Permite obtener el nombre del validador, el cual funcionará como clave identificatoria
     *
     * @param value El nombre del validador
     */
    set rangeDateValidatorName(value) {
        this._rangeDateValidatorName = value;
    }
}
RangeDateValidator.ɵfac = function RangeDateValidator_Factory(t) { return new (t || RangeDateValidator)(); };
RangeDateValidator.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: RangeDateValidator, selectors: [["", "rangeDateValidator", ""]], inputs: { startDateValue: "startDateValue", endDateValue: "endDateValue", rangeDateValidatorEnabled: "rangeDateValidatorEnabled", rangeDateValidatorName: "rangeDateValidatorName" }, features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: NG_VALIDATORS, useExisting: RangeDateValidator, multi: true }
        ])] });
RangeDateValidator.propDecorators = {
    startDateValue: [{ type: Input }],
    endDateValue: [{ type: Input }],
    rangeDateValidatorEnabled: [{ type: Input }],
    rangeDateValidatorName: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RangeDateValidator, [{
        type: Directive,
        args: [{
                selector: '[rangeDateValidator]',
                providers: [
                    { provide: NG_VALIDATORS, useExisting: RangeDateValidator, multi: true }
                ]
            }]
    }], function () { return []; }, { startDateValue: [{
            type: Input
        }], endDateValue: [{
            type: Input
        }], rangeDateValidatorEnabled: [{
            type: Input
        }], rangeDateValidatorName: [{
            type: Input
        }] }); })();

class ValidatorsModule {
}
ValidatorsModule.ɵfac = function ValidatorsModule_Factory(t) { return new (t || ValidatorsModule)(); };
ValidatorsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ValidatorsModule });
ValidatorsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            FormsModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ValidatorsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    FormsModule
                ],
                exports: [
                    RegexpValidator,
                    AsyncValidator,
                    RangeDateValidator
                ],
                declarations: [
                    RegexpValidator,
                    AsyncValidator,
                    RangeDateValidator
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ValidatorsModule, { declarations: function () { return [RegexpValidator, AsyncValidator, RangeDateValidator]; }, imports: function () { return [FormsModule]; }, exports: function () { return [RegexpValidator, AsyncValidator, RangeDateValidator]; } }); })();

/**
 * Este componente tiene como funcionalidad funcionar como selector de archivos, haciendo que la zona que envuelva funcione como tal
 *
 * @example
 * <ngwk-upload-file (fileSelected)="onFileSelected($event)">
 *      <!--Select File Zone-->
 * </ngwk-upload-file>
 */
class UploadFileComponent {
    /** @ignore */
    constructor() {
        this._types = null;
        this._typesString = '';
        this._multiple = false;
        this._fileSelected = new EventEmitter();
    }
    /** @ignore */
    onClick(event) {
        event.stopImmediatePropagation();
        this._uploadFile.nativeElement.click();
    }
    /** @ignore */
    onChange() {
        this.fileSelected.emit(this._uploadFile.nativeElement.files);
        this._uploadFile.nativeElement.value = null;
    }
    /**
     * Permite obtener los tipos de documentos válidos que acepta el componente. Si no se definen tipos, se permiten todos
     *
     * @return
     */
    get types() {
        return this._types;
    }
    /**
     * Permite definir los tipos de documentos válidos que acepta el componente. Si no se definen tipos, se permiten todos
     *
     * @param value Los tipos de documentos válidos
     * @return
     */
    set types(value) {
        this._types = value;
        this._typesString = this.types ? this.types.join(',') : null;
    }
    /**
     * Permite consultar si el Upload File permite subir múltiples documentos o no
     *
     * @return
     */
    get multiple() {
        return this._multiple;
    }
    /**
     * Permite activar o desactivar la funcionalidad de permitir subir múltiples documentos
     *
     * @param value Valor que activa o desactiva la funcionalidad de subir múltiples documentos
     * @return
     */
    set multiple(value) {
        this._multiple = value;
    }
    /** @ignore */
    get typesString() {
        return this._typesString;
    }
    /**
     * Emite un evento de archivos seleccionados cuando se ha seleccionado uno o múltiples archivos
     */
    get fileSelected() {
        return this._fileSelected;
    }
}
UploadFileComponent.ɵfac = function UploadFileComponent_Factory(t) { return new (t || UploadFileComponent)(); };
UploadFileComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: UploadFileComponent, selectors: [["ngwk-upload-file"]], viewQuery: function UploadFileComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c11, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._uploadFile = _t.first);
    } }, hostBindings: function UploadFileComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function UploadFileComponent_click_HostBindingHandler($event) { return ctx.onClick($event); });
    } }, inputs: { types: "types", multiple: "multiple" }, outputs: { fileSelected: "fileSelected" }, ngContentSelectors: _c5, decls: 4, vars: 2, consts: [[1, "uploadFileCursor"], ["type", "file", 1, "uploadFileDisplay", 3, "accept", "multiple", "change"], ["upload", ""]], template: function UploadFileComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "input", 1, 2);
        ɵngcc0.ɵɵlistener("change", function UploadFileComponent_Template_input_change_2_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("accept", ctx.typesString)("multiple", ctx.multiple);
    } }, styles: [".uploadFileDisplay[_ngcontent-%COMP%]{display:none}.uploadFileCursor[_ngcontent-%COMP%]{cursor:pointer}"] });
/** @nocollapse */
UploadFileComponent.ctorParameters = () => [];
UploadFileComponent.propDecorators = {
    _uploadFile: [{ type: ViewChild, args: ['upload', { static: true },] }],
    onClick: [{ type: HostListener, args: ['click', ['$event'],] }],
    types: [{ type: Input }],
    multiple: [{ type: Input }],
    fileSelected: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UploadFileComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-upload-file',
                template: "<div class=\"uploadFileCursor\">\r\n    <ng-content></ng-content>\r\n</div>\r\n<input #upload type=\"file\" class=\"uploadFileDisplay\" [accept]=\"typesString\" (change)=\"onChange()\" [multiple]=\"multiple\">\r\n",
                styles: [".uploadFileDisplay{display:none}.uploadFileCursor{cursor:pointer}\n"]
            }]
    }], function () { return []; }, { 
    /** @ignore */
    onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], types: [{
            type: Input
        }], multiple: [{
            type: Input
        }], fileSelected: [{
            type: Output
        }], _uploadFile: [{
            type: ViewChild,
            args: ['upload', { static: true }]
        }] }); })();

class UploadFileModule {
}
UploadFileModule.ɵfac = function UploadFileModule_Factory(t) { return new (t || UploadFileModule)(); };
UploadFileModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: UploadFileModule });
UploadFileModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UploadFileModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule
                ],
                declarations: [
                    UploadFileComponent
                ],
                exports: [
                    UploadFileComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(UploadFileModule, { declarations: function () { return [UploadFileComponent]; }, imports: function () { return [CommonModule,
        FormsModule]; }, exports: function () { return [UploadFileComponent]; } }); })();

/**
 * Servicio de [FormValidationListComponent]{@link FormValidationListComponent} y [NgwkFormValidationListDirective]{@link NgwkFormValidationListDirective}
 * Se utiliza para la gestión de las validaciones, ya sea borrar las existentes, añadir de nuevas, entre otras acciones
 */
class FormValidationListService {
    /** @ignore */
    constructor() {
        this._validationList = [];
        this._customValidationList = [];
    }
    /**
     * Permite añadir validaciones nuevas a la lista de validaciones actual
     *
     * @param validations Validaciones nuevas a añadir
     */
    addValidations(validations) {
        this._validationList.push(...validations);
    }
    /**
     * Permite añadir validaciones customizadas nuevas a la lista de validaciones custom actual
     *
     * @param validations Validaciones custom a añadir
     */
    addCustomValidations(validations) {
        this._customValidationList.push(...validations);
    }
    /**
     * Permite eliminar validaciones de un control en concreto
     *
     * @param control Control del cual borrar validaciones
     */
    deleteValidations(control) {
        this._validationList = this._validationList.filter((validation) => validation.control !== control);
    }
    /**
     * Permite eliminar validaciones del scope indicado
     *
     * @param scope Scope en el cual borrar las validaciones
     */
    deleteValidationsByScope(scope) {
        this._validationList = this._validationList.filter((validation) => validation.scope !== scope);
        this._customValidationList = this._customValidationList.filter((validation) => validation.scope !== scope);
    }
    /**
     * Permite obtener el mensaje de una validación a partir de un control
     *
     * @param scope Scope al que pertenece el mensaje de la validación a buscar
     * @param control Control al que pertenece la validacióón
     * @param validationKey Identificador único de la validación
     */
    getValidationMessageFromControl(scope, control, validationKey) {
        let validation = this._customValidationList.find((_validation) => this.existValidation(_validation, scope, control, validationKey));
        if (validation) {
            return validation.validationMessage;
        }
        return validationKey;
    }
    /**
     * Permite saber si existe una validación que cumpla los parámetros pasados a este método
     *
     * @param validation Validación a comprobar
     * @param scope Scope al que debería pertenecer la validación
     * @param control Control al que debería pertenecer la validación
     * @param validationKey Indentificador único que debería tener la validación
     */
    existValidation(validation, scope, control, validationKey) {
        return validation.scope === scope && validation.validationKey === validationKey && validation.control === control;
    }
    /**
     * Método que permite saber si hay validaciones activas en el scope que es pasado como parámetro
     *
     * @param scope Scope a comprobar si hay validaciones activas
     */
    hasValidationsByScope(scope) {
        return this._validationList.some((validation) => validation.scope === scope) || this._customValidationList.some((validation) => validation.scope === scope);
    }
    /**
     * Método que permite obtener las validaciones que hay en el scope que es pasado como parámetro
     *
     * @param scope Scope donde obtener las validaciones activas
     */
    getValidationsByScope(scope) {
        return this._validationList.filter((validation) => validation.scope === scope);
    }
}
FormValidationListService.ɵfac = function FormValidationListService_Factory(t) { return new (t || FormValidationListService)(); };
FormValidationListService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: FormValidationListService, factory: FormValidationListService.ɵfac });
/** @nocollapse */
FormValidationListService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormValidationListService, [{
        type: Injectable
    }], function () { return []; }, null); })();

/**
 * Este componente se utiliza para la declaración de un FormValidationList. Este componente se encarga de proporcionar información
 * sobre los errores que hay en los Inputs de donde está declarado. El encargado de detectar los errores es el
 * [FormValidationListDirective]{@link FormValidationListDirective}, el cual los informa al [FormValidationListService]{@link FormValidationListService}
 * y, finalmente, se acaban mostrando a través de este componente al usuario final. El Input de 'scope' es obligatorio
 * ponerlo para poder diferenciar entre los distintos errores que haya entre las páginas.
 *
 * @example
 * <ngwk-form-validation-list [scope]="scope"></ngwk-form-validation-list>
 *
 */
class FormValidationListComponent {
    /** @ignore */
    constructor(_formValidationListService, _navigationService, _router) {
        this._formValidationListService = _formValidationListService;
        this._navigationService = _navigationService;
        this._router = _router;
        this._validations = null;
        this._showValidations = false;
        this._scope = null;
        this._isInitialized = false;
        this._anchorAlign = { horizontal: 'left', vertical: 'bottom' };
        this._popupAlign = { horizontal: 'left', vertical: 'top' };
    }
    //#region Hooks
    ngOnDestroy() {
        this._formValidationListService.deleteValidationsByScope(this.scope);
    }
    ngAfterViewInit() {
        // We have to wait for the binding of the Inputs because we would have false validations during the Form creation.
        setTimeout(() => this._isInitialized = true, 1000);
    }
    //#endregion
    //#region Methods Public
    /** @ignore */
    onClick(validation) {
        if (this._router.url !== validation.url) {
            this._navigationService.go(validation.url).then(() => validation.focus());
        }
        else {
            validation.focus();
        }
    }
    /** @ignore */
    trackByValidationKey(index, item) {
        return item.validationKey;
    }
    /** @ignore */
    keydown(event) {
        if (event.keyCode === 27) {
            this.onListClose();
        }
    }
    /** @ignore */
    documentClick(event) {
        if (!this.contains(event.target)) {
            this.onListClose();
        }
    }
    /** @ignore */
    onCardClick() {
        this.showValidations = !this.showValidations;
    }
    /** @ignore */
    onListClose() {
        this.showValidations = false;
    }
    //#endregion
    //#region Methods Private
    contains(target) {
        return ((this.anchor ? this.anchor.nativeElement.contains(target) : false) ||
            (this.popup ? this.popup.nativeElement.contains(target) : false));
    }
    //#endregion
    //#region Properties
    /**
     * Permite obtener las validaciones que hay pendientes de revisar, ya sean personalizables o definidas por el usuario
     */
    get validations() {
        return this._validations ? this._validations : this._formValidationListService.getValidationsByScope(this.scope);
    }
    /**
     * Permite definir de manera opcional un listado de validaciones custom
     *
     * @param value Listado de validaciones custom
     */
    set validations(value) {
        this._validations = value;
    }
    /**
     * Permite consultar si el componente para mostrar las validaciones pendientes es visible o no
     */
    get showValidations() {
        return this._showValidations;
    }
    /**
     * Permite activar o desactivar el componente que muestra las validaciones que hay pendientes
     *
     * @param value Valor que activa o desactiva el componente con las validaciones pendientes
     */
    set showValidations(value) {
        this._showValidations = value;
    }
    /**
     * Permite obtener el scope donde se situa el componente. Es un campo obligatorio
     */
    get scope() {
        return this._scope;
    }
    /**
     * Permite definir el scope donde se situa el componente. Es un campo obligatorio
     *
     * @param value El scope donde se situa el componente
     */
    set scope(value) {
        this._scope = value;
    }
    /**
     * Permite consultar si el FormValidationList tiene validaciones pendientes de revisar o no
     */
    get hasValidations() {
        return this.validations && this.validations.length > 0 && this._isInitialized;
    }
    /** @ignore */
    get anchorAlign() {
        return this._anchorAlign;
    }
    /** @ignore */
    get popupAlign() {
        return this._popupAlign;
    }
}
FormValidationListComponent.ɵfac = function FormValidationListComponent_Factory(t) { return new (t || FormValidationListComponent)(ɵngcc0.ɵɵdirectiveInject(FormValidationListService), ɵngcc0.ɵɵdirectiveInject(ɵngcc8.NavigationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc9.Router)); };
FormValidationListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormValidationListComponent, selectors: [["ngwk-form-validation-list"]], viewQuery: function FormValidationListComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c12, 5);
        ɵngcc0.ɵɵviewQuery(_c13, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.anchor = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.popup = _t.first);
    } }, hostBindings: function FormValidationListComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function FormValidationListComponent_keydown_HostBindingHandler($event) { return ctx.keydown($event); }, false, ɵngcc0.ɵɵresolveDocument)("click", function FormValidationListComponent_click_HostBindingHandler($event) { return ctx.documentClick($event); }, false, ɵngcc0.ɵɵresolveDocument)("click", function FormValidationListComponent_click_HostBindingHandler() { return ctx.onCardClick(); });
    } }, inputs: { showValidations: "showValidations", validations: "validations", scope: "scope" }, decls: 2, vars: 2, consts: [[3, "anchor", "anchorAlign", "popupAlign", "popupClass", "close", 4, "ngIf"], [4, "ngIf"], [3, "anchor", "anchorAlign", "popupAlign", "popupClass", "close"], [1, "menuPopupContent"], [1, "formValidationListHeaderPopup"], [1, "verticalLayout", "formValidationListContentPopup"], ["class", "rowAuto", 3, "click", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "rowAuto", 3, "click"], ["anchor", ""], ["class", "horizontalLayout textValidation alignVerticalMiddle", 3, "click", 4, "ngIf"], ["class", "horizontalLayout textValidation alignVerticalMiddle", 4, "ngIf"], [1, "horizontalLayout", "textValidation", "alignVerticalMiddle", 3, "click"], ["key", "errorIcon", "decorator", "circle", "iconClass", "formValidationErrorIcon"], [1, "alignVerticalMiddle"], [1, "horizontalLayout", "textValidation", "alignVerticalMiddle"]], template: function FormValidationListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, FormValidationListComponent_ngwk_popup_0_Template, 7, 9, "ngwk-popup", 0);
        ɵngcc0.ɵɵtemplate(1, FormValidationListComponent_div_1_Template, 4, 2, "div", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.showValidations && (ctx.validations == null ? null : ctx.validations.length) > 1);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasValidations);
    } }, directives: [ɵngcc4.NgIf, ɵngcc2.PopupComponent, ɵngcc4.NgForOf, ɵngcc5.IconComponent], pipes: [ɵngcc2.LocalePipe], styles: ["[_nghost-%COMP%]     .textValidation{color:#ff4b20;width:fit-content;border-radius:10px;padding:8px;margin-right:10px;font-size:13px}[_nghost-%COMP%]     .textValidation ucc-icon{margin-top:2px;color:#ff4b20!important}[_nghost-%COMP%]     .textValidation span{padding-left:4px;padding-right:4px}[_nghost-%COMP%]     .textValidation:hover{background-color:#ffe9dc;cursor:pointer}[_nghost-%COMP%]     .formValidationListHeaderPopup{color:#fff;background-color:#fb7e5d;padding:8px}[_nghost-%COMP%]     .formValidationListContentPopup{max-height:250px}.menuPopup[_nghost-%COMP%]     .formValidationListContentPopup button{min-width:200px;max-width:500px}[_nghost-%COMP%]     .floatingLabelIcon{font-size:12px;margin:2px 1px 3px 6px;color:#fff;background-color:#ccc;padding:1px}[_nghost-%COMP%]     .formValidationErrorIcon{font-size:12px;margin:2px 1px 3px 6px;color:#fff;padding:1px;background-color:#fb7e5d}[_nghost-%COMP%]     .textValidation .formValidationErrorIcon{font-size:14px}[_nghost-%COMP%]     .k-popup{border:none;background:none}"] });
/** @nocollapse */
FormValidationListComponent.ctorParameters = () => [
    { type: FormValidationListService },
    { type: NavigationService },
    { type: Router }
];
FormValidationListComponent.propDecorators = {
    anchor: [{ type: ViewChild, args: ['anchor',] }],
    popup: [{ type: ViewChild, args: ['popup', { read: ElementRef },] }],
    keydown: [{ type: HostListener, args: ['document:keydown', ['$event'],] }],
    documentClick: [{ type: HostListener, args: ['document:click', ['$event'],] }],
    onCardClick: [{ type: HostListener, args: ['click',] }],
    validations: [{ type: Input }],
    showValidations: [{ type: Input }],
    scope: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormValidationListComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-form-validation-list',
                template: "<ngwk-popup *ngIf=\"showValidations && validations?.length > 1\"\r\n    [anchor]=\"anchor\"\r\n    [anchorAlign]=\"anchorAlign\"\r\n    [popupAlign]=\"popupAlign\"\r\n    [popupClass]=\"'menuPopupContainer'\"\r\n    (close)=\"onListClose()\">\r\n        <div class=\"menuPopupContent\">\r\n            <div class=\"formValidationListHeaderPopup\">\r\n                {{'validation_error_list' | locale}}\r\n            </div>\r\n            <div class=\"verticalLayout formValidationListContentPopup\">\r\n                <button class=\"rowAuto\" *ngFor=\"let validation of validations; trackBy: trackByValidationKey;\" (click)=\"onClick(validation)\">{{validation.validationMessage}}</button>\r\n            </div>\r\n        </div>\r\n</ngwk-popup>\r\n\r\n<div #anchor *ngIf=\"hasValidations\">\r\n    <div *ngIf=\"validations?.length == 1\" class=\"horizontalLayout textValidation alignVerticalMiddle\" (click)=\"onClick(validations[0])\">\r\n        <ucc-icon key=\"errorIcon\" decorator='circle' iconClass=\"formValidationErrorIcon\"></ucc-icon>\r\n        <span class=\"alignVerticalMiddle\">\r\n            {{validations[0]?.validationMessage}}\r\n        </span>\r\n    </div>\r\n    <div *ngIf=\"validations?.length > 1\" class=\"horizontalLayout textValidation alignVerticalMiddle\">\r\n        <ucc-icon key=\"errorIcon\" decorator='circle' iconClass=\"formValidationErrorIcon\"></ucc-icon>\r\n        <span class=\"alignVerticalMiddle\">\r\n            {{'validation_error_length_first' | locale}} {{ validations?.length }} {{'validation_error_length_second' | locale}}\r\n        </span>\r\n    </div>\r\n</div>\r\n",
                styles: [":host ::ng-deep .textValidation{color:#ff4b20;width:fit-content;border-radius:10px;padding:8px;margin-right:10px;font-size:13px}:host ::ng-deep .textValidation ucc-icon{margin-top:2px;color:#ff4b20!important}:host ::ng-deep .textValidation span{padding-left:4px;padding-right:4px}:host ::ng-deep .textValidation:hover{background-color:#ffe9dc;cursor:pointer}:host ::ng-deep .formValidationListHeaderPopup{color:#fff;background-color:#fb7e5d;padding:8px}:host ::ng-deep .formValidationListContentPopup{max-height:250px}.menuPopup:host ::ng-deep .formValidationListContentPopup button{min-width:200px;max-width:500px}:host ::ng-deep .floatingLabelIcon{font-size:12px;margin:2px 1px 3px 6px;color:#fff;background-color:#ccc;padding:1px}:host ::ng-deep .formValidationErrorIcon{font-size:12px;margin:2px 1px 3px 6px;color:#fff;padding:1px;background-color:#fb7e5d}:host ::ng-deep .textValidation .formValidationErrorIcon{font-size:14px}:host ::ng-deep .k-popup{border:none;background:none}\n"]
            }]
    }], function () { return [{ type: FormValidationListService }, { type: ɵngcc8.NavigationService }, { type: ɵngcc9.Router }]; }, { 
    /** @ignore */
    keydown: [{
            type: HostListener,
            args: ['document:keydown', ['$event']]
        }], 
    /** @ignore */
    documentClick: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }], 
    /** @ignore */
    onCardClick: [{
            type: HostListener,
            args: ['click']
        }], showValidations: [{
            type: Input
        }], validations: [{
            type: Input
        }], scope: [{
            type: Input
        }], anchor: [{
            type: ViewChild,
            args: ['anchor']
        }], popup: [{
            type: ViewChild,
            args: ['popup', { read: ElementRef }]
        }] }); })();

/** Directiva que funciona para detectar los errores de validaciones que estén dentro de su zona HTML. Es obligatorio definir un
 * scope en la zona donde se declare la directiva, para poder diferenciar entre distintas validaciones
 *
 * @example
 * <div ngwkFormValidationList [scope]="scope">
 *  Input Validation
 *  Input Validation
 *  ...
 *  Input Validation
 * </div>
 *
 */
class NgwkFormValidationListDirective {
    /** @ignore */
    constructor(_formValidationListService, _renderer, _router) {
        this._formValidationListService = _formValidationListService;
        this._renderer = _renderer;
        this._router = _router;
        this._isAlive = true;
        this._scope = null;
        this._modelsSubscribed = new Array();
    }
    ngAfterContentChecked() {
        if (this._models && this._modelsElementRef) {
            let models = this._models.toArray();
            let elementRefs = this._modelsElementRef.toArray();
            for (let model of models) {
                if (!this._modelsSubscribed.some(ms => ms === model)) {
                    model.valueChanges.pipe(debounceTime(300), takeWhile(() => this._isAlive)).subscribe(() => this.onValueChange(model, elementRefs[models.indexOf(model)]));
                    this.onValueChange(model, elementRefs[models.indexOf(model)]);
                    this._modelsSubscribed.push(model);
                }
            }
        }
    }
    ngOnDestroy() {
        this._isAlive = false;
        this._modelsSubscribed = null;
        this._formValidationListService.deleteValidationsByScope(this.scope);
    }
    /** @ignore */
    onValueChange(model, modelElementRef) {
        if (this.hasErrors(model)) {
            this.setValidations(model, modelElementRef);
        }
        else {
            this.deleteValidationsByControl(model.control);
        }
    }
    deleteValidationsByControl(control) {
        this._formValidationListService.deleteValidations(control);
    }
    setValidations(model, modelElementRef) {
        let validationKeys = Reflection.getProperties(model.errors);
        if (validationKeys) {
            for (let validationKey of validationKeys) {
                let validationInfo = this.createValidationInfo(model, modelElementRef, validationKey);
                if (!this.validationExist(validationInfo)) {
                    this._formValidationListService.addValidations([validationInfo]);
                }
            }
            ;
        }
    }
    validationExist(validation) {
        return this._formValidationListService.getValidationsByScope(this.scope).some((v) => v.control === validation.control &&
            v.validationKey === validation.validationKey &&
            v.validationMessage === validation.validationMessage &&
            v.url === validation.url);
    }
    createValidationInfo(model, modelElementRef, validationKey) {
        let validationInfo = {
            scope: this.scope,
            control: model.control,
            validationKey: validationKey,
            focus: () => model.valueAccessor.focus(),
            url: this._router.url
        };
        let validationFloatingLabel = this.getFloatingLabelByModel(modelElementRef);
        if (validationFloatingLabel && validationFloatingLabel.errorMessages && validationFloatingLabel.errorMessages.has(validationKey)) {
            validationInfo.validationMessage = validationFloatingLabel.errorMessages.get(validationKey);
        }
        else if (!validationInfo.validationMessage) {
            validationInfo.validationMessage = this._formValidationListService.getValidationMessageFromControl(this.scope, model.control, validationKey);
        }
        return validationInfo;
    }
    getFloatingLabelByModel(modelElementRef) {
        return this._floatingLabels.find((_floatingLabel) => this.modelIsChildOfFloatingLabel(_floatingLabel.elementRef, modelElementRef));
    }
    modelIsChildOfFloatingLabel(floatingLabelElementRef, modelElementRef) {
        return floatingLabelElementRef.nativeElement.contains(modelElementRef.nativeElement);
    }
    hasErrors(model) {
        return model && model.errors && Object.keys(model.errors).length > 0;
    }
    /**
     * Permite obtener el scope identificador de las validaciones que engloba la directiva
     */
    get scope() {
        return this._scope;
    }
    /**
     * Permite definir el scope identificador de las validaciones que engloba la directiva
     *
     * @param value El scope identificador
     */
    set scope(value) {
        this._scope = value;
    }
}
NgwkFormValidationListDirective.ɵfac = function NgwkFormValidationListDirective_Factory(t) { return new (t || NgwkFormValidationListDirective)(ɵngcc0.ɵɵdirectiveInject(FormValidationListService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc9.Router)); };
NgwkFormValidationListDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NgwkFormValidationListDirective, selectors: [["", "ngwkFormValidationList", ""]], contentQueries: function NgwkFormValidationListDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, NgModel, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, NgModel, 5, ElementRef);
        ɵngcc0.ɵɵcontentQuery(dirIndex, FloatingLabelComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._models = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._modelsElementRef = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._floatingLabels = _t);
    } }, inputs: { scope: "scope" } });
/** @nocollapse */
NgwkFormValidationListDirective.ctorParameters = () => [
    { type: FormValidationListService },
    { type: Renderer2 },
    { type: Router }
];
NgwkFormValidationListDirective.propDecorators = {
    _models: [{ type: ContentChildren, args: [NgModel, { descendants: true },] }],
    _modelsElementRef: [{ type: ContentChildren, args: [NgModel, { descendants: true, read: ElementRef },] }],
    _floatingLabels: [{ type: ContentChildren, args: [FloatingLabelComponent, { descendants: true },] }],
    scope: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgwkFormValidationListDirective, [{
        type: Directive,
        args: [{
                selector: '[ngwkFormValidationList]'
            }]
    }], function () { return [{ type: FormValidationListService }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc9.Router }]; }, { scope: [{
            type: Input
        }], _models: [{
            type: ContentChildren,
            args: [NgModel, { descendants: true }]
        }], _modelsElementRef: [{
            type: ContentChildren,
            args: [NgModel, { descendants: true, read: ElementRef }]
        }], _floatingLabels: [{
            type: ContentChildren,
            args: [FloatingLabelComponent, { descendants: true }]
        }] }); })();

class FormValidationListModule {
}
FormValidationListModule.ɵfac = function FormValidationListModule_Factory(t) { return new (t || FormValidationListModule)(); };
FormValidationListModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: FormValidationListModule });
FormValidationListModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            PopupModule,
            IconModule,
            LocalizationModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormValidationListModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    PopupModule,
                    IconModule,
                    LocalizationModule
                ],
                declarations: [
                    FormValidationListComponent,
                    NgwkFormValidationListDirective
                ],
                exports: [
                    FormValidationListComponent,
                    NgwkFormValidationListDirective
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FormValidationListModule, { declarations: function () { return [FormValidationListComponent, NgwkFormValidationListDirective]; }, imports: function () { return [CommonModule,
        FormsModule,
        PopupModule,
        IconModule,
        LocalizationModule]; }, exports: function () { return [FormValidationListComponent, NgwkFormValidationListDirective]; } }); })();

/**
 * Este componente se utiliza para la declaración de input de tipo checkbox
 *
 * @example
 *  <ngwk-checkbox #checkbox
 *    [(ngModel)]="checked"
 *    [id]="checkboxHeader"
 *    [disabled]="!isEnabled"
 *    [indeterminate]="indeterminate"
 *    (checkboxClick)="onCheckboxClick()">
 *  </ngwk-checkbox>
 *
 */
class CheckboxComponent extends ReadonlyFocusableInput {
    //#endregion
    /** @ignore */
    constructor(_localeService) {
        super();
        this._localeService = _localeService;
        //#region Privates
        this._id = Guid.newGuid();
        this._disabled = false;
        this._indeterminate = false;
        this._checkboxClick = new EventEmitter();
    }
    //#region Public methods
    /** @ignore */
    get inputFocus() {
        return this._checkbox;
    }
    /** @ignore */
    onCheckboxClick(event) {
        this.internalValue = !this.internalValue;
        this._checkboxClick.emit(event);
    }
    /** @ignore */
    onBlur() {
        super.onBlur();
    }
    /** @ignore */
    onFocus() {
        super.onFocus();
    }
    //#endregion
    //#region Properties
    /**
     * Permite obtener el id del checkbox
     *
     * @return
     */
    get id() {
        return this._id;
    }
    /**
     * Permite definir el id del checkbox. Es un campo obligatorio para que el checkbox funcione correctamente
     *
     * @param value El id del checkbox
     * @return
     */
    set id(value) {
        this._id = value;
    }
    /**
     * Permite consultar si el checkbox está deshabilitado o no
     *
     * @return
     */
    get disabled() {
        return this._disabled;
    }
    /**
     * Permite habilitar o deshabilitar el checkbox a partir del valor boolean que se le pase. De manera predeterminada está habilitado
     *
     * @param value Valor que activa o desactiva el checkbox
     * @return
     */
    set disabled(value) {
        this._disabled = value;
    }
    /**
     * Permite consultar si el checkbox está indeterminado o no
     *
     * @return
     */
    get indeterminate() {
        return this._indeterminate;
    }
    /**
     * Permite activar o desactivar el estado de indeterminado del checkbox a partir del valor boolean que se le pase. De manera predeterminada está desactivado
     *
     * @param value Valor que activa o desactiva el estado de indeterminado del checkbox
     * @return
     */
    set indeterminate(value) {
        this._indeterminate = value;
    }
    /**
     * Permite saber cuando se ha hecho click al checkbox a través de este evento
     *
     * @return
     */
    get checkboxClick() {
        return this._checkboxClick;
    }
}
CheckboxComponent.ɵfac = function CheckboxComponent_Factory(t) { return new (t || CheckboxComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.LocaleService)); };
CheckboxComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CheckboxComponent, selectors: [["ngwk-checkbox"]], viewQuery: function CheckboxComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c14, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._checkbox = _t.first);
    } }, inputs: { id: "id", disabled: "disabled", indeterminate: "indeterminate" }, outputs: { checkboxClick: "checkboxClick" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => CheckboxComponent),
                multi: true
            },
            {
                provide: ReadonlyFocusableInput,
                useExisting: forwardRef(() => CheckboxComponent),
                multi: true
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 5, consts: [["type", "checkbox", 3, "ngModel", "id", "disabled", "indeterminate", "ngModelChange", "click"], ["checkbox", ""], [3, "for"]], template: function CheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "input", 0, 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function CheckboxComponent_Template_input_ngModelChange_0_listener($event) { return ctx.internalValue = $event; })("click", function CheckboxComponent_Template_input_click_0_listener($event) { return ctx.onCheckboxClick($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(2, "label", 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngModel", ctx.internalValue)("id", ctx.id)("disabled", ctx.disabled)("indeterminate", ctx.indeterminate);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("for", ctx.id);
    } }, directives: [ɵngcc1.CheckboxControlValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.NgModel], styles: ["[_nghost-%COMP%]     .checkBoxIcon{border-radius:100%;background-color:#e6742e;height:15px;width:15px;color:#fff}[_nghost-%COMP%]     input[type=checkbox]:not(:checked), [_nghost-%COMP%]     input[type=checkbox]:checked{position:absolute;cursor:pointer;width:0px!important;height:0px!important;z-index:1;opacity:0}[_nghost-%COMP%]     input[type=checkbox]:not(:checked)+label, [_nghost-%COMP%]     input[type=checkbox]:checked+label{position:relative;margin-right:1.95em;cursor:pointer}[_nghost-%COMP%]     input[type=checkbox]:not(:checked)+label:before{content:\"\";position:absolute;left:0;top:0;width:15px;height:15px;border:1px solid #ccc;background:white;box-sizing:initial}[_nghost-%COMP%]     input[type=checkbox]:checked+label:before{font-family:ucc-icons;content:\"\";color:#fff;position:absolute;left:0;top:0;width:15px;height:15px;border:none!important;background:#0081C6}[_nghost-%COMP%]     input[type=checkbox]:indeterminate:not(:checked)+label:before{font-family:ucc-icons;content:\"\\eacd\";position:absolute;font-size:13px;text-align:center;border:1px solid #ccc;background:white;color:#0081c6;line-height:1.2}[_nghost-%COMP%]     input[type=checkbox]:indeterminate:not(:checked)+label:after, [_nghost-%COMP%]     input[type=checkbox]:not(:checked)+label:after, [_nghost-%COMP%]     input[type=checkbox]:checked+label:after{font-family:ucc-icons;content:\"\\ea3b\";position:absolute;top:3px;left:1px;font-size:12px;line-height:.8;color:#fff;background:transparent;transition:all .2s}[_nghost-%COMP%]     input[type=checkbox]:not(:checked)+label:after{opacity:0;transform:scale(0)}[_nghost-%COMP%]     input[type=checkbox]:checked+label:after{opacity:1;transform:scale(1)}[_nghost-%COMP%]     input[type=checkbox]:disabled:not(:checked)+label:before, [_nghost-%COMP%]     input[type=checkbox]:disabled:checked+label:before{box-shadow:none;border-color:#ccc;background:#eee}[_nghost-%COMP%]     input[type=checkbox]:disabled:checked+label:after{color:#ccc;background:transparent}[_nghost-%COMP%]     input[type=checkbox]:disabled+label{color:#aaa}[_nghost-%COMP%]     input[type=checkbox]:checked:focus+label:before, [_nghost-%COMP%]     input[type=checkbox]:not(:checked):focus+label:before{border:1px solid #ccc}"] });
/** @nocollapse */
CheckboxComponent.ctorParameters = () => [
    { type: LocaleService }
];
CheckboxComponent.propDecorators = {
    _checkbox: [{ type: ViewChild, args: ['checkbox', { static: true },] }],
    id: [{ type: Input }],
    disabled: [{ type: Input }],
    indeterminate: [{ type: Input }],
    checkboxClick: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CheckboxComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-checkbox',
                template: "<input #checkbox\r\n    type=\"checkbox\"\r\n    [(ngModel)]=\"internalValue\"\r\n    [id]=\"id\"\r\n    [disabled]=\"disabled\"\r\n    [indeterminate]=\"indeterminate\"\r\n    (click)=\"onCheckboxClick($event)\"/>\r\n<label [for]=\"id\"></label>",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => CheckboxComponent),
                        multi: true
                    },
                    {
                        provide: ReadonlyFocusableInput,
                        useExisting: forwardRef(() => CheckboxComponent),
                        multi: true
                    }
                ],
                styles: [":host ::ng-deep .checkBoxIcon{border-radius:100%;background-color:#e6742e;height:15px;width:15px;color:#fff}:host ::ng-deep input[type=checkbox]:not(:checked),:host ::ng-deep input[type=checkbox]:checked{position:absolute;cursor:pointer;width:0px!important;height:0px!important;z-index:1;opacity:0}:host ::ng-deep input[type=checkbox]:not(:checked)+label,:host ::ng-deep input[type=checkbox]:checked+label{position:relative;margin-right:1.95em;cursor:pointer}:host ::ng-deep input[type=checkbox]:not(:checked)+label:before{content:\"\";position:absolute;left:0;top:0;width:15px;height:15px;border:1px solid #ccc;background:white;box-sizing:initial}:host ::ng-deep input[type=checkbox]:checked+label:before{font-family:ucc-icons;content:\"\";color:#fff;position:absolute;left:0;top:0;width:15px;height:15px;border:none!important;background:#0081C6}:host ::ng-deep input[type=checkbox]:indeterminate:not(:checked)+label:before{font-family:ucc-icons;content:\"\\eacd\";position:absolute;font-size:13px;text-align:center;border:1px solid #ccc;background:white;color:#0081c6;line-height:1.2}:host ::ng-deep input[type=checkbox]:indeterminate:not(:checked)+label:after,:host ::ng-deep input[type=checkbox]:not(:checked)+label:after,:host ::ng-deep input[type=checkbox]:checked+label:after{font-family:ucc-icons;content:\"\\ea3b\";position:absolute;top:3px;left:1px;font-size:12px;line-height:.8;color:#fff;background:transparent;transition:all .2s}:host ::ng-deep input[type=checkbox]:not(:checked)+label:after{opacity:0;transform:scale(0)}:host ::ng-deep input[type=checkbox]:checked+label:after{opacity:1;transform:scale(1)}:host ::ng-deep input[type=checkbox]:disabled:not(:checked)+label:before,:host ::ng-deep input[type=checkbox]:disabled:checked+label:before{box-shadow:none;border-color:#ccc;background:#eee}:host ::ng-deep input[type=checkbox]:disabled:checked+label:after{color:#ccc;background:transparent}:host ::ng-deep input[type=checkbox]:disabled+label{color:#aaa}:host ::ng-deep input[type=checkbox]:checked:focus+label:before,:host ::ng-deep input[type=checkbox]:not(:checked):focus+label:before{border:1px solid #ccc}\n"]
            }]
    }], function () { return [{ type: ɵngcc2.LocaleService }]; }, { id: [{
            type: Input
        }], disabled: [{
            type: Input
        }], indeterminate: [{
            type: Input
        }], checkboxClick: [{
            type: Output
        }], _checkbox: [{
            type: ViewChild,
            args: ['checkbox', { static: true }]
        }] }); })();

class CheckboxModule {
}
CheckboxModule.ɵfac = function CheckboxModule_Factory(t) { return new (t || CheckboxModule)(); };
CheckboxModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CheckboxModule });
CheckboxModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            FormsModule,
            CommonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CheckboxModule, [{
        type: NgModule,
        args: [{
                imports: [
                    FormsModule,
                    CommonModule
                ],
                exports: [
                    CheckboxComponent
                ],
                declarations: [
                    CheckboxComponent
                ],
                schemas: [CUSTOM_ELEMENTS_SCHEMA]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CheckboxModule, { declarations: function () { return [CheckboxComponent]; }, imports: function () { return [FormsModule,
        CommonModule]; }, exports: function () { return [CheckboxComponent]; } }); })();

/**
 * Este componente se utiliza para la declaración de un Search Box, que és muy similar a un [TextBoxComponent]{@link TextBoxComponent}
 * pero con la posibilidad de limpiar el campo de texto y, además, la de poder definir un método de búsqueda a través del
 * Output de 'search'
 *
 * @example
 * <ngwk-search-box
 *  [placeholder]="placeholder"
 *  (search)="onSearch($event)"
 *  (clear)="onClear()">
 * </ngwk-search-box>
 *
 */
class SearchBoxComponent {
    //#endregion
    /** @ignore */
    constructor() {
        //#region Privates
        this._textValue = '';
        this._placeholder = '';
        this._clearButton = true;
        this._search = new EventEmitter();
        this._clear = new EventEmitter();
    }
    //#region Public Methods
    /** @ignore */
    onSearch(value) {
        this.search.emit(value);
    }
    /** @ignore */
    onClear() {
        this.clear.emit();
    }
    //#endregion
    //#region Properties
    /**
     * Permite obtener el valor actual del Input
     */
    get textValue() {
        return this._textValue;
    }
    /**
     * Permite definir el valor del Input
     *
     * @param value El valor del Input
     */
    set textValue(value) {
        this._textValue = value;
    }
    /**
     * Permite obtener el placeholder del SearchBox
     */
    get placeholder() {
        return this._placeholder;
    }
    /**
     * Permite definir placeholder del SearchBox
     *
     * @param value El placeholder del SearchBox
     */
    set placeholder(value) {
        this._placeholder = value;
    }
    /**
     * Permite consultar si el botón de borrar el texto del SearchBox está activado o desactivado
     */
    get clearButton() {
        return this._clearButton;
    }
    /**
     * Permite activar o desactivar el botón de borrar el texto del SearchBox
     *
     * @param value Valor que activa o desactiva el botón de borrar
     */
    set clearButton(value) {
        this._clearButton = value;
    }
    /**
     * Emite un evento cuando el usuario le da click al botón de buscar
     */
    get search() {
        return this._search;
    }
    /**
     * Emite un evento cuando el usuario le da click al botón de borrar el texto del SearchBox
     */
    get clear() {
        return this._clear;
    }
}
SearchBoxComponent.ɵfac = function SearchBoxComponent_Factory(t) { return new (t || SearchBoxComponent)(); };
SearchBoxComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SearchBoxComponent, selectors: [["ngwk-search-box"]], inputs: { placeholder: "placeholder", clearButton: "clearButton" }, outputs: { search: "search", clear: "clear" }, decls: 5, vars: 3, consts: [[1, "colAuto", "alignVerticalMiddle", "searchBox"], [1, "searchIcon"], ["key", "search", 3, "click"], [1, "searchText"], ["id", "txtSearch", 1, "floatingLabelSearch", 3, "ngModel", "clearButton", "placeholder", "ngModelChange", "keyup.enter", "clear"]], template: function SearchBoxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "ucc-icon", 2);
        ɵngcc0.ɵɵlistener("click", function SearchBoxComponent_Template_ucc_icon_click_2_listener() { return ctx.onSearch(ctx.textValue); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "ngwk-text-box", 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function SearchBoxComponent_Template_ngwk_text_box_ngModelChange_4_listener($event) { return ctx.textValue = $event; })("keyup.enter", function SearchBoxComponent_Template_ngwk_text_box_keyup_enter_4_listener() { return ctx.onSearch(ctx.textValue); })("clear", function SearchBoxComponent_Template_ngwk_text_box_clear_4_listener() { return ctx.onClear(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.textValue)("clearButton", ctx.clearButton)("placeholder", ctx.placeholder);
    } }, directives: [ɵngcc5.IconComponent, TextBoxComponent, ɵngcc1.NgControlStatus, ɵngcc1.NgModel], styles: ["[_nghost-%COMP%]     .searchBox{margin-top:2px;padding-right:8px;border:1px solid #ccc;border-radius:5px;display:flex;font-size:11px;height:30px;width:260px;padding-left:7px;margin-right:10px}[_nghost-%COMP%]     .searchBox .searchText{grid-column:2;height:100%;width:100%;display:flex;align-items:center}[_nghost-%COMP%]     .searchBox .searchText ngwk-text-box{width:100%}[_nghost-%COMP%]     .searchBox .searchText ngwk-text-box input{padding:0;color:#555;font-size:13px;width:100%;height:100%;border:none}[_nghost-%COMP%]     .searchBox .searchIcon{display:flex;align-items:center;justify-content:center;grid-column:1;height:25px;width:25px;margin-right:7px;cursor:pointer}[_nghost-%COMP%]     .searchBox .searchIcon ucc-icon{color:#999}[_nghost-%COMP%]     .searchBox .searchIcon ucc-icon:hover{background-color:transparent;color:#373737}"] });
/** @nocollapse */
SearchBoxComponent.ctorParameters = () => [];
SearchBoxComponent.propDecorators = {
    placeholder: [{ type: Input }],
    clearButton: [{ type: Input }],
    search: [{ type: Output }],
    clear: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SearchBoxComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-search-box',
                template: "<div class=\"colAuto alignVerticalMiddle searchBox\">\r\n  <div class=\"searchIcon\">\r\n    <ucc-icon key=\"search\" (click)=\"onSearch(textValue)\"></ucc-icon>\r\n  </div>\r\n  <div class=\"searchText\">\r\n    <ngwk-text-box\r\n      id=\"txtSearch\"\r\n      [(ngModel)]=\"textValue\"\r\n      class=\"floatingLabelSearch\"\r\n      [clearButton]=\"clearButton\"\r\n      [placeholder]=\"placeholder\"\r\n      (keyup.enter)=\"onSearch(textValue)\"\r\n      (clear)=\"onClear()\">\r\n    </ngwk-text-box>\r\n  </div>\r\n</div>",
                styles: [":host ::ng-deep .searchBox{margin-top:2px;padding-right:8px;border:1px solid #ccc;border-radius:5px;display:flex;font-size:11px;height:30px;width:260px;padding-left:7px;margin-right:10px}:host ::ng-deep .searchBox .searchText{grid-column:2;height:100%;width:100%;display:flex;align-items:center}:host ::ng-deep .searchBox .searchText ngwk-text-box{width:100%}:host ::ng-deep .searchBox .searchText ngwk-text-box input{padding:0;color:#555;font-size:13px;width:100%;height:100%;border:none}:host ::ng-deep .searchBox .searchIcon{display:flex;align-items:center;justify-content:center;grid-column:1;height:25px;width:25px;margin-right:7px;cursor:pointer}:host ::ng-deep .searchBox .searchIcon ucc-icon{color:#999}:host ::ng-deep .searchBox .searchIcon ucc-icon:hover{background-color:transparent;color:#373737}\n"]
            }]
    }], function () { return []; }, { placeholder: [{
            type: Input
        }], clearButton: [{
            type: Input
        }], search: [{
            type: Output
        }], clear: [{
            type: Output
        }] }); })();

class SearchBoxModule {
}
SearchBoxModule.ɵfac = function SearchBoxModule_Factory(t) { return new (t || SearchBoxModule)(); };
SearchBoxModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SearchBoxModule });
SearchBoxModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            FormsModule,
            CommonModule,
            IconModule,
            TextBoxModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SearchBoxModule, [{
        type: NgModule,
        args: [{
                imports: [
                    FormsModule,
                    CommonModule,
                    IconModule,
                    TextBoxModule
                ],
                declarations: [
                    SearchBoxComponent
                ],
                exports: [
                    SearchBoxComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SearchBoxModule, { declarations: function () { return [SearchBoxComponent]; }, imports: function () { return [FormsModule,
        CommonModule,
        IconModule, TextBoxModule]; }, exports: function () { return [SearchBoxComponent]; } }); })();

/**
 * Este componente se utiliza para la declaración de inputs de tipo Tags
 *
 * @example
 * <ngwk-tags
 *  [data]="data"
 *  [(ngModel)]="internalValue"
 *  [textField]="textField"
 *  [allowCustom]="allowCustom">
 * </ngwk-tags>
 *
 */
class TagsComponent extends ReadonlyFocusableInput {
    //#endregion
    /** @ignore */
    constructor(_el) {
        super();
        this._el = _el;
        //#region Privates
        this._valueNormalizer = (text) => this.onValueNormalizer(text);
        this._popupSettings = { popupClass: 'tagsComponentPopup' };
        this._data = null;
        this._internalData = null;
        this._filteredData = null;
        this._isInputOpen = false;
        this._isAlive = true;
        // Esta propiedad privada se utiliza para comprobar si se ha hecho click en un TagItem. En ese caso, el estado de abierto o cerrado del Popup no será afectado.
        this._tagClicked = false;
        /** Permite activar o desactivar la opción de que el TagsComponent permita valores custom. De manera predeterminada está activado. */
        this.allowCustom = true;
        /** Permite definir el campo de tipo string que se mostrará de cada uno de los objetos que se hayan filtrado y/o seleccionado en el desplegable del Tags Component */
        this.textField = null;
        /** Permite definir el mínimo de carácteres que se deben escribir en el tags component para realizar un filtro de la búsqueda */
        this.searchMinLength = 0;
        /** Permite activar o desactivar la opción de que el TagsComponent permita seleccionar más tags. De manera predeterminada el valor es "true" */
        this.canAddMoreTags = true;
        /** Permite pasar un método que devuelve un booleano y determina si el tag es inválido o no. */
        this.isTagInvalid = null;
        /** Permite cambiar el template del TagItem para poder personalizarlo. El template tiene de por si como contexto el objeto del TagItem que haya definido el usuario. */
        this.customTemplate = null;
        /** Emite un evento cuando se ha añadido un item custom a la lista de elementos seleccionados */
        this.addCustom = new EventEmitter();
        /** Evento que permite informar de cuando se ha realizado una búsqueda en el autocomplete y se ha filtrado por un valor en concreto */
        this.filterEvent = new EventEmitter();
        this._ngwkTags = null;
        this._ngwkTagsElementRef = null;
        this._ngwkTagsOpenButtonElementRef = null;
    }
    //#region Hooks
    /** @ignore */
    ngAfterViewInit() {
        this.filterChangeSubscriptions();
        this.valueChangeSubscriptions();
        this.openSubscription();
        this.closeSubscription();
        this.handleKeydown();
    }
    /** @ignore */
    ngOnDestroy() {
        this._isAlive = false;
    }
    //#endregion
    //#region Public Methods
    /** @ignore */
    documentClick(event) {
        if (this.isOpenButtonClicked(event.target)) {
            this._isInputOpen = true;
            setTimeout(() => this._ngwkTags.focus());
        }
        else if (!this.isComponentClicked(event.target)) {
            this._isInputOpen = false;
        }
    }
    /** @ignore */
    onMouseDown(event) {
        this._tagClicked = this.isTagClicked(event.target);
    }
    /** @ignore */
    onKeyDown() {
        this._tagClicked = false;
    }
    /**@ignore */
    writeValue(value) {
        super.writeValue(value);
        if (value) {
            this.onValueChange(value);
        }
    }
    /** @ignore */
    onValueChange(selectedTags) {
        if (!this.isBuiltInSearch() && this.isFocused) {
            this._internalData = this._data.filter((tag) => !this.isTagSelected(tag, selectedTags));
            this._filteredData = this._internalData;
        }
    }
    /** @ignore */
    getTagItemText(dataItem) {
        return dataItem[this.textField];
    }
    /** @ignore */
    getTagItemId(dataItem) {
        return dataItem[this.textField] + 'Id';
    }
    /** @ignore */
    getTagContext(dataItem) {
        return { $implicit: dataItem };
    }
    /** @ignore */
    isButtonDisabled() {
        return this.disabled || !this.addingTagsEnabled();
    }
    //#endregion
    //#region Private Methods
    filterChangeSubscriptions() {
        this._ngwkTags.filterChange.pipe(filter((searchValue) => this.hasTextMinSearchLength(searchValue)), takeWhile(() => this._isAlive))
            .subscribe((searchValue) => {
            if (this.isBuiltInSearch()) {
                const resultSearch = this.searchOnData(searchValue);
                this._filteredData = resultSearch;
            }
            else {
                this.filterEvent.emit(searchValue);
            }
        });
        this._ngwkTags.filterChange.pipe(filter((searchValue) => !this.hasTextMinSearchLength(searchValue)), takeWhile(() => this._isAlive))
            .subscribe(() => {
            this._ngwkTags.toggle(false);
            this._filteredData = [];
        });
    }
    valueChangeSubscriptions() {
        this._ngwkTags.valueChange.pipe(takeWhile(() => this._isAlive))
            .subscribe(() => {
            setTimeout(() => {
                if (!this.addingTagsEnabled()) {
                    this._isInputOpen = false;
                    this._ngwkTags.toggle(false);
                }
            });
        });
        this._ngwkTags.valueChange.pipe(takeWhile(() => this._isAlive))
            .subscribe((tags) => {
            // Este setTimeOut está para poder esperar a que se realice el set de los Tags internamente en el componente de Kendo
            setTimeout(() => {
                if (tags) {
                    tags.forEach((tag) => {
                        this.checkIfTagIsInvalid(tag);
                    });
                }
            });
        });
    }
    openSubscription() {
        this._ngwkTags.open.subscribe((event) => {
            event.preventDefault();
            // Este setTimeOut está para poder hacer que los eventos de MouseDown y KeyDown se ejecuten antes y así comprobar si se ha hecho click en el TagItem.
            // En ese caso, no se ejecutará el toggle que abre el Popup.
            setTimeout(() => {
                if (!this._tagClicked && this._isInputOpen) {
                    if ((this.hasText() && this.hasTextMinSearchLength(this._ngwkTags.text)) || this.hasFilteredData()) {
                        this._ngwkTags.toggle(true);
                    }
                }
            });
        });
    }
    closeSubscription() {
        this._ngwkTags.close.subscribe((event) => {
            event.preventDefault();
            // Este setTimeOut está para poder hacer que los eventos de MouseDown y KeyDown se ejecuten antes y así comprobar si se ha hecho click en el TagItem.
            // En ese caso, no se ejecutará el toggle que cierra el Popup.
            setTimeout(() => {
                if (!this._tagClicked) {
                    this._ngwkTags.toggle(false);
                }
            });
        });
    }
    checkIfTagsAreInvalidInitially() {
        // Este setTimeOut está para poder esperar a que se realice el set de los Tags internamente en el componente de Kendo
        setTimeout(() => {
            if (this._ngwkTags.tags) {
                this._ngwkTags.tags.forEach((tag) => {
                    this.checkIfTagIsInvalid(tag);
                });
            }
        });
    }
    hasText() {
        return this._ngwkTags.text !== null && this._ngwkTags.text !== undefined && this._ngwkTags.text !== '';
    }
    hasFilteredData() {
        return this._filteredData !== null && this._filteredData !== undefined && this._filteredData.length > 0;
    }
    searchOnData(filterValue) {
        let result = null;
        const contains = (value) => (s) => (this.getTextFieldValue(s))
            .toLowerCase()
            .indexOf(value.toLowerCase()) !== -1;
        if (this.data) {
            result = this.data.filter(contains(filterValue));
        }
        return result;
    }
    getTextFieldValue(item) {
        return this.textField ? Reflection.getPropertyValue(item, this.textField) : item;
    }
    hasTextMinSearchLength(text) {
        return (text !== null && (text.length >= this.searchMinLength));
    }
    handleKeydown() {
        this._ngwkTags.searchbar.ngwkHandleKeydown = this._ngwkTags.searchbar.handleKeydown;
        this._ngwkTags.searchbar.handleKeydown = (event) => {
            if (event.key === 'Tab') {
                this._isInputOpen = false;
            }
            else if (event.key === 'Backspace' && !this._ngwkTags.text) {
                event.stopImmediatePropagation();
                event.preventDefault();
            }
            else {
                this._ngwkTags.searchbar.ngwkHandleKeydown(event);
            }
        };
    }
    isTagSelected(tagToCheck, selectedTags) {
        let tag = null;
        if (selectedTags) {
            tag = selectedTags.find((selectedTag) => {
                return selectedTag[this.textField] === tagToCheck[this.textField];
            });
        }
        return tag !== null && tag != undefined;
    }
    onValueNormalizer(text) {
        return text.pipe(map((text) => this.normalizeObject(text)));
    }
    normalizeObject(text) {
        const matchingDataItem = this.data.find((dataItem) => {
            return dataItem[this.textField].toLowerCase() === text.toLowerCase();
        });
        if (matchingDataItem) {
            const matchingDataItemInternalValue = this.internalValue.find((internalValueItem) => {
                return internalValueItem[this.textField].toLowerCase() === matchingDataItem[this.textField].toLowerCase();
            });
            if (!matchingDataItemInternalValue) {
                return matchingDataItem;
            }
        }
        else {
            const matchingInternalValueItem = this.internalValue.find((internalValueItem) => {
                return internalValueItem[this.textField].toLowerCase() === text.toLowerCase();
            });
            if (!matchingInternalValueItem) {
                let result = {};
                Reflection.setPropertyValue(result, this.textField, text);
                this.addCustom.emit(result);
                return result;
            }
        }
        // Para que funcione igual que sin customValues === false, donde al pulsar la tecla 'Enter' no se borra el valor si no existe,
        // utilizamos un setTimeout para volver a poner el texto una vez termine el valueNormalizer y no termine con el texto vacio.
        setTimeout(() => this._ngwkTags.text = text);
        return;
    }
    isOpenButtonClicked(target) {
        return this._ngwkTagsOpenButtonElementRef && this._ngwkTagsOpenButtonElementRef.nativeElement.contains(target);
    }
    isTagClicked(target) {
        const tags = this._el.nativeElement.getElementsByClassName('k-button');
        const isSomeTagClicked = Array.from(tags).some((element) => (element === target || element.contains(target)));
        return isSomeTagClicked;
    }
    checkIfTagIsInvalid(tag) {
        if (this.isTagInvalid !== null && Type.isFunction(this.isTagInvalid) && this.isTagInvalid(tag)) {
            const tagElement = this._el.nativeElement.querySelector(`[id="${this.getTagItemId(tag)}"]`);
            tagElement.parentElement.parentElement.classList.add('invalidTag');
        }
    }
    isComponentClicked(target) {
        return this._ngwkTagsElementRef && this._ngwkTagsElementRef.nativeElement.contains(target);
    }
    isBuiltInSearch() {
        return this.filterEvent.observers.length === 0;
    }
    addingTagsEnabled() {
        if (Type.isFunction(this.canAddMoreTags)) {
            return this.canAddMoreTags();
        }
        else if (Bool.isBoolean(this.canAddMoreTags)) {
            return this.canAddMoreTags;
        }
        return true;
    }
    //#endregion
    //#region Properties
    /**@ignore */
    get inputFocus() {
        return this._ngwkTags;
    }
    /** @ignore */
    get valueNormalizer() {
        return this._valueNormalizer;
    }
    /** @ignore */
    get popupSettings() {
        return this._popupSettings;
    }
    /** @ignore */
    get filteredData() {
        return this._filteredData;
    }
    /** @ignore */
    get isInputOpen() {
        return this._isInputOpen;
    }
    /**
     * Permite obtener toda los objetos definidos en el Tags Component
     */
    get data() {
        return this._data;
    }
    /**
     * Permite definir los objetos del Tags Component
     *
     * @param value Los objetos a añadir en el Tags Component
     */
    set data(value) {
        this._data = value;
        this._internalData = value;
        this._filteredData = this._internalData;
        this.checkIfTagsAreInvalidInitially();
    }
}
TagsComponent.ɵfac = function TagsComponent_Factory(t) { return new (t || TagsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
TagsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TagsComponent, selectors: [["ngwk-tags"]], viewQuery: function TagsComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c15, 7);
        ɵngcc0.ɵɵviewQuery(_c15, 7, ElementRef);
        ɵngcc0.ɵɵviewQuery(_c16, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._ngwkTags = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._ngwkTagsElementRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._ngwkTagsOpenButtonElementRef = _t.first);
    } }, hostBindings: function TagsComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function TagsComponent_click_HostBindingHandler($event) { return ctx.documentClick($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, inputs: { allowCustom: "allowCustom", textField: "textField", searchMinLength: "searchMinLength", canAddMoreTags: "canAddMoreTags", isTagInvalid: "isTagInvalid", customTemplate: "customTemplate", data: "data" }, outputs: { addCustom: "addCustom", filterEvent: "filter" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => TagsComponent),
                multi: true
            },
            {
                provide: ReadonlyFocusableInput,
                useExisting: forwardRef(() => TagsComponent),
                multi: true
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 6, vars: 14, consts: [[1, "horizontalLayout", "tagsContainer"], [1, "fullWidth", 3, "ngClass", "data", "ngModel", "textField", "valueField", "allowCustom", "valueNormalizer", "popupSettings", "clearButton", "disabled", "filterable", "ngModelChange", "blur", "focus", "mousedown", "keydown"], ["ngwkTags", ""], ["kendoMultiSelectTagTemplate", ""], ["kendoComboBoxNoDataTemplate", ""], ["id", "tagsOpenInputButton", "class", "openInputButton", 3, "disabled", 4, "ngIf"], [3, "id"], ["ngwkTooltipPosition", "top-left", 3, "ngwkTooltip", 4, "ngIf"], [4, "ngIf"], ["ngwkTooltipPosition", "top-left", 3, "ngwkTooltip"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["id", "tagsOpenInputButton", 1, "openInputButton", 3, "disabled"], ["ngwkTagsOpenButton", ""], ["key", "addIcon"]], template: function TagsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "kendo-multiselect", 1, 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function TagsComponent_Template_kendo_multiselect_ngModelChange_1_listener($event) { return ctx.internalValue = $event; })("ngModelChange", function TagsComponent_Template_kendo_multiselect_ngModelChange_1_listener($event) { return ctx.onValueChange($event); })("blur", function TagsComponent_Template_kendo_multiselect_blur_1_listener() { return ctx.onBlur(); })("focus", function TagsComponent_Template_kendo_multiselect_focus_1_listener() { return ctx.onFocus(); })("mousedown", function TagsComponent_Template_kendo_multiselect_mousedown_1_listener($event) { return ctx.onMouseDown($event); })("keydown", function TagsComponent_Template_kendo_multiselect_keydown_1_listener() { return ctx.onKeyDown(); });
        ɵngcc0.ɵɵtemplate(3, TagsComponent_ng_template_3_Template, 3, 3, "ng-template", 3);
        ɵngcc0.ɵɵtemplate(4, TagsComponent_ng_template_4_Template, 3, 3, "ng-template", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, TagsComponent_button_5_Template, 3, 1, "button", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(12, _c17, !ctx.isInputOpen))("data", ctx.filteredData)("ngModel", ctx.internalValue)("textField", ctx.textField)("valueField", ctx.textField)("allowCustom", ctx.allowCustom)("valueNormalizer", ctx.valueNormalizer)("popupSettings", ctx.popupSettings)("clearButton", false)("disabled", ctx.disabled)("filterable", true);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isInputOpen);
    } }, directives: [ɵngcc7.MultiSelectComponent, ɵngcc4.NgClass, ɵngcc1.NgControlStatus, ɵngcc1.NgModel, ɵngcc7.TagTemplateDirective, ɵngcc7.NoDataTemplateDirective, ɵngcc4.NgIf, ɵngcc2.NgwkTooltipDirective, ɵngcc4.NgTemplateOutlet, ɵngcc5.IconComponent], pipes: [ɵngcc2.LocalePipe], styles: ["[_nghost-%COMP%]     .k-multiselect{white-space:normal}[_nghost-%COMP%]     .k-multiselect-wrap{padding-right:0;border-width:0px;border-style:none}[_nghost-%COMP%]     .k-multiselect-wrap .k-clear-value{top:1px}[_nghost-%COMP%]     .k-button{border-radius:25px;color:#009881;background-color:#fff;border-color:#009881;line-height:1.5px;height:22px;margin-right:5px;margin-bottom:5px;max-width:250px;cursor:auto;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}[_nghost-%COMP%]     .k-button span:first-child{color:#009881!important;font-size:12px!important;line-height:12px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}[_nghost-%COMP%]     .k-button:active{box-shadow:none}[_nghost-%COMP%]     .k-button:hover{background-color:#f7fcfb}[_nghost-%COMP%]     .k-button[disabled]{opacity:.5;cursor:default;pointer-events:none}[_nghost-%COMP%]     .k-button .k-select .k-icon{padding:0;margin-left:1px;cursor:pointer}[_nghost-%COMP%]     .k-icon{font-size:12px;padding-left:5px}[_nghost-%COMP%]     .hideInput .k-multiselect-wrap input{display:none}[_nghost-%COMP%]     .openInputButton{align-self:flex-end;margin-bottom:5px;min-width:22px;max-width:22px;min-height:22px;max-height:22px;border-radius:50%;border:none;cursor:pointer;overflow:hidden;outline:none;background-color:#c9efe9;color:#fff}[_nghost-%COMP%]     .openInputButton i{font-size:16px;color:#009881}[_nghost-%COMP%]     .openInputButton:focus{border:1px solid #009881}[_nghost-%COMP%]     .openInputButton:hover{background-color:#e1f6f3}[_nghost-%COMP%]     .openInputButton[disabled]{opacity:.5;cursor:default;pointer-events:none}[_nghost-%COMP%]     .invalidTag{color:#fb7e5d;border-color:#fb7e5d}[_nghost-%COMP%]     .invalidTag span:first-child{color:#fb7e5d!important}[_nghost-%COMP%]     .invalidTag:hover{background-color:#fff5f2}"] });
/** @nocollapse */
TagsComponent.ctorParameters = () => [
    { type: ElementRef }
];
TagsComponent.propDecorators = {
    allowCustom: [{ type: Input }],
    textField: [{ type: Input }],
    searchMinLength: [{ type: Input }],
    canAddMoreTags: [{ type: Input }],
    isTagInvalid: [{ type: Input }],
    customTemplate: [{ type: Input }],
    addCustom: [{ type: Output }],
    filterEvent: [{ type: Output, args: ['filter',] }],
    _ngwkTags: [{ type: ViewChild, args: ['ngwkTags', { static: true },] }],
    _ngwkTagsElementRef: [{ type: ViewChild, args: ['ngwkTags', { read: ElementRef, static: true },] }],
    _ngwkTagsOpenButtonElementRef: [{ type: ViewChild, args: ['ngwkTagsOpenButton', { read: ElementRef },] }],
    documentClick: [{ type: HostListener, args: ['document:click', ['$event'],] }],
    data: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TagsComponent, [{
        type: Component,
        args: [{
                selector: "ngwk-tags",
                template: "<div class=\"horizontalLayout tagsContainer\">\r\n\r\n  <kendo-multiselect #ngwkTags\r\n    class=\"fullWidth\"\r\n    [ngClass]=\"{'hideInput': !isInputOpen}\"\r\n    [data]=\"filteredData\"\r\n    [(ngModel)]=\"internalValue\"\r\n    [textField]=\"textField\"\r\n    [valueField]=\"textField\"\r\n    [allowCustom]=\"allowCustom\"\r\n    [valueNormalizer]=\"valueNormalizer\"\r\n    [popupSettings]=\"popupSettings\"\r\n    [clearButton]=\"false\"\r\n    [disabled]=\"disabled\"\r\n    [filterable]=\"true\"\r\n    (ngModelChange)=\"onValueChange($event)\"\r\n    (blur)=\"onBlur()\"\r\n    (focus)=\"onFocus()\"\r\n    (mousedown)=\"onMouseDown($event)\"\r\n    (keydown)=\"onKeyDown()\">\r\n      <ng-template kendoMultiSelectTagTemplate let-dataItem>\r\n        <div [id]=\"getTagItemId(dataItem)\">\r\n          <span *ngIf=\"!customTemplate\" [ngwkTooltip]=\"getTagItemText(dataItem)\" ngwkTooltipPosition=\"top-left\">{{ getTagItemText(dataItem) }}</span>\r\n          <div *ngIf=\"customTemplate\">\r\n            <ng-container *ngTemplateOutlet=\"customTemplate; context: getTagContext(dataItem)\"></ng-container>\r\n          </div>\r\n        </div>\r\n      </ng-template>\r\n      <ng-template kendoComboBoxNoDataTemplate>\r\n        <span>{{'no_data_found' | locale }}</span>\r\n      </ng-template>\r\n  </kendo-multiselect>\r\n\r\n  <button #ngwkTagsOpenButton id=\"tagsOpenInputButton\" *ngIf=\"!isInputOpen\" class=\"openInputButton\" [disabled]=\"isButtonDisabled()\">\r\n    <ucc-icon key=\"addIcon\"></ucc-icon>\r\n  </button>\r\n\r\n</div>",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => TagsComponent),
                        multi: true
                    },
                    {
                        provide: ReadonlyFocusableInput,
                        useExisting: forwardRef(() => TagsComponent),
                        multi: true
                    }
                ],
                styles: [":host ::ng-deep .k-multiselect{white-space:normal}:host ::ng-deep .k-multiselect-wrap{padding-right:0;border-width:0px;border-style:none}:host ::ng-deep .k-multiselect-wrap .k-clear-value{top:1px}:host ::ng-deep .k-button{border-radius:25px;color:#009881;background-color:#fff;border-color:#009881;line-height:1.5px;height:22px;margin-right:5px;margin-bottom:5px;max-width:250px;cursor:auto;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}:host ::ng-deep .k-button span:first-child{color:#009881!important;font-size:12px!important;line-height:12px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}:host ::ng-deep .k-button:active{box-shadow:none}:host ::ng-deep .k-button:hover{background-color:#f7fcfb}:host ::ng-deep .k-button[disabled]{opacity:.5;cursor:default;pointer-events:none}:host ::ng-deep .k-button .k-select .k-icon{padding:0;margin-left:1px;cursor:pointer}:host ::ng-deep .k-icon{font-size:12px;padding-left:5px}:host ::ng-deep .hideInput .k-multiselect-wrap input{display:none}:host ::ng-deep .openInputButton{align-self:flex-end;margin-bottom:5px;min-width:22px;max-width:22px;min-height:22px;max-height:22px;border-radius:50%;border:none;cursor:pointer;overflow:hidden;outline:none;background-color:#c9efe9;color:#fff}:host ::ng-deep .openInputButton i{font-size:16px;color:#009881}:host ::ng-deep .openInputButton:focus{border:1px solid #009881}:host ::ng-deep .openInputButton:hover{background-color:#e1f6f3}:host ::ng-deep .openInputButton[disabled]{opacity:.5;cursor:default;pointer-events:none}:host ::ng-deep .invalidTag{color:#fb7e5d;border-color:#fb7e5d}:host ::ng-deep .invalidTag span:first-child{color:#fb7e5d!important}:host ::ng-deep .invalidTag:hover{background-color:#fff5f2}\n"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { allowCustom: [{
            type: Input
        }], textField: [{
            type: Input
        }], searchMinLength: [{
            type: Input
        }], canAddMoreTags: [{
            type: Input
        }], isTagInvalid: [{
            type: Input
        }], customTemplate: [{
            type: Input
        }], addCustom: [{
            type: Output
        }], filterEvent: [{
            type: Output,
            args: ['filter']
        }], _ngwkTags: [{
            type: ViewChild,
            args: ['ngwkTags', { static: true }]
        }], _ngwkTagsElementRef: [{
            type: ViewChild,
            args: ['ngwkTags', { read: ElementRef, static: true }]
        }], _ngwkTagsOpenButtonElementRef: [{
            type: ViewChild,
            args: ['ngwkTagsOpenButton', { read: ElementRef }]
        }], 
    //#endregion
    //#region Public Methods
    /** @ignore */
    documentClick: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }], data: [{
            type: Input
        }] }); })();

class TagsModule {
}
TagsModule.ɵfac = function TagsModule_Factory(t) { return new (t || TagsModule)(); };
TagsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TagsModule });
TagsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            LocalizationModule,
            IconModule,
            DropDownsModule,
            TooltipModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TagsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    LocalizationModule,
                    IconModule,
                    DropDownsModule,
                    TooltipModule
                ],
                exports: [
                    TagsComponent
                ],
                declarations: [
                    TagsComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TagsModule, { declarations: function () { return [TagsComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        LocalizationModule,
        IconModule,
        DropDownsModule,
        TooltipModule]; }, exports: function () { return [TagsComponent]; } }); })();

/**
 * Este componente se utiliza para la declaración de un selector de periodicidad. Se le debe pasar un Array de [INgwkPeriodicitySelectorItem]{@link INgwkPeriodicitySelectorItem},
 * los cuales mostraran una serie de items con la Label definida. Para gestionar el estado de seleccionado de cada uno de los Item,
 * en el NgModel se le pasará un Array de los identificadores de los Item que esten seleccionados. De manera opcional se puede pasar
 * también qué identificadores de los Item estan deshabilitados a través del Input 'disabledItems' y, también, se puede deshabilitar
 * totalmente el componente con el Input de 'disabled'
 *
 * @example
 * <ngwk-periodicity-selector
 *  [(ngModel)]="selectedPeriodicityItems"
 *  [periodicitySelectorItems]="periodicitySelectorItems"
 *  [disabledItems]="disabledPeriodicityItems"
 *  [disabled]="disabled">
 * </ngwk-periodicity-selector>
 *
 */
class PeriodicitySelectorComponent extends BaseInput {
    constructor() {
        //#region Privates
        super(...arguments);
        this._periodicitySelectorItems = [];
        this._disabledItems = [];
        this._disabled = false;
        this._readonly = false;
        //#endregion
    }
    //#endregion
    //#region Public Methods
    /** @ignore */
    onItemClick(id) {
        if (!this.readonly) {
            const checkedValues = this.internalValue.slice(0);
            if (checkedValues.includes(id)) {
                checkedValues.splice(checkedValues.indexOf(id), 1);
            }
            else {
                checkedValues.push(id);
            }
            this.internalValue = checkedValues;
        }
    }
    /** @ignore */
    isDisabled(id) {
        return this.disabled || this.disabledItems.includes(id);
    }
    /** @ignore */
    isChecked(id) {
        return this.internalValue && this.internalValue.includes(id);
    }
    //#endregion
    //#region Properties
    /**
     * Permite obtener los [INgwkPeriodicitySelectorItem]{@link INgwkPeriodicitySelectorItem} que se mostrarán dentro del componente
     */
    get periodicitySelectorItems() {
        return this._periodicitySelectorItems;
    }
    /**
     * Permite definir los [INgwkPeriodicitySelectorItem]{@link INgwkPeriodicitySelectorItem} que se mostrarán dentro del componente
     *
     * @param value Los [INgwkPeriodicitySelectorItem]{@link INgwkPeriodicitySelectorItem}
     */
    set periodicitySelectorItems(value) {
        this._periodicitySelectorItems = value;
    }
    /**
     * Permite obtener los identificadores de los [INgwkPeriodicitySelectorItem]{@link INgwkPeriodicitySelectorItem} que están deshabilitados
     */
    get disabledItems() {
        return this._disabledItems;
    }
    /**
     * Permite definir los identificadores de los [INgwkPeriodicitySelectorItem]{@link INgwkPeriodicitySelectorItem} que están deshabilitados
     *
     * @param value Los identificadores de los [INgwkPeriodicitySelectorItem]{@link INgwkPeriodicitySelectorItem} que están deshabilitados
     */
    set disabledItems(value) {
        this._disabledItems = value;
    }
    /**
     * Permite consultar si todos los [INgwkPeriodicitySelectorItem]{@link INgwkPeriodicitySelectorItem} estan deshabilitados o no
     */
    get disabled() {
        return this._disabled;
    }
    /**
     * Permite habilitar o deshabilitar todos los [INgwkPeriodicitySelectorItem]{@link INgwkPeriodicitySelectorItem}
     *
     * @param value Valor que habilita o deshabilita todos los [INgwkPeriodicitySelectorItem]{@link INgwkPeriodicitySelectorItem}
     */
    set disabled(value) {
        this._disabled = value;
    }
    /**
     * Permite consultar si todos los [INgwkPeriodicitySelectorItem]{@link INgwkPeriodicitySelectorItem} estan readonly o no
     */
    get readonly() {
        return this._readonly;
    }
    /**
     * Permite activar o desactivar el estado de readonly de todos los [INgwkPeriodicitySelectorItem]{@link INgwkPeriodicitySelectorItem}
     *
     * @param value Valor que activa o desactiva el estado de readonly de todos los [INgwkPeriodicitySelectorItem]{@link INgwkPeriodicitySelectorItem}
     */
    set readonly(value) {
        this._readonly = value;
    }
}
PeriodicitySelectorComponent.ɵfac = /*@__PURE__*/ function () { let ɵPeriodicitySelectorComponent_BaseFactory; return function PeriodicitySelectorComponent_Factory(t) { return (ɵPeriodicitySelectorComponent_BaseFactory || (ɵPeriodicitySelectorComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(PeriodicitySelectorComponent)))(t || PeriodicitySelectorComponent); }; }();
PeriodicitySelectorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PeriodicitySelectorComponent, selectors: [["ngwk-periodicity-selector"]], inputs: { periodicitySelectorItems: "periodicitySelectorItems", disabledItems: "disabledItems", disabled: "disabled", readonly: "readonly" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => PeriodicitySelectorComponent),
                multi: true
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 1, consts: [[1, "horizontalLayout", "fluidItems"], [3, "id", "ngClass", "label", "checked", "disabled", "readonly", "itemClick", 4, "ngFor", "ngForOf"], [3, "id", "ngClass", "label", "checked", "disabled", "readonly", "itemClick"]], template: function PeriodicitySelectorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, PeriodicitySelectorComponent_ngwk_periodicity_selector_item_1_Template, 1, 9, "ngwk-periodicity-selector-item", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.periodicitySelectorItems);
    } }, directives: function () { return [ɵngcc4.NgForOf, PeriodicitySelectorItemComponent, ɵngcc4.NgClass]; }, styles: ["[_nghost-%COMP%]     .fluidItems{display:flex;flex-wrap:wrap}[_nghost-%COMP%]     .periodicitySelectorItemDisabled{opacity:.5;cursor:default;pointer-events:none}"] });
PeriodicitySelectorComponent.propDecorators = {
    periodicitySelectorItems: [{ type: Input }],
    disabledItems: [{ type: Input }],
    disabled: [{ type: Input }],
    readonly: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PeriodicitySelectorComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-periodicity-selector',
                template: "<div class=\"horizontalLayout fluidItems\">\r\n    <ngwk-periodicity-selector-item \r\n        *ngFor=\"let item of periodicitySelectorItems\"\r\n        [id]=\"item.id\"\r\n        [ngClass]=\"{ periodicitySelectorItemDisabled : isDisabled(item.id) }\"\r\n        [label]=\"item.label\" \r\n        [checked]=\"isChecked(item.id)\"\r\n        [attr.checked]=\"isChecked(item.id)\"\r\n        [disabled]=\"isDisabled(item.id)\"\r\n        [readonly]=\"readonly\"\r\n        (itemClick)=\"onItemClick(item.id)\">\r\n    </ngwk-periodicity-selector-item>\r\n</div>",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => PeriodicitySelectorComponent),
                        multi: true
                    },
                ],
                styles: [":host ::ng-deep .fluidItems{display:flex;flex-wrap:wrap}:host ::ng-deep .periodicitySelectorItemDisabled{opacity:.5;cursor:default;pointer-events:none}\n"]
            }]
    }], null, { periodicitySelectorItems: [{
            type: Input
        }], disabledItems: [{
            type: Input
        }], disabled: [{
            type: Input
        }], readonly: [{
            type: Input
        }] }); })();

/**
 * Componente interno que representa un Item del [PeriodicitySelectorComponent]{@link PeriodicitySelectorComponent}
 *
 * @example
 * <ngwk-periodicity-selector-item
 *  [label]="label"
 *  [checked]="internalValue?.includes(item.id)">
 * </ngwk-periodicity-selector-item>
 *
 */
class PeriodicitySelectorItemComponent {
    //#endregion
    /** @ignore */
    constructor(_elementRef, _renderer) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        //#region Privates
        this._label = null;
        this._checked = null;
        this._disabled = false;
        this._readonly = false;
        this._itemClick = new EventEmitter();
    }
    //#region Public Methods
    onItemClick() {
        this._itemClick.emit();
    }
    //#endregion
    //#region Properties
    /**
     * Permite obtener la label del Periodicity Selector Item
     */
    get label() {
        return this._label;
    }
    /**
     * Permite definir la label del Periodicity Selector Item
     *
     * @param value La label del Periodicity Selector Item
     */
    set label(value) {
        this._label = value;
    }
    /**
     * Permite consultar si el estado de seleccionado del Periodicity Selector Item está activado o no
     */
    get checked() {
        return this._checked;
    }
    /**
     * Permite activar o desactivar el estado de seleccionado del Periodicity Selector Item
     *
     * @param value Activa o desactiva el estado de seleccionado del Periodicity Selector Item
     */
    set checked(value) {
        this._checked = value;
    }
    /**
     * Permite consultar si el estado de disabled del Periodicity Selector Item está activado o no
     */
    get disabled() {
        return this._disabled;
    }
    /**
     * Permite activar o desactivar el estado de disabled del Periodicity Selector Item
     *
     * @param value Activa o desactiva el estado de disabled del Periodicity Selector Item
     */
    set disabled(value) {
        this._disabled = value;
    }
    /**
     * Permite consultar si el estado de readonly del Periodicity Selector Item está activado o no
     */
    get readonly() {
        return this._readonly;
    }
    /**
     * Permite activar o desactivar el estado de readonly del Periodicity Selector Item
     *
     * @param value Valor que activa o desactiva el estado de disabled del Periodicity Selector Item
     */
    set readonly(value) {
        this._readonly = value;
    }
    /**
     * Emite un evento cuando se hace click en el botón del Periodicity Selector Item
     */
    get itemClick() {
        return this._itemClick;
    }
}
PeriodicitySelectorItemComponent.ɵfac = function PeriodicitySelectorItemComponent_Factory(t) { return new (t || PeriodicitySelectorItemComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
PeriodicitySelectorItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PeriodicitySelectorItemComponent, selectors: [["ngwk-periodicity-selector-item"]], inputs: { label: "label", checked: "checked", disabled: "disabled", readonly: "readonly" }, outputs: { itemClick: "itemClick" }, decls: 2, vars: 6, consts: [[1, "periodicitySelectorItem", "alignMiddle", 3, "ngClass", "disabled", "click"]], template: function PeriodicitySelectorItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("click", function PeriodicitySelectorItemComponent_Template_button_click_0_listener() { return ctx.onItemClick(); });
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(3, _c19, ctx.checked, ctx.readonly))("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.label, "\n");
    } }, directives: [ɵngcc4.NgClass], styles: ["[_nghost-%COMP%]     .periodicitySelectorItem{font-size:12px;min-width:30px;max-width:30px;min-height:30px;max-height:30px;border-radius:50%;cursor:pointer;overflow:hidden;outline:none;margin:0 10px 10px 0;padding:4px;background-color:transparent;border:1px solid #C8C8C8;color:#b7b7b7}[_nghost-%COMP%]     .periodicitySelectorItem:focus{border:1px solid #989898;color:#989898}[_nghost-%COMP%]     .periodicitySelectorItem:hover{background-color:#ededed}[_nghost-%COMP%]     .periodicitySelectorItem:active{border:0px;background-color:#b5b5b5;color:#fff}[_nghost-%COMP%]     .periodicitySelectorItemChecked{border:1px solid transparent;background-color:#faddb1;color:#e6742e}[_nghost-%COMP%]     .periodicitySelectorItemChecked:focus{border:1px solid #E6742E;color:#e6742e}[_nghost-%COMP%]     .periodicitySelectorItemChecked:hover{background-color:#f7d299}[_nghost-%COMP%]     .periodicitySelectorItemChecked:active{background-color:#fa9200;color:#fff}[_nghost-%COMP%]     .periodicitySelectorItemReadonly{cursor:default!important;pointer-events:none}"] });
/** @nocollapse */
PeriodicitySelectorItemComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
PeriodicitySelectorItemComponent.propDecorators = {
    label: [{ type: Input }],
    checked: [{ type: Input }],
    disabled: [{ type: Input }],
    readonly: [{ type: Input }],
    itemClick: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PeriodicitySelectorItemComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-periodicity-selector-item',
                template: "<button \r\n    class=\"periodicitySelectorItem alignMiddle\" \r\n    [ngClass]=\"{ periodicitySelectorItemChecked : checked, periodicitySelectorItemReadonly : readonly }\" \r\n    [disabled]=\"disabled\"\r\n    (click)=\"onItemClick()\">\r\n        {{label}}\r\n</button>",
                styles: [":host ::ng-deep .periodicitySelectorItem{font-size:12px;min-width:30px;max-width:30px;min-height:30px;max-height:30px;border-radius:50%;cursor:pointer;overflow:hidden;outline:none;margin:0 10px 10px 0;padding:4px;background-color:transparent;border:1px solid #C8C8C8;color:#b7b7b7}:host ::ng-deep .periodicitySelectorItem:focus{border:1px solid #989898;color:#989898}:host ::ng-deep .periodicitySelectorItem:hover{background-color:#ededed}:host ::ng-deep .periodicitySelectorItem:active{border:0px;background-color:#b5b5b5;color:#fff}:host ::ng-deep .periodicitySelectorItemChecked{border:1px solid transparent;background-color:#faddb1;color:#e6742e}:host ::ng-deep .periodicitySelectorItemChecked:focus{border:1px solid #E6742E;color:#e6742e}:host ::ng-deep .periodicitySelectorItemChecked:hover{background-color:#f7d299}:host ::ng-deep .periodicitySelectorItemChecked:active{background-color:#fa9200;color:#fff}:host ::ng-deep .periodicitySelectorItemReadonly{cursor:default!important;pointer-events:none}\n"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { label: [{
            type: Input
        }], checked: [{
            type: Input
        }], disabled: [{
            type: Input
        }], readonly: [{
            type: Input
        }], itemClick: [{
            type: Output
        }] }); })();

class PeriodicitySelectorModule {
}
PeriodicitySelectorModule.ɵfac = function PeriodicitySelectorModule_Factory(t) { return new (t || PeriodicitySelectorModule)(); };
PeriodicitySelectorModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PeriodicitySelectorModule });
PeriodicitySelectorModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            FormsModule,
            CommonModule,
            IconModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PeriodicitySelectorModule, [{
        type: NgModule,
        args: [{
                imports: [
                    FormsModule,
                    CommonModule,
                    IconModule
                ],
                declarations: [
                    PeriodicitySelectorComponent,
                    PeriodicitySelectorItemComponent
                ],
                exports: [
                    PeriodicitySelectorComponent,
                    PeriodicitySelectorItemComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PeriodicitySelectorModule, { declarations: function () { return [PeriodicitySelectorComponent, PeriodicitySelectorItemComponent]; }, imports: function () { return [FormsModule,
        CommonModule,
        IconModule]; }, exports: function () { return [PeriodicitySelectorComponent, PeriodicitySelectorItemComponent]; } }); })();

/**
 * Este componente se utiliza para la declaración de inputs de tipo Multi Dropdown. Tiene una funcionalidad similar a los
 * [DropDownListComponent]{@link DropDownListComponent}, pero donde se puede seleccionar más de un objeto a la vez.
 *
 * @example
 * <ngwk-multi-dropdown-list
 *  [(ngModel)]="selectedItems"
 *  [data]="data"
 *  [textField]="textField"
 *  [valueField]="valueField"
 *  [selectAllCheckbox]="selectAllCheckbox">
 * </ngwk-multi-dropdown-list>
 */
class MultiDropDownListComponent extends ReadonlyFocusableInput {
    /** @ignore */
    constructor() {
        super();
        /** @ignore */
        this.popupSettings = { width: 'auto' };
        /** Permite activar o desactivar el header con la funcionalidad de seleccionar todos los objetos */
        this.selectAllCheckbox = true;
        /** Permite definir el listado de objetos que se mostrará en el desplegable del DropDown */
        this.data = null;
        /** Permite definir el campo de tipo string que se mostrará tanto en el listado de los objetos mostrados en el desplegable del DropDown como en la label de objetos seleccionados */
        this.textField = null;
        /** Permite definir el campo de tipo string identificador de cada uno de los objetos mostrados en el desplegable del DropDown */
        this.valueField = null;
        /** Permite definir el TemplateRef custom de cada uno de los objetos mostrados en el desplegable del DropDown */
        this.itemTemplate = null;
        /** Permite definir el TemplateRef custom que aparecerá en la label de objetos que han sido seleccionados */
        this.valueTemplate = null;
        /** Indica si se va a usar un filtro para mostrar solo los elementos coincidentes */
        this.filterable = false;
        /** Permite definir el número mínimo de elementos a introducir para abrir el drowpdownlist */
        this.minFilterLength = 0;
        /** Permite definir la altura del desplegable del DropDown */
        this.popupHeight = 200;
        /** Deprecated */
        this.listHeight = 200;
        /** Evento que informa de cuando se ha cerrado el desplegable de objetos del DropDown */
        this.close = new EventEmitter();
        /** Evento que informa de cuando se ha abierto el desplegable de objetos del DropDown */
        this.open = new EventEmitter();
        /** Evento que indica que hay un cambio en el filtro de búsqueda */
        this.filterChange = new EventEmitter();
        this._currentSelectedItem = null;
    }
    /** @ignore */
    ngAfterViewInit() {
        this._dropdownlist.popupSettings.appendTo = "component";
    }
    /** @ignore */
    documentClick(event) {
        if (!this.disabled && !this.readonly) {
            if (!this._dropdownlist.isOpen && this._dropdownlistElementRef.nativeElement.contains(event.target)) {
                this._dropdownlist.toggle(true);
                this.open.emit();
            }
            else if (this._dropdownlist.isOpen) {
                const popup = document.getElementsByClassName('k-popup').item(0);
                if (popup && !popup.contains(event.target)) {
                    this._dropdownlist.toggle(false);
                    this.close.emit();
                }
            }
        }
    }
    /** @ignore */
    getPopupHeight() {
        return this.popupHeight !== 200 ? this.popupHeight : this.listHeight;
    }
    /** @ignore */
    onClose(event) {
        event.preventDefault();
    }
    /** @ignore */
    onOpen(event) {
        event.preventDefault();
    }
    /** @ignore */
    onKeydown(event) {
        if (!this.disabled && !this.readonly) {
            if (!this._dropdownlist.isOpen && event.altKey && event.key === 'ArrowDown') {
                this._dropdownlist.toggle(true);
                this.open.emit();
            }
            else if (this._dropdownlist.isOpen) {
                if (((event.altKey && event.key === 'ArrowUp') || event.key === 'Escape' || event.key === 'Tab')) {
                    this._dropdownlist.toggle(false);
                    this.close.emit();
                }
                else if (this._dropdownlist.isOpen && event.key === 'Enter') {
                    this.onCheckClick(this._currentSelectedItem);
                }
            }
        }
    }
    /** @ignore */
    onSelectionChange(item) {
        this._currentSelectedItem = item;
    }
    /** @ignore */
    getTextField(dataItem) {
        let textFieldExists = dataItem && dataItem.hasOwnProperty(this.textField);
        return textFieldExists ? dataItem[this.textField] : '';
    }
    /** @ignore */
    getTextFields() {
        if (this.internalValue) {
            let itemsTextField = this.internalValue.map(item => item[this.textField]);
            return itemsTextField.join(", ");
        }
    }
    /** @ignore */
    onCheckClick(dataItem) {
        if (this.internalValue !== null && this.internalValue !== undefined) {
            const dataItemIndex = this.internalValue.findIndex((item) => item[this.valueField] === dataItem[this.valueField]);
            if (dataItemIndex >= 0) {
                const temporalValue = this.internalValue.slice(0);
                temporalValue.splice(dataItemIndex, 1);
                this.internalValue = temporalValue;
            }
            else {
                const temporalValue = this.internalValue.slice(0);
                temporalValue.push(dataItem);
                this.internalValue = temporalValue;
            }
            ;
        }
        else {
            const temporalValue = [];
            temporalValue.push(dataItem);
            this.internalValue = temporalValue;
        }
    }
    /** @ignore */
    onCheckAllClick() {
        if (this.internalValue !== null && this.internalValue !== undefined && this.internalValue.length === this.data.length) {
            this.internalValue = [];
        }
        else {
            this.internalValue = this.data.slice(0);
        }
    }
    /** @ignore */
    isItemChecked(dataItem) {
        return this.internalValue && this.internalValue.findIndex((item) => item[this.valueField] === dataItem[this.valueField]) >= 0;
    }
    /** @ignore */
    isItemDisabled(dataItem) {
        return false;
    }
    /** @ignore */
    isHeaderChecked() {
        return this.internalValue && this.internalValue.length === this.data.length;
    }
    /** @ignore */
    isHeaderIndeterminate() {
        return this.internalValue && this.internalValue.length !== this.data.length && this.internalValue.length > 0;
    }
    handleFilter(e) {
        this.filterChange.emit(e);
    }
    //#region Getters & Setters
    /** @ignore */
    get inputFocus() {
        return this._dropdownlist;
    }
    /** @ignore */
    get isDropdownOpen() {
        return this._dropdownlist.isOpen;
    }
    /**
     * Permite obtener el ancho del desplegable del DropDown
     *
     * @return
     */
    get popupWidth() {
        return this.popupSettings.width;
    }
    /**
     * Permite definir el ancho del desplegable del DropDown
     *
     * @param value Nuevo valor para el ancho del desplegable del DropDown
     * @return
     */
    set popupWidth(value) {
        this.popupSettings.width = value;
    }
}
MultiDropDownListComponent.ɵfac = function MultiDropDownListComponent_Factory(t) { return new (t || MultiDropDownListComponent)(); };
MultiDropDownListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MultiDropDownListComponent, selectors: [["ngwk-multi-dropdown-list"]], viewQuery: function MultiDropDownListComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c20, 7);
        ɵngcc0.ɵɵviewQuery(_c20, 7, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._dropdownlist = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._dropdownlistElementRef = _t.first);
    } }, hostBindings: function MultiDropDownListComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function MultiDropDownListComponent_click_HostBindingHandler($event) { return ctx.documentClick($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, inputs: { selectAllCheckbox: "selectAllCheckbox", data: "data", textField: "textField", valueField: "valueField", itemTemplate: "itemTemplate", valueTemplate: "valueTemplate", filterable: "filterable", minFilterLength: "minFilterLength", popupHeight: "popupHeight", listHeight: "listHeight", popupWidth: "popupWidth" }, outputs: { close: "close", open: "open", filterChange: "filterChange" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => MultiDropDownListComponent),
                multi: true
            },
            {
                provide: ReadonlyFocusableInput,
                useExisting: forwardRef(() => MultiDropDownListComponent),
                multi: true
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 6, vars: 11, consts: [["ngwkTooltipPosition", "top-left", 3, "data", "filterable", "textField", "valueField", "readonly", "disabled", "popupSettings", "listHeight", "ngwkTooltip", "ngwkTooltipDisable", "blur", "focus", "open", "close", "keydown", "filterChange", "selectionChange"], ["dropDownList", ""], ["kendoComboBoxNoDataTemplate", ""], [4, "ngIf"], ["kendoDropDownListValueTemplate", ""], ["kendoDropDownListItemTemplate", ""], ["kendoDropDownListHeaderTemplate", ""], [1, "horizontalLayout", "multiCheckListHeader", 3, "click"], ["id", "multiDropdownCheckboxHeader", 3, "ngModel", "indeterminate"], [1, "colAvailable", "alignVerticalMiddle"], [1, "truncateText"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "horizontalLayout", "alignVerticalMiddle", "multiCheckListElement", 3, "click"], ["id", "multiDropdownCheckboxItem", 3, "ngModel", "disabled"], ["style", "width: 100%", 4, "ngIf"], [2, "width", "100%"]], template: function MultiDropDownListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "kendo-dropdownlist", 0, 1);
        ɵngcc0.ɵɵlistener("blur", function MultiDropDownListComponent_Template_kendo_dropdownlist_blur_0_listener() { return ctx.onBlur(); })("focus", function MultiDropDownListComponent_Template_kendo_dropdownlist_focus_0_listener() { return ctx.onFocus(); })("open", function MultiDropDownListComponent_Template_kendo_dropdownlist_open_0_listener($event) { return ctx.onOpen($event); })("close", function MultiDropDownListComponent_Template_kendo_dropdownlist_close_0_listener($event) { return ctx.onClose($event); })("keydown", function MultiDropDownListComponent_Template_kendo_dropdownlist_keydown_0_listener($event) { return ctx.onKeydown($event); })("filterChange", function MultiDropDownListComponent_Template_kendo_dropdownlist_filterChange_0_listener($event) { return ctx.handleFilter($event); })("selectionChange", function MultiDropDownListComponent_Template_kendo_dropdownlist_selectionChange_0_listener($event) { return ctx.onSelectionChange($event); });
        ɵngcc0.ɵɵtemplate(2, MultiDropDownListComponent_ng_template_2_Template, 3, 3, "ng-template", 2);
        ɵngcc0.ɵɵtemplate(3, MultiDropDownListComponent_3_Template, 1, 0, undefined, 3);
        ɵngcc0.ɵɵtemplate(4, MultiDropDownListComponent_ng_template_4_Template, 2, 2, "ng-template", 4);
        ɵngcc0.ɵɵtemplate(5, MultiDropDownListComponent_ng_template_5_Template, 4, 4, "ng-template", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("data", ctx.data)("filterable", ctx.filterable)("textField", ctx.textField)("valueField", ctx.valueField)("readonly", ctx.readonly)("disabled", ctx.disabled)("popupSettings", ctx.popupSettings)("listHeight", ctx.getPopupHeight())("ngwkTooltip", ctx.getTextFields())("ngwkTooltipDisable", ctx.isDropdownOpen);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.selectAllCheckbox);
    } }, directives: [ɵngcc7.DropDownListComponent, ɵngcc2.NgwkTooltipDirective, ɵngcc7.NoDataTemplateDirective, ɵngcc4.NgIf, ɵngcc7.ValueTemplateDirective, ɵngcc7.ItemTemplateDirective, ɵngcc7.HeaderTemplateDirective, CheckboxComponent, ɵngcc1.NgControlStatus, ɵngcc1.NgModel, ɵngcc4.NgTemplateOutlet], pipes: [ɵngcc2.LocalePipe], styles: ["[_nghost-%COMP%]     kendo-dropdownlist{height:25px}[_nghost-%COMP%]     kendo-dropdownlist kendo-popup kendo-list .k-list .k-item{padding:0}[_nghost-%COMP%]     kendo-dropdownlist kendo-popup kendo-list .k-list .k-item .multiCheckListElement{padding:4px 8px}[_nghost-%COMP%]     kendo-dropdownlist kendo-popup .multiCheckListHeader{padding:4px 8px;border-bottom:1px solid #ccc}[_nghost-%COMP%]     kendo-dropdownlist kendo-popup .multiCheckListHeader ngwk-checkbox{height:25px}[_nghost-%COMP%]     kendo-dropdownlist kendo-popup .multiCheckListHeader ngwk-checkbox input[type=checkbox]:checked+label:before{border:1px solid #0081C6!important}[_nghost-%COMP%]     kendo-dropdownlist kendo-popup .multiCheckListHeader ngwk-checkbox input[type=checkbox]:checked+label:after{top:4px!important;left:2px!important}[_nghost-%COMP%]     kendo-dropdownlist kendo-popup .multiCheckListHeader span{font-size:13px!important}[_nghost-%COMP%]     kendo-dropdownlist kendo-popup .multiCheckListElement ngwk-checkbox{height:23px}[_nghost-%COMP%]     kendo-dropdownlist kendo-popup .multiCheckListElement ngwk-checkbox input[type=checkbox]:checked+label:before{border:1px solid #0081C6!important}[_nghost-%COMP%]     kendo-dropdownlist kendo-popup .multiCheckListElement ngwk-checkbox input[type=checkbox]:checked+label:after{top:4px!important;left:2px!important}.inputLabelContent[_nghost-%COMP%]     kendo-dropdownlist, .inputLabelContent   [_nghost-%COMP%]     kendo-dropdownlist{width:100%;user-select:none;font-size:13px}.inputLabelContent[_nghost-%COMP%]     kendo-dropdownlist span, .inputLabelContent   [_nghost-%COMP%]     kendo-dropdownlist span{color:#373737!important;border:none;background-color:transparent!important;background-image:none!important}.inputLabelContent[_nghost-%COMP%]     kendo-dropdownlist span span.k-select, .inputLabelContent   [_nghost-%COMP%]     kendo-dropdownlist span span.k-select{width:auto;padding:4px}.inputLabelContent[_nghost-%COMP%]     kendo-dropdownlist span:hover, .inputLabelContent   [_nghost-%COMP%]     kendo-dropdownlist span:hover{color:#333!important}.inputLabelContent[_nghost-%COMP%]     kendo-dropdownlist span:focus, .inputLabelContent   [_nghost-%COMP%]     kendo-dropdownlist span:focus{border:none!important;background-color:transparent!important;box-shadow:0 0!important;color:#3390ff!important}.inputLabelContent[_nghost-%COMP%]     kendo-dropdownlist span.k-state-focused .k-input::selection, .inputLabelContent   [_nghost-%COMP%]     kendo-dropdownlist span.k-state-focused .k-input::selection{background-color:#3390ff!important}.inputLabelContent[_nghost-%COMP%]     kendo-dropdownlist span .k-input, .inputLabelContent   [_nghost-%COMP%]     kendo-dropdownlist span .k-input{cursor:default;user-select:text;padding:4px!important}.inputLabelContent[_nghost-%COMP%]     kendo-dropdownlist span .k-input::selection, .inputLabelContent   [_nghost-%COMP%]     kendo-dropdownlist span .k-input::selection{background:#3390FF}.inputLabelContent[_nghost-%COMP%]     kendo-dropdownlist span .k-dropdown .k-dropdown-wrap .k-select, .inputLabelContent   [_nghost-%COMP%]     kendo-dropdownlist span .k-dropdown .k-dropdown-wrap .k-select{width:auto;padding:4px}.inputLabelContent[_nghost-%COMP%]     kendo-dropdownlist .k-state-focused span div, .inputLabelContent   [_nghost-%COMP%]     kendo-dropdownlist .k-state-focused span div{color:#fff!important;background-color:#3390ff!important}"] });
/** @nocollapse */
MultiDropDownListComponent.ctorParameters = () => [];
MultiDropDownListComponent.propDecorators = {
    selectAllCheckbox: [{ type: Input }],
    data: [{ type: Input }],
    textField: [{ type: Input }],
    valueField: [{ type: Input }],
    itemTemplate: [{ type: Input }],
    valueTemplate: [{ type: Input }],
    filterable: [{ type: Input }],
    minFilterLength: [{ type: Input }],
    popupHeight: [{ type: Input }],
    listHeight: [{ type: Input }],
    close: [{ type: Output }],
    open: [{ type: Output }],
    filterChange: [{ type: Output }],
    _dropdownlist: [{ type: ViewChild, args: ["dropDownList", { static: true },] }],
    _dropdownlistElementRef: [{ type: ViewChild, args: ["dropDownList", { read: ElementRef, static: true },] }],
    documentClick: [{ type: HostListener, args: ['document:click', ['$event'],] }],
    popupWidth: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MultiDropDownListComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-multi-dropdown-list',
                template: "<kendo-dropdownlist\r\n  #dropDownList\r\n  [data]=\"data\"\r\n  [filterable]=\"filterable\"\r\n  [textField]=\"textField\"\r\n  [valueField]=\"valueField\"\r\n  [readonly]=\"readonly\"\r\n  [disabled]=\"disabled\"\r\n  [popupSettings]=\"popupSettings\"\r\n  [listHeight]=\"getPopupHeight()\"\r\n  [ngwkTooltip]=\"getTextFields()\"\r\n  [ngwkTooltipDisable]=\"isDropdownOpen\"\r\n  ngwkTooltipPosition=\"top-left\"\r\n  (blur)=\"onBlur()\"\r\n  (focus)=\"onFocus()\"\r\n  (open)=\"onOpen($event)\"\r\n  (close)=\"onClose($event)\"\r\n  (keydown)=\"onKeydown($event)\"\r\n  (filterChange)=\"handleFilter($event)\"\r\n  (selectionChange)=\"onSelectionChange($event)\">\r\n  \r\n  <ng-template kendoComboBoxNoDataTemplate>\r\n    <span>{{'no_data_found' | locale }}</span>\r\n  </ng-template>\r\n\r\n  <ng-template *ngIf=\"selectAllCheckbox\" kendoDropDownListHeaderTemplate>\r\n    <div class=\"horizontalLayout multiCheckListHeader\" (click)=\"onCheckAllClick()\">\r\n      <ngwk-checkbox\r\n        id=\"multiDropdownCheckboxHeader\"\r\n        [ngModel]=\"isHeaderChecked()\"\r\n        [indeterminate]=\"isHeaderIndeterminate()\">\r\n      </ngwk-checkbox>\r\n      <span class=\"colAvailable alignVerticalMiddle\">\r\n        <span>{{ \"select_all\" | locale }}</span>\r\n      </span>\r\n    </div>\r\n  </ng-template>\r\n\r\n  <ng-template kendoDropDownListValueTemplate let-dataItem>\r\n    <ng-container *ngIf=\"!valueTemplate\">\r\n      <span class=\"truncateText\">{{ getTextFields() }}</span>\r\n    </ng-container>\r\n    <span *ngIf=\"valueTemplate\">\r\n      <ng-container *ngTemplateOutlet=\"valueTemplate; context: { dataItem: dataItem }\"></ng-container>\r\n    </span>\r\n  </ng-template>\r\n\r\n  <ng-template kendoDropDownListItemTemplate let-dataItem>\r\n    <div class=\"horizontalLayout alignVerticalMiddle multiCheckListElement\" (click)=\"onCheckClick(dataItem)\">\r\n      <ngwk-checkbox\r\n        id=\"multiDropdownCheckboxItem\"\r\n        [ngModel]=\"isItemChecked(dataItem)\"\r\n        [disabled]=\"isItemDisabled(dataItem)\">\r\n      </ngwk-checkbox>\r\n      <ng-container *ngIf=\"!itemTemplate\" style=\"width: 100%\">\r\n        <span class=\"truncateText\">{{ getTextField(dataItem) }}</span>\r\n      </ng-container>\r\n      <span *ngIf=\"itemTemplate\" style=\"width: 100%\">\r\n        <ng-container *ngTemplateOutlet=\"itemTemplate; context: { dataItem: dataItem }\"></ng-container>\r\n      </span>\r\n    </div>\r\n  </ng-template>\r\n\r\n</kendo-dropdownlist>",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => MultiDropDownListComponent),
                        multi: true
                    },
                    {
                        provide: ReadonlyFocusableInput,
                        useExisting: forwardRef(() => MultiDropDownListComponent),
                        multi: true
                    }
                ],
                styles: [":host ::ng-deep kendo-dropdownlist{height:25px}:host ::ng-deep kendo-dropdownlist kendo-popup kendo-list .k-list .k-item{padding:0}:host ::ng-deep kendo-dropdownlist kendo-popup kendo-list .k-list .k-item .multiCheckListElement{padding:4px 8px}:host ::ng-deep kendo-dropdownlist kendo-popup .multiCheckListHeader{padding:4px 8px;border-bottom:1px solid #ccc}:host ::ng-deep kendo-dropdownlist kendo-popup .multiCheckListHeader ngwk-checkbox{height:25px}:host ::ng-deep kendo-dropdownlist kendo-popup .multiCheckListHeader ngwk-checkbox input[type=checkbox]:checked+label:before{border:1px solid #0081C6!important}:host ::ng-deep kendo-dropdownlist kendo-popup .multiCheckListHeader ngwk-checkbox input[type=checkbox]:checked+label:after{top:4px!important;left:2px!important}:host ::ng-deep kendo-dropdownlist kendo-popup .multiCheckListHeader span{font-size:13px!important}:host ::ng-deep kendo-dropdownlist kendo-popup .multiCheckListElement ngwk-checkbox{height:23px}:host ::ng-deep kendo-dropdownlist kendo-popup .multiCheckListElement ngwk-checkbox input[type=checkbox]:checked+label:before{border:1px solid #0081C6!important}:host ::ng-deep kendo-dropdownlist kendo-popup .multiCheckListElement ngwk-checkbox input[type=checkbox]:checked+label:after{top:4px!important;left:2px!important}:host-context(.inputLabelContent) ::ng-deep kendo-dropdownlist{width:100%;user-select:none;font-size:13px}:host-context(.inputLabelContent) ::ng-deep kendo-dropdownlist span{color:#373737!important;border:none;background-color:transparent!important;background-image:none!important}:host-context(.inputLabelContent) ::ng-deep kendo-dropdownlist span span.k-select{width:auto;padding:4px}:host-context(.inputLabelContent) ::ng-deep kendo-dropdownlist span:hover{color:#333!important}:host-context(.inputLabelContent) ::ng-deep kendo-dropdownlist span:focus{border:none!important;background-color:transparent!important;box-shadow:0 0!important;color:#3390ff!important}:host-context(.inputLabelContent) ::ng-deep kendo-dropdownlist span.k-state-focused .k-input::selection{background-color:#3390ff!important}:host-context(.inputLabelContent) ::ng-deep kendo-dropdownlist span .k-input{cursor:default;user-select:text;padding:4px!important}:host-context(.inputLabelContent) ::ng-deep kendo-dropdownlist span .k-input::selection{background:#3390FF}:host-context(.inputLabelContent) ::ng-deep kendo-dropdownlist span .k-dropdown .k-dropdown-wrap .k-select{width:auto;padding:4px}:host-context(.inputLabelContent) ::ng-deep kendo-dropdownlist .k-state-focused span div{color:#fff!important;background-color:#3390ff!important}\n"]
            }]
    }], function () { return []; }, { selectAllCheckbox: [{
            type: Input
        }], data: [{
            type: Input
        }], textField: [{
            type: Input
        }], valueField: [{
            type: Input
        }], itemTemplate: [{
            type: Input
        }], valueTemplate: [{
            type: Input
        }], filterable: [{
            type: Input
        }], minFilterLength: [{
            type: Input
        }], popupHeight: [{
            type: Input
        }], listHeight: [{
            type: Input
        }], close: [{
            type: Output
        }], open: [{
            type: Output
        }], filterChange: [{
            type: Output
        }], 
    /** @ignore */
    documentClick: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }], popupWidth: [{
            type: Input
        }], _dropdownlist: [{
            type: ViewChild,
            args: ["dropDownList", { static: true }]
        }], _dropdownlistElementRef: [{
            type: ViewChild,
            args: ["dropDownList", { read: ElementRef, static: true }]
        }] }); })();

class MultiDropDownListModule {
}
MultiDropDownListModule.ɵfac = function MultiDropDownListModule_Factory(t) { return new (t || MultiDropDownListModule)(); };
MultiDropDownListModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: MultiDropDownListModule });
MultiDropDownListModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            DropDownListModule$1,
            LocalizationModule,
            IconModule,
            CheckboxModule,
            TooltipModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MultiDropDownListModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    DropDownListModule$1,
                    LocalizationModule,
                    IconModule,
                    CheckboxModule,
                    TooltipModule
                ],
                exports: [
                    MultiDropDownListComponent
                ],
                declarations: [
                    MultiDropDownListComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MultiDropDownListModule, { declarations: function () { return [MultiDropDownListComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        DropDownListModule$1,
        LocalizationModule,
        IconModule, CheckboxModule, TooltipModule]; }, exports: function () { return [MultiDropDownListComponent]; } }); })();

/**
 * Este componente se utiliza para la declaración de un sistema de rating en formato de estrellas. Se debe definir el rating asociado
 * (si es 0 no saldrán estrellas) y, de manera opcional, la cantidad de estrellas para hacer el rating. De manera predeterminada son 5.
 * De manera opcional se puede hacer que el control sea readonly o deshabilitarlo.
 *
 * @example
 * <ngwk-star-rating
 *  [(ngModel)]="rating"
 *  [stars]="stars"
 *  [customClass]="customClass"
 *  [customTexts]="customTexts"
 *  [readonly]="readonly"
 *  [disabled]="disabled">
 * </ngwk-star-rating>
 *
 */
class StarRatingComponent extends BaseInput {
    constructor() {
        //#region Privates
        super(...arguments);
        this._customClass = null;
        this._customTexts = null;
        this._readonly = false;
        this._stars = 5;
        this._starItems = [
            { id: 1, active: false },
            { id: 2, active: false },
            { id: 3, active: false },
            { id: 4, active: false },
            { id: 5, active: false }
        ];
        //#endregion
    }
    //#endregion
    //#region Public Methods
    /**@ignore */
    writeValue(value) {
        super.writeValue(value);
        this.onItemClick(value);
    }
    /** @ignore */
    onItemClick(starId) {
        this.internalValue = starId;
        for (let i = 0; i < this._starItems.length; ++i) {
            if (i < this.internalValue) {
                this._starItems[i].active = true;
            }
            else {
                this._starItems[i].active = false;
            }
        }
    }
    /** @ignore */
    getId(starId) {
        return 'starRatingItem' + starId;
    }
    /** @ignore */
    getText(starId) {
        if (this._customTexts) {
            return this._customTexts[starId - 1];
        }
        return starId.toString();
    }
    /** @ignore */
    getKey(isStarActive) {
        return isStarActive ? 'star' : 'star-o';
    }
    /** @ignore */
    getClasses(isStarActive) {
        const classes = [];
        isStarActive ? classes.push('starRatingItemActive') : classes.push('starRatingItemInactive');
        if (this.disabled) {
            classes.push('starRatingItemDisabled');
        }
        if (this.readonly) {
            classes.push('starRatingItemReadonly');
        }
        if (this._customClass) {
            classes.push(this._customClass);
        }
        return classes;
    }
    //#endregion
    //#region Properties
    /** @ignore */
    get starItems() {
        return this._starItems;
    }
    /** @ignore */
    set starItems(value) {
        this._starItems = value;
    }
    /**
     * Permite obtener el número de estrellas que hay en el Star Rating. Por defecto son 5.
     */
    get stars() {
        return this._stars;
    }
    /**
     * Permite definir el número de estrellas que hay en el Star Rating. Por defecto son 5.
     *
     * @param value El número de estrellas que hay en el Star Rating.
     */
    set stars(value) {
        this._stars = value;
        this._starItems = [];
        for (let i = 0; i < value; ++i) {
            this._starItems.push({ id: i + 1, active: false });
        }
        this.onItemClick(this.internalValue);
    }
    /**
     * Permite obtener la clase custom decoradora de las estrellas. Si se desea editar el tamaño de las estrellas, se debe editar
     * el tag 'i' dentro de la clase custom con la propiedad 'font-size'.
     */
    get customClass() {
        return this._customClass;
    }
    /**
     * Permite definir la clase custom decoradora de las estrellas. Si se desea editar el tamaño de las estrellas, se debe editar
     * el tag 'i' dentro de la clase custom con la propiedad 'font-size'.
     *
     * @param value La clase custom decoradora de las estrellas.
     */
    set customClass(value) {
        this._customClass = value;
    }
    /**
     * Permite obtener la lista de textos personalizables para cada una de las estrellas. El primer elemento del Array corresponde
     * a la primera estrella, y el último elemento corresponde a la última estrella. Debe haber tantos elementos en el Array como
     * estrellas en el Input.
     */
    get customTexts() {
        return this._customTexts;
    }
    /**
     * Permite definir la lista de textos personalizables para cada una de las estrellas. El primer elemento del Array corresponde
     * a la primera estrella, y el último elemento corresponde a la última estrella. Debe haber tantos elementos en el Array como
     * estrellas en el Input.
     *
     * @param value La lista de textos personalizables para cada una de las estrellas.
     */
    set customTexts(value) {
        this._customTexts = value;
    }
    /**
     * Permite consultar si el control está readonly o no
     */
    get readonly() {
        return this._readonly;
    }
    /**
     * Permite activar o desactivar el estado de readonly del control
     *
     * @param value Valor que activa o desactiva el estado del control
     */
    set readonly(value) {
        this._readonly = value;
    }
}
StarRatingComponent.ɵfac = /*@__PURE__*/ function () { let ɵStarRatingComponent_BaseFactory; return function StarRatingComponent_Factory(t) { return (ɵStarRatingComponent_BaseFactory || (ɵStarRatingComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(StarRatingComponent)))(t || StarRatingComponent); }; }();
StarRatingComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: StarRatingComponent, selectors: [["ngwk-star-rating"]], inputs: { stars: "stars", customClass: "customClass", customTexts: "customTexts", readonly: "readonly" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => StarRatingComponent),
                multi: true
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 1, consts: [[1, "horizontalLayout", "fluidItems"], ["class", "starRatingItem", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "starRatingItem", 3, "ngClass"], [3, "id", "key", "click"], [1, "alignMiddle", "starRatingItemText"]], template: function StarRatingComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, StarRatingComponent_div_1_Template, 4, 4, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.starItems);
    } }, directives: [ɵngcc4.NgForOf, ɵngcc4.NgClass, ɵngcc5.IconComponent], styles: ["[_nghost-%COMP%]     .fluidItems{display:flex;flex-wrap:wrap}[_nghost-%COMP%]     .starRatingItem{cursor:pointer;margin:0 10px 10px 0}[_nghost-%COMP%]     .starRatingItem i{font-size:30px}[_nghost-%COMP%]     .starRatingItemActive i{color:#f7c14b}[_nghost-%COMP%]     .starRatingItemActive i:hover{color:#f5b01a}[_nghost-%COMP%]     .starRatingItemInactive i{color:#e4e4e4}[_nghost-%COMP%]     .starRatingItemInactive i:hover{color:#cbcbcb}[_nghost-%COMP%]     .starRatingItemDisabled{cursor:default;pointer-events:none;opacity:.5}[_nghost-%COMP%]     .starRatingItemReadonly{cursor:default;pointer-events:none}[_nghost-%COMP%]     .starRatingItemText{cursor:default;font-size:11px;color:#acacac}"] });
StarRatingComponent.propDecorators = {
    stars: [{ type: Input }],
    customClass: [{ type: Input }],
    customTexts: [{ type: Input }],
    readonly: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StarRatingComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-star-rating',
                template: "<div class=\"horizontalLayout fluidItems\">\r\n    <div *ngFor=\"let star of starItems\" class=\"starRatingItem\" [ngClass]=\"getClasses(star.active)\">\r\n        <ucc-icon\r\n            [id]=\"getId(star.id)\"\r\n            [key]=\"getKey(star.active)\"\r\n            (click)=\"onItemClick(star.id)\">\r\n        </ucc-icon>\r\n        <div class=\"alignMiddle starRatingItemText\">{{ getText(star.id) }}</div>\r\n    </div>\r\n</div>\r\n\r\n<!-- <div class=\"horizontalLayout fluidItems\">\r\n    <ucc-icon\r\n        *ngFor=\"let star of starItems\"\r\n        class=\"starRatingItem\"\r\n        [id]=\"getId(star.id)\"\r\n        [key]=\"getKey(star.active)\"\r\n        [ngClass]=\"getClasses(star.active)\"\r\n        (click)=\"onItemClick(star.id)\">\r\n    </ucc-icon>\r\n</div> -->",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => StarRatingComponent),
                        multi: true
                    },
                ],
                styles: [":host ::ng-deep .fluidItems{display:flex;flex-wrap:wrap}:host ::ng-deep .starRatingItem{cursor:pointer;margin:0 10px 10px 0}:host ::ng-deep .starRatingItem i{font-size:30px}:host ::ng-deep .starRatingItemActive i{color:#f7c14b}:host ::ng-deep .starRatingItemActive i:hover{color:#f5b01a}:host ::ng-deep .starRatingItemInactive i{color:#e4e4e4}:host ::ng-deep .starRatingItemInactive i:hover{color:#cbcbcb}:host ::ng-deep .starRatingItemDisabled{cursor:default;pointer-events:none;opacity:.5}:host ::ng-deep .starRatingItemReadonly{cursor:default;pointer-events:none}:host ::ng-deep .starRatingItemText{cursor:default;font-size:11px;color:#acacac}\n"]
            }]
    }], null, { stars: [{
            type: Input
        }], customClass: [{
            type: Input
        }], customTexts: [{
            type: Input
        }], readonly: [{
            type: Input
        }] }); })();

class StarRatingModule {
}
StarRatingModule.ɵfac = function StarRatingModule_Factory(t) { return new (t || StarRatingModule)(); };
StarRatingModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: StarRatingModule });
StarRatingModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            FormsModule,
            CommonModule,
            IconModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StarRatingModule, [{
        type: NgModule,
        args: [{
                imports: [
                    FormsModule,
                    CommonModule,
                    IconModule
                ],
                declarations: [
                    StarRatingComponent
                ],
                exports: [
                    StarRatingComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(StarRatingModule, { declarations: function () { return [StarRatingComponent]; }, imports: function () { return [FormsModule,
        CommonModule,
        IconModule]; }, exports: function () { return [StarRatingComponent]; } }); })();

class InputsModule {
}
InputsModule.ɵfac = function InputsModule_Factory(t) { return new (t || InputsModule)(); };
InputsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: InputsModule });
InputsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            TextBoxModule,
            NumericBoxModule,
            FloatingLabelModule,
            DropDownListModule,
            DatePickerModule,
            TextareaBoxModule,
            AutocompleteModule,
            SwitchModule,
            PasswordBoxModule,
            ValidatorsModule,
            UploadFileModule,
            FormValidationListModule,
            CheckboxModule,
            SearchBoxModule,
            TagsModule,
            PeriodicitySelectorModule,
            MultiDropDownListModule,
            StarRatingModule
        ], TextBoxModule, NumericBoxModule, FloatingLabelModule, DropDownListModule, DatePickerModule, TextareaBoxModule, AutocompleteModule, SwitchModule, PasswordBoxModule, ValidatorsModule, UploadFileModule, FormValidationListModule, CheckboxModule, SearchBoxModule, TagsModule, PeriodicitySelectorModule, MultiDropDownListModule, StarRatingModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    TextBoxModule,
                    NumericBoxModule,
                    FloatingLabelModule,
                    DropDownListModule,
                    DatePickerModule,
                    TextareaBoxModule,
                    AutocompleteModule,
                    SwitchModule,
                    PasswordBoxModule,
                    ValidatorsModule,
                    UploadFileModule,
                    FormValidationListModule,
                    CheckboxModule,
                    SearchBoxModule,
                    TagsModule,
                    PeriodicitySelectorModule,
                    MultiDropDownListModule,
                    StarRatingModule
                ],
                exports: [
                    TextBoxModule,
                    NumericBoxModule,
                    FloatingLabelModule,
                    DropDownListModule,
                    DatePickerModule,
                    TextareaBoxModule,
                    AutocompleteModule,
                    SwitchModule,
                    PasswordBoxModule,
                    ValidatorsModule,
                    UploadFileModule,
                    FormValidationListModule,
                    CheckboxModule,
                    SearchBoxModule,
                    TagsModule,
                    PeriodicitySelectorModule,
                    MultiDropDownListModule,
                    StarRatingModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(InputsModule, { imports: [TextBoxModule, NumericBoxModule, FloatingLabelModule, DropDownListModule, DatePickerModule, TextareaBoxModule, AutocompleteModule, SwitchModule, PasswordBoxModule, ValidatorsModule, UploadFileModule, FormValidationListModule, CheckboxModule, SearchBoxModule, TagsModule, PeriodicitySelectorModule, MultiDropDownListModule, StarRatingModule], exports: [TextBoxModule, NumericBoxModule, FloatingLabelModule, DropDownListModule, DatePickerModule, TextareaBoxModule, AutocompleteModule, SwitchModule, PasswordBoxModule, ValidatorsModule, UploadFileModule, FormValidationListModule, CheckboxModule, SearchBoxModule, TagsModule, PeriodicitySelectorModule, MultiDropDownListModule, StarRatingModule] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { AsyncValidator, AutocompleteComponent, AutocompleteModule, BaseInput, CheckboxComponent, CheckboxModule, DatePickerComponent, DatePickerModule, DropDownListComponent, DropDownListModule, FloatingLabelComponent, FloatingLabelModule, FocusableInput, FormValidationListComponent, FormValidationListModule, FormValidationListService, InputsModule, MultiDropDownListComponent, MultiDropDownListModule, NgwkFormValidationListDirective, NumericBoxComponent, NumericBoxModule, PasswordBoxComponent, PasswordBoxModule, PeriodicitySelectorComponent, PeriodicitySelectorItemComponent, PeriodicitySelectorModule, RangeDateValidator, ReadonlyFocusableInput, RegexpValidator, SearchBoxComponent, SearchBoxModule, StarRatingComponent, StarRatingModule, SwitchComponent, SwitchModule, TagsComponent, TagsModule, TextBoxComponent, TextBoxModule, TextareaAutosizeDirective, TextareaBoxComponent, TextareaBoxModule, UploadFileComponent, UploadFileModule, ValidatorsModule };

